"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.set");
require("core-js/modules/es6.number.is-finite");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.reflect.set");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.reflect.get");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _inherits2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/createSuper.js"));
var _wrapNativeSuper2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/wrapNativeSuper.js"));
var _slicedToArray2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/slicedToArray.js"));
require("core-js/modules/es6.number.is-nan");
require("core-js/modules/es7.object.entries");
require("core-js/modules/es6.map");
var _classCallCheck2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/createClass.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.regexp.to-string");
var _toConsumableArray2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _typeof2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/typeof.js"));
var MeetNow = function (exports) {
  'use strict';

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  /**
   * Helpers.
   */

  var s = 1000;
  var m = s * 60;
  var h = m * 60;
  var d = h * 24;
  var w = d * 7;
  var y = d * 365.25;

  /**
   * Parse or format the given `val`.
   *
   * Options:
   *
   *  - `long` verbose formatting [false]
   *
   * @param {String|Number} val
   * @param {Object} [options]
   * @throws {Error} throw an error if val is not a non-empty string or a number
   * @return {String|Number}
   * @api public
   */

  var ms = function ms(val, options) {
    options = options || {};
    var type = (0, _typeof2.default)(val);
    if (type === 'string' && val.length > 0) {
      return parse(val);
    } else if (type === 'number' && isFinite(val)) {
      return options.long ? fmtLong(val) : fmtShort(val);
    }
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
  };

  /**
   * Parse the given `str` and return milliseconds.
   *
   * @param {String} str
   * @return {Number}
   * @api private
   */

  function parse(str) {
    str = String(str);
    if (str.length > 100) {
      return;
    }
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) {
      return;
    }
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch (type) {
      case 'years':
      case 'year':
      case 'yrs':
      case 'yr':
      case 'y':
        return n * y;
      case 'weeks':
      case 'week':
      case 'w':
        return n * w;
      case 'days':
      case 'day':
      case 'd':
        return n * d;
      case 'hours':
      case 'hour':
      case 'hrs':
      case 'hr':
      case 'h':
        return n * h;
      case 'minutes':
      case 'minute':
      case 'mins':
      case 'min':
      case 'm':
        return n * m;
      case 'seconds':
      case 'second':
      case 'secs':
      case 'sec':
      case 's':
        return n * s;
      case 'milliseconds':
      case 'millisecond':
      case 'msecs':
      case 'msec':
      case 'ms':
        return n;
      default:
        return undefined;
    }
  }

  /**
   * Short format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) {
      return Math.round(ms / d) + 'd';
    }
    if (msAbs >= h) {
      return Math.round(ms / h) + 'h';
    }
    if (msAbs >= m) {
      return Math.round(ms / m) + 'm';
    }
    if (msAbs >= s) {
      return Math.round(ms / s) + 's';
    }
    return ms + 'ms';
  }

  /**
   * Long format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) {
      return plural(ms, msAbs, d, 'day');
    }
    if (msAbs >= h) {
      return plural(ms, msAbs, h, 'hour');
    }
    if (msAbs >= m) {
      return plural(ms, msAbs, m, 'minute');
    }
    if (msAbs >= s) {
      return plural(ms, msAbs, s, 'second');
    }
    return ms + ' ms';
  }

  /**
   * Pluralization helper.
   */

  function plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
  }

  /**
   * This is the common logic for both the Node.js and web browser
   * implementations of `debug()`.
   */

  function setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = ms;
    Object.keys(env).forEach(function (key) {
      createDebug[key] = env[key];
    });

    /**
    * Active `debug` instances.
    */
    createDebug.instances = [];

    /**
    * The currently active debug mode names, and names to skip.
    */

    createDebug.names = [];
    createDebug.skips = [];

    /**
    * Map of special "%n" handling functions, for the debug "format" argument.
    *
    * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
    */
    createDebug.formatters = {};

    /**
    * Selects a color for a debug namespace
    * @param {String} namespace The namespace string for the for the debug instance to be colored
    * @return {Number|String} An ANSI color code for the given namespace
    * @api private
    */
    function selectColor(namespace) {
      var hash = 0;
      for (var i = 0; i < namespace.length; i++) {
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }

      return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;

    /**
    * Create a debugger with the given `namespace`.
    *
    * @param {String} namespace
    * @return {Function}
    * @api public
    */
    function createDebug(namespace) {
      var prevTime;
      function debug() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        // Disabled?
        if (!debug.enabled) {
          return;
        }
        var self = debug;

        // Set `diff` timestamp
        var curr = Number(new Date());
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        args[0] = createDebug.coerce(args[0]);
        if (typeof args[0] !== 'string') {
          // Anything else let's inspect with %O
          args.unshift('%O');
        }

        // Apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
          // If we encounter an escaped % then don't increase the array index
          if (match === '%%') {
            return match;
          }
          index++;
          var formatter = createDebug.formatters[format];
          if (typeof formatter === 'function') {
            var val = args[index];
            match = formatter.call(self, val);

            // Now we need to remove `args[index]` since it's inlined in the `format`
            args.splice(index, 1);
            index--;
          }
          return match;
        });

        // Apply env-specific formatting (colors, etc.)
        createDebug.formatArgs.call(self, args);
        var logFn = self.log || createDebug.log;
        logFn.apply(self, args);
      }
      debug.namespace = namespace;
      debug.enabled = createDebug.enabled(namespace);
      debug.useColors = createDebug.useColors();
      debug.color = selectColor(namespace);
      debug.destroy = destroy;
      debug.extend = extend;
      // Debug.formatArgs = formatArgs;
      // debug.rawLog = rawLog;

      // env-specific initialization logic for debug instances
      if (typeof createDebug.init === 'function') {
        createDebug.init(debug);
      }
      createDebug.instances.push(debug);
      return debug;
    }
    function destroy() {
      var index = createDebug.instances.indexOf(this);
      if (index !== -1) {
        createDebug.instances.splice(index, 1);
        return true;
      }
      return false;
    }
    function extend(namespace, delimiter) {
      var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
      newDebug.log = this.log;
      return newDebug;
    }

    /**
    * Enables a debug mode by namespaces. This can include modes
    * separated by a colon and wildcards.
    *
    * @param {String} namespaces
    * @api public
    */
    function enable(namespaces) {
      createDebug.save(namespaces);
      createDebug.names = [];
      createDebug.skips = [];
      var i;
      var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
      var len = split.length;
      for (i = 0; i < len; i++) {
        if (!split[i]) {
          // ignore empty strings
          continue;
        }
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') {
          createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        } else {
          createDebug.names.push(new RegExp('^' + namespaces + '$'));
        }
      }
      for (i = 0; i < createDebug.instances.length; i++) {
        var instance = createDebug.instances[i];
        instance.enabled = createDebug.enabled(instance.namespace);
      }
    }

    /**
    * Disable debug output.
    *
    * @return {String} namespaces
    * @api public
    */
    function disable() {
      var namespaces = [].concat((0, _toConsumableArray2.default)(createDebug.names.map(toNamespace)), (0, _toConsumableArray2.default)(createDebug.skips.map(toNamespace).map(function (namespace) {
        return '-' + namespace;
      }))).join(',');
      createDebug.enable('');
      return namespaces;
    }

    /**
    * Returns true if the given mode name is enabled, false otherwise.
    *
    * @param {String} name
    * @return {Boolean}
    * @api public
    */
    function enabled(name) {
      if (name[name.length - 1] === '*') {
        return true;
      }
      var i;
      var len;
      for (i = 0, len = createDebug.skips.length; i < len; i++) {
        if (createDebug.skips[i].test(name)) {
          return false;
        }
      }
      for (i = 0, len = createDebug.names.length; i < len; i++) {
        if (createDebug.names[i].test(name)) {
          return true;
        }
      }
      return false;
    }

    /**
    * Convert regexp to namespace
    *
    * @param {RegExp} regxep
    * @return {String} namespace
    * @api private
    */
    function toNamespace(regexp) {
      return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
    }

    /**
    * Coerce `val`.
    *
    * @param {Mixed} val
    * @return {Mixed}
    * @api private
    */
    function coerce(val) {
      if (val instanceof Error) {
        return val.stack || val.message;
      }
      return val;
    }
    createDebug.enable(createDebug.load());
    return createDebug;
  }
  var common = setup;
  var browser = createCommonjsModule(function (module, exports) {
    /* eslint-env browser */

    /**
     * This is the web browser implementation of `debug()`.
     */

    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = localstorage();

    /**
     * Colors.
     */

    exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

    /**
     * Currently only WebKit-based Web Inspectors, Firefox >= v31,
     * and the Firebug extension (any Firefox version) are known
     * to support "%c" CSS customizations.
     *
     * TODO: add a `localStorage` variable to explicitly enable/disable colors
     */

    // eslint-disable-next-line complexity
    function useColors() {
      // NB: In an Electron preload script, document will be defined but not fully
      // initialized. Since we know we're in Chrome, we'll just detect this case
      // explicitly
      if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
        return true;
      }

      // Internet Explorer and Edge do not support colors.
      if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
        return false;
      }

      // Is webkit? http://stackoverflow.com/a/16459606/376773
      // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
      return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
      // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
      // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
      // Double check webkit in userAgent just in case we are in a worker
      typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }

    /**
     * Colorize log arguments if enabled.
     *
     * @api public
     */

    function formatArgs(args) {
      args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
      if (!this.useColors) {
        return;
      }
      var c = 'color: ' + this.color;
      args.splice(1, 0, c, 'color: inherit');

      // The final "%c" is somewhat tricky, because there could be other
      // arguments passed either before or after the %c, so we need to
      // figure out the correct index to insert the CSS into
      var index = 0;
      var lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, function (match) {
        if (match === '%%') {
          return;
        }
        index++;
        if (match === '%c') {
          // We only are interested in the *last* %c
          // (the user may have provided their own)
          lastC = index;
        }
      });
      args.splice(lastC, 0, c);
    }

    /**
     * Invokes `console.log()` when available.
     * No-op when `console.log` is not a "function".
     *
     * @api public
     */
    function log() {
      var _console;
      // This hackery is required for IE8/9, where
      // the `console.log` function doesn't have 'apply'
      return (typeof console === "undefined" ? "undefined" : (0, _typeof2.default)(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
    }

    /**
     * Save `namespaces`.
     *
     * @param {String} namespaces
     * @api private
     */
    function save(namespaces) {
      try {
        if (namespaces) {
          exports.storage.setItem('debug', namespaces);
        } else {
          exports.storage.removeItem('debug');
        }
      } catch (error) {
        // Swallow
        // XXX (@Qix-) should we be logging these?
      }
    }

    /**
     * Load `namespaces`.
     *
     * @return {String} returns the previously persisted debug modes
     * @api private
     */
    function load() {
      var r;
      try {
        r = exports.storage.getItem('debug');
      } catch (error) {
        // Swallow
        // XXX (@Qix-) should we be logging these?
      }

      // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
      if (!r && typeof process !== 'undefined' && 'env' in process) {
        r = process.env.DEBUG;
      }
      return r;
    }

    /**
     * Localstorage attempts to return the localstorage.
     *
     * This is necessary because safari throws
     * when a user disables cookies/localstorage
     * and you attempt to access it.
     *
     * @return {LocalStorage}
     * @api private
     */

    function localstorage() {
      try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
      } catch (error) {
        // Swallow
        // XXX (@Qix-) should we be logging these?
      }
    }
    module.exports = common(exports);
    var formatters = module.exports.formatters;

    /**
     * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
     */

    formatters.j = function (v) {
      try {
        return JSON.stringify(v);
      } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
      }
    };
  });
  var browser_1 = browser.log;
  var browser_2 = browser.formatArgs;
  var browser_3 = browser.save;
  var browser_4 = browser.load;
  var browser_5 = browser.useColors;
  var browser_6 = browser.storage;
  var browser_7 = browser.colors;
  var bind = function bind(fn, thisArg) {
    return function wrap() {
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }
      return fn.apply(thisArg, args);
    };
  };

  /*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */

  var isBuffer = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
  };

  /*global toString:true*/

  // utils is a library of generic helper functions non-specific to axios

  var toString = Object.prototype.toString;

  /**
   * Determine if a value is an Array
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Array, otherwise false
   */
  function isArray(val) {
    return toString.call(val) === '[object Array]';
  }

  /**
   * Determine if a value is an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an ArrayBuffer, otherwise false
   */
  function isArrayBuffer(val) {
    return toString.call(val) === '[object ArrayBuffer]';
  }

  /**
   * Determine if a value is a FormData
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an FormData, otherwise false
   */
  function isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
  }

  /**
   * Determine if a value is a view on an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
   */
  function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    }
    return result;
  }

  /**
   * Determine if a value is a String
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a String, otherwise false
   */
  function isString(val) {
    return typeof val === 'string';
  }

  /**
   * Determine if a value is a Number
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Number, otherwise false
   */
  function isNumber(val) {
    return typeof val === 'number';
  }

  /**
   * Determine if a value is undefined
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if the value is undefined, otherwise false
   */
  function isUndefined(val) {
    return typeof val === 'undefined';
  }

  /**
   * Determine if a value is an Object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Object, otherwise false
   */
  function isObject(val) {
    return val !== null && (0, _typeof2.default)(val) === 'object';
  }

  /**
   * Determine if a value is a Date
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Date, otherwise false
   */
  function isDate(val) {
    return toString.call(val) === '[object Date]';
  }

  /**
   * Determine if a value is a File
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a File, otherwise false
   */
  function isFile(val) {
    return toString.call(val) === '[object File]';
  }

  /**
   * Determine if a value is a Blob
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Blob, otherwise false
   */
  function isBlob(val) {
    return toString.call(val) === '[object Blob]';
  }

  /**
   * Determine if a value is a Function
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Function, otherwise false
   */
  function isFunction(val) {
    return toString.call(val) === '[object Function]';
  }

  /**
   * Determine if a value is a Stream
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Stream, otherwise false
   */
  function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
  }

  /**
   * Determine if a value is a URLSearchParams object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a URLSearchParams object, otherwise false
   */
  function isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
  }

  /**
   * Trim excess whitespace off the beginning and end of a string
   *
   * @param {String} str The String to trim
   * @returns {String} The String freed of excess whitespace
   */
  function trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
  }

  /**
   * Determine if we're running in a standard browser environment
   *
   * This allows axios to run in a web worker, and react-native.
   * Both environments support XMLHttpRequest, but not fully standard globals.
   *
   * web workers:
   *  typeof window -> undefined
   *  typeof document -> undefined
   *
   * react-native:
   *  navigator.product -> 'ReactNative'
   * nativescript
   *  navigator.product -> 'NativeScript' or 'NS'
   */
  function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
      return false;
    }
    return typeof window !== 'undefined' && typeof document !== 'undefined';
  }

  /**
   * Iterate over an Array or an Object invoking a function for each item.
   *
   * If `obj` is an Array callback will be called passing
   * the value, index, and complete array for each item.
   *
   * If 'obj' is an Object callback will be called passing
   * the value, key, and complete object for each property.
   *
   * @param {Object|Array} obj The object to iterate
   * @param {Function} fn The callback to invoke for each item
   */
  function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
      return;
    }

    // Force an array if not already something iterable
    if ((0, _typeof2.default)(obj) !== 'object') {
      /*eslint no-param-reassign:0*/
      obj = [obj];
    }
    if (isArray(obj)) {
      // Iterate over array values
      for (var i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      // Iterate over object keys
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          fn.call(null, obj[key], key, obj);
        }
      }
    }
  }

  /**
   * Accepts varargs expecting each argument to be an object, then
   * immutably merges the properties of each object and returns result.
   *
   * When multiple objects contain the same key the later object in
   * the arguments list will take precedence.
   *
   * Example:
   *
   * ```js
   * var result = merge({foo: 123}, {foo: 456});
   * console.log(result.foo); // outputs 456
   * ```
   *
   * @param {Object} obj1 Object to merge
   * @returns {Object} Result of all merge properties
   */
  function merge( /* obj1, obj2, obj3, ... */
  ) {
    var result = {};
    function assignValue(val, key) {
      if ((0, _typeof2.default)(result[key]) === 'object' && (0, _typeof2.default)(val) === 'object') {
        result[key] = merge(result[key], val);
      } else {
        result[key] = val;
      }
    }
    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }
    return result;
  }

  /**
   * Function equal to merge with the difference being that no reference
   * to original objects is kept.
   *
   * @see merge
   * @param {Object} obj1 Object to merge
   * @returns {Object} Result of all merge properties
   */
  function deepMerge( /* obj1, obj2, obj3, ... */
  ) {
    var result = {};
    function assignValue(val, key) {
      if ((0, _typeof2.default)(result[key]) === 'object' && (0, _typeof2.default)(val) === 'object') {
        result[key] = deepMerge(result[key], val);
      } else if ((0, _typeof2.default)(val) === 'object') {
        result[key] = deepMerge({}, val);
      } else {
        result[key] = val;
      }
    }
    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }
    return result;
  }

  /**
   * Extends object a by mutably adding to it the properties of object b.
   *
   * @param {Object} a The object to be extended
   * @param {Object} b The object to copy properties from
   * @param {Object} thisArg The object to bind function to
   * @return {Object} The resulting value of object a
   */
  function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
      if (thisArg && typeof val === 'function') {
        a[key] = bind(val, thisArg);
      } else {
        a[key] = val;
      }
    });
    return a;
  }
  var utils = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    deepMerge: deepMerge,
    extend: extend,
    trim: trim
  };
  function encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
  }

  /**
   * Build a URL by appending params to the end
   *
   * @param {string} url The base of the url (e.g., http://www.google.com)
   * @param {object} [params] The params to be appended
   * @returns {string} The formatted url
   */
  var buildURL = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/
    if (!params) {
      return url;
    }
    var serializedParams;
    if (paramsSerializer) {
      serializedParams = paramsSerializer(params);
    } else if (utils.isURLSearchParams(params)) {
      serializedParams = params.toString();
    } else {
      var parts = [];
      utils.forEach(params, function serialize(val, key) {
        if (val === null || typeof val === 'undefined') {
          return;
        }
        if (utils.isArray(val)) {
          key = key + '[]';
        } else {
          val = [val];
        }
        utils.forEach(val, function parseValue(v) {
          if (utils.isDate(v)) {
            v = v.toISOString();
          } else if (utils.isObject(v)) {
            v = JSON.stringify(v);
          }
          parts.push(encode(key) + '=' + encode(v));
        });
      });
      serializedParams = parts.join('&');
    }
    if (serializedParams) {
      var hashmarkIndex = url.indexOf('#');
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }
      url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
  };
  function InterceptorManager() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
      fulfilled: fulfilled,
      rejected: rejected
    });
    return this.handlers.length - 1;
  };

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   */
  InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  };

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   */
  InterceptorManager.prototype.forEach = function forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  };
  var InterceptorManager_1 = InterceptorManager;

  /**
   * Transform the data for a request or a response
   *
   * @param {Object|String} data The data to be transformed
   * @param {Array} headers The headers for the request or response
   * @param {Array|Function} fns A single function or Array of functions
   * @returns {*} The resulting transformed data
   */
  var transformData = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/
    utils.forEach(fns, function transform(fn) {
      data = fn(data, headers);
    });
    return data;
  };
  var isCancel = function isCancel(value) {
    return !!(value && value.__CANCEL__);
  };
  var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
    utils.forEach(headers, function processHeader(value, name) {
      if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
        headers[normalizedName] = value;
        delete headers[name];
      }
    });
  };

  /**
   * Update an Error with the specified config, error code, and response.
   *
   * @param {Error} error The error to update.
   * @param {Object} config The config.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   * @returns {Error} The error.
   */
  var enhanceError = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) {
      error.code = code;
    }
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function () {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    };
    return error;
  };

  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {Object} config The config.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   * @returns {Error} The created error.
   */
  var createError = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return enhanceError(error, config, code, request, response);
  };

  /**
   * Resolve or reject a Promise based on response status.
   *
   * @param {Function} resolve A function that resolves the promise.
   * @param {Function} reject A function that rejects the promise.
   * @param {object} response The response.
   */
  var settle = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) {
      resolve(response);
    } else {
      reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
    }
  };

  // Headers whose duplicates are ignored by node
  // c.f. https://nodejs.org/api/http.html#http_message_headers
  var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

  /**
   * Parse headers into an object
   *
   * ```
   * Date: Wed, 27 Aug 2014 08:58:49 GMT
   * Content-Type: application/json
   * Connection: keep-alive
   * Transfer-Encoding: chunked
   * ```
   *
   * @param {String} headers Headers needing to be parsed
   * @returns {Object} Headers parsed into an object
   */
  var parseHeaders = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) {
      return parsed;
    }
    utils.forEach(headers.split('\n'), function parser(line) {
      i = line.indexOf(':');
      key = utils.trim(line.substr(0, i)).toLowerCase();
      val = utils.trim(line.substr(i + 1));
      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }
        if (key === 'set-cookie') {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
      }
    });
    return parsed;
  };
  var isURLSameOrigin = utils.isStandardBrowserEnv() ?
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;
      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }
      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
      };
    }
    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }() :
  // Non standard browser envs (web workers, react-native) lack needed support.
  function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  }();
  var cookies = utils.isStandardBrowserEnv() ?
  // Standard browser envs support document.cookie
  function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));
        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }
        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }
        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }
        if (secure === true) {
          cookie.push('secure');
        }
        document.cookie = cookie.join('; ');
      },
      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
      },
      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  }() :
  // Non standard browser env (web workers, react-native) lack needed support.
  function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }();
  var xhr = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
      var requestData = config.data;
      var requestHeaders = config.headers;
      if (utils.isFormData(requestData)) {
        delete requestHeaders['Content-Type']; // Let the browser set it
      }

      var request = new XMLHttpRequest();

      // HTTP basic authentication
      if (config.auth) {
        var username = config.auth.username || '';
        var password = config.auth.password || '';
        requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
      }
      request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

      // Set the request timeout in MS
      request.timeout = config.timeout;

      // Listen for ready state
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }

        // Prepare the response
        var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
        var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
        var response = {
          data: responseData,
          status: request.status,
          statusText: request.statusText,
          headers: responseHeaders,
          config: config,
          request: request
        };
        settle(resolve, reject, response);

        // Clean up request
        request = null;
      };

      // Handle browser request cancellation (as opposed to a manual cancellation)
      request.onabort = function handleAbort() {
        if (!request) {
          return;
        }
        reject(createError('Request aborted', config, 'ECONNABORTED', request));

        // Clean up request
        request = null;
      };

      // Handle low level network errors
      request.onerror = function handleError() {
        // Real errors are hidden from us by the browser
        // onerror should only fire if it's a network error
        reject(createError('Network Error', config, null, request));

        // Clean up request
        request = null;
      };

      // Handle timeout
      request.ontimeout = function handleTimeout() {
        reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

        // Clean up request
        request = null;
      };

      // Add xsrf header
      // This is only done if running in a standard browser environment.
      // Specifically not if we're in a web worker, or react-native.
      if (utils.isStandardBrowserEnv()) {
        var cookies$1 = cookies;

        // Add xsrf header
        var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies$1.read(config.xsrfCookieName) : undefined;
        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }

      // Add headers to the request
      if ('setRequestHeader' in request) {
        utils.forEach(requestHeaders, function setRequestHeader(val, key) {
          if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
            // Remove Content-Type if data is undefined
            delete requestHeaders[key];
          } else {
            // Otherwise add header to the request
            request.setRequestHeader(key, val);
          }
        });
      }

      // Add withCredentials to request if needed
      if (config.withCredentials) {
        request.withCredentials = true;
      }

      // Add responseType to request if needed
      if (config.responseType) {
        try {
          request.responseType = config.responseType;
        } catch (e) {
          // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
          // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
          if (config.responseType !== 'json') {
            throw e;
          }
        }
      }

      // Handle progress if needed
      if (typeof config.onDownloadProgress === 'function') {
        request.addEventListener('progress', config.onDownloadProgress);
      }

      // Not all browsers support upload events
      if (typeof config.onUploadProgress === 'function' && request.upload) {
        request.upload.addEventListener('progress', config.onUploadProgress);
      }
      if (config.cancelToken) {
        // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
          if (!request) {
            return;
          }
          request.abort();
          reject(cancel);
          // Clean up request
          request = null;
        });
      }
      if (requestData === undefined) {
        requestData = null;
      }

      // Send the request
      request.send(requestData);
    });
  };
  var DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  function setContentTypeIfUnset(headers, value) {
    if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
      headers['Content-Type'] = value;
    }
  }
  function getDefaultAdapter() {
    var adapter;
    // Only Node.JS has a process variable that is of [[Class]] process
    if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
      // For node use HTTP adapter
      adapter = xhr;
    } else if (typeof XMLHttpRequest !== 'undefined') {
      // For browsers use XHR adapter
      adapter = xhr;
    }
    return adapter;
  }
  var defaults = {
    adapter: getDefaultAdapter(),
    transformRequest: [function transformRequest(data, headers) {
      normalizeHeaderName(headers, 'Accept');
      normalizeHeaderName(headers, 'Content-Type');
      if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
        return data;
      }
      if (utils.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils.isURLSearchParams(data)) {
        setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
        return data.toString();
      }
      if (utils.isObject(data)) {
        setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
        return JSON.stringify(data);
      }
      return data;
    }],
    transformResponse: [function transformResponse(data) {
      /*eslint no-param-reassign:0*/
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {/* Ignore */}
      }
      return data;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    }
  };
  defaults.headers = {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  };
  utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
    defaults.headers[method] = {};
  });
  utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
  });
  var defaults_1 = defaults;

  /**
   * Determines whether the specified URL is absolute
   *
   * @param {string} url The URL to test
   * @returns {boolean} True if the specified URL is absolute, otherwise false
   */
  var isAbsoluteURL = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
  };

  /**
   * Creates a new URL by combining the specified URLs
   *
   * @param {string} baseURL The base URL
   * @param {string} relativeURL The relative URL
   * @returns {string} The combined URL
   */
  var combineURLs = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
  };

  /**
   * Throws a `Cancel` if cancellation has been requested.
   */
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
  }

  /**
   * Dispatch a request to the server using the configured adapter.
   *
   * @param {object} config The config that is to be used for the request
   * @returns {Promise} The Promise to be fulfilled
   */
  var dispatchRequest = function dispatchRequest(config) {
    throwIfCancellationRequested(config);

    // Support baseURL config
    if (config.baseURL && !isAbsoluteURL(config.url)) {
      config.url = combineURLs(config.baseURL, config.url);
    }

    // Ensure headers exist
    config.headers = config.headers || {};

    // Transform request data
    config.data = transformData(config.data, config.headers, config.transformRequest);

    // Flatten headers
    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
    utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
      delete config.headers[method];
    });
    var adapter = config.adapter || defaults_1.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config);

      // Transform response data
      response.data = transformData(response.data, response.headers, config.transformResponse);
      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);

        // Transform response data
        if (reason && reason.response) {
          reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
        }
      }
      return Promise.reject(reason);
    });
  };

  /**
   * Config-specific merge-function which creates a new config-object
   * by merging two configuration objects together.
   *
   * @param {Object} config1
   * @param {Object} config2
   * @returns {Object} New object resulting from merging config2 to config1
   */
  var mergeConfig = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
      if (typeof config2[prop] !== 'undefined') {
        config[prop] = config2[prop];
      }
    });
    utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
      if (utils.isObject(config2[prop])) {
        config[prop] = utils.deepMerge(config1[prop], config2[prop]);
      } else if (typeof config2[prop] !== 'undefined') {
        config[prop] = config2[prop];
      } else if (utils.isObject(config1[prop])) {
        config[prop] = utils.deepMerge(config1[prop]);
      } else if (typeof config1[prop] !== 'undefined') {
        config[prop] = config1[prop];
      }
    });
    utils.forEach(['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'], function defaultToConfig2(prop) {
      if (typeof config2[prop] !== 'undefined') {
        config[prop] = config2[prop];
      } else if (typeof config1[prop] !== 'undefined') {
        config[prop] = config1[prop];
      }
    });
    return config;
  };

  /**
   * Create a new instance of Axios
   *
   * @param {Object} instanceConfig The default config for the instance
   */
  function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager_1(),
      response: new InterceptorManager_1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {Object} config The config specific for this request (merged with this.defaults)
   */
  Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
      config = arguments[1] || {};
      config.url = arguments[0];
    } else {
      config = config || {};
    }
    config = mergeConfig(this.defaults, config);
    config.method = config.method ? config.method.toLowerCase() : 'get';

    // Hook up interceptors middleware
    var chain = [dispatchRequest, undefined];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  };
  Axios.prototype.getUri = function getUri(config) {
    config = mergeConfig(this.defaults, config);
    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
  };

  // Provide aliases for supported request methods
  utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
    /*eslint func-names:0*/
    Axios.prototype[method] = function (url, config) {
      return this.request(utils.merge(config || {}, {
        method: method,
        url: url
      }));
    };
  });
  utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    /*eslint func-names:0*/
    Axios.prototype[method] = function (url, data, config) {
      return this.request(utils.merge(config || {}, {
        method: method,
        url: url,
        data: data
      }));
    };
  });
  var Axios_1 = Axios;

  /**
   * A `Cancel` is an object that is thrown when an operation is canceled.
   *
   * @class
   * @param {string=} message The message.
   */
  function Cancel(message) {
    this.message = message;
  }
  Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
  };
  Cancel.prototype.__CANCEL__ = true;
  var Cancel_1 = Cancel;

  /**
   * A `CancelToken` is an object that can be used to request cancellation of an operation.
   *
   * @class
   * @param {Function} executor The executor function.
   */
  function CancelToken(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }
      token.reason = new Cancel_1(message);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `Cancel` if cancellation has been requested.
   */
  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token: token,
      cancel: cancel
    };
  };
  var CancelToken_1 = CancelToken;

  /**
   * Syntactic sugar for invoking a function and expanding an array for arguments.
   *
   * Common use case would be to use `Function.prototype.apply`.
   *
   *  ```js
   *  function f(x, y, z) {}
   *  var args = [1, 2, 3];
   *  f.apply(null, args);
   *  ```
   *
   * With `spread` this example can be re-written.
   *
   *  ```js
   *  spread(function(x, y, z) {})([1, 2, 3]);
   *  ```
   *
   * @param {Function} callback
   * @returns {Function}
   */
  var spread = function spread(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };

  /**
   * Create an instance of Axios
   *
   * @param {Object} defaultConfig The default config for the instance
   * @return {Axios} A new instance of Axios
   */
  function createInstance(defaultConfig) {
    var context = new Axios_1(defaultConfig);
    var instance = bind(Axios_1.prototype.request, context);

    // Copy axios.prototype to instance
    utils.extend(instance, Axios_1.prototype, context);

    // Copy context to instance
    utils.extend(instance, context);
    return instance;
  }

  // Create the default instance to be exported
  var axios = createInstance(defaults_1);

  // Expose Axios class to allow class inheritance
  axios.Axios = Axios_1;

  // Factory for creating new instances
  axios.create = function create(instanceConfig) {
    return createInstance(mergeConfig(axios.defaults, instanceConfig));
  };

  // Expose Cancel & CancelToken
  axios.Cancel = Cancel_1;
  axios.CancelToken = CancelToken_1;
  axios.isCancel = isCancel;

  // Expose all/spread
  axios.all = function all(promises) {
    return Promise.all(promises);
  };
  axios.spread = spread;
  var axios_1 = axios;

  // Allow use of default import syntax in TypeScript
  var default_1 = axios;
  axios_1.default = default_1;
  var axios$1 = axios_1;
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  // btoa
  function btoa$1(input) {
    var str = String(input);
    // initialize result and counter
    var block;
    var charCode;
    var idx = 0;
    var map = chars;
    var output = '';
    /* eslint-disable no-cond-assign, no-bitwise, no-mixed-operators */
    for (;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
      charCode = str.charCodeAt(idx += 3 / 4);
      if (charCode > 0xFF) {
        throw new Error('"btoa" failed: The string to be encoded contains characters outside of the Latin1 range.');
      }
      block = block << 8 | charCode;
    }
    return output;
  }
  var PLATFORM;
  (function (PLATFORM) {
    PLATFORM[PLATFORM["kUnknown"] = 0] = "kUnknown";
    PLATFORM[PLATFORM["kWechat"] = 1] = "kWechat";
    PLATFORM[PLATFORM["kAlipay"] = 2] = "kAlipay";
    PLATFORM[PLATFORM["kBaidu"] = 3] = "kBaidu";
  })(PLATFORM || (PLATFORM = {}));
  function getPlatform() {
    switch (true) {
      case (typeof wx === "undefined" ? "undefined" : (0, _typeof2.default)(wx)) === 'object':
        return PLATFORM.kWechat;
      case (typeof swan === "undefined" ? "undefined" : (0, _typeof2.default)(swan)) === 'object':
        return PLATFORM.kBaidu;
      case (typeof my === "undefined" ? "undefined" : (0, _typeof2.default)(my)) === 'object':
        return PLATFORM.kAlipay;
      default:
        return PLATFORM.kUnknown;
    }
  }
  var platform = getPlatform();
  var delegate = platform === PLATFORM.kWechat ? wx.request.bind(wx) : platform === PLATFORM.kAlipay ? (my.request || my.httpRequest).bind(my) : platform === PLATFORM.kBaidu ? swan.request.bind(swan) : undefined;
  function createRequestDelegate() {
    var task;
    return {
      send: function send(options) {
        if (!delegate) {
          return;
        }
        task = delegate(options);
      },
      abort: function abort() {
        task && task.abort();
      }
    };
  }
  function createRequest(config) {
    var timer;
    var timeout;
    var onabort;
    var onerror;
    var ontimeout;
    var onsuccess;
    var delegate = createRequestDelegate();
    return {
      send: function send(options) {
        delegate.send(Object.spread({}, options, {
          success: function success(response) {
            // normalize data
            var headers = response.header || response.headers;
            var status = response.statusCode || response.status || 200;
            var statusText = status === 200 ? 'OK' : status === 400 ? 'Bad Request' : '';
            onsuccess && onsuccess({
              data: response.data,
              status: status,
              statusText: statusText,
              headers: headers,
              config: config,
              request: options
            });
          },
          fail: function fail(data) {
            var isAbort = false;
            var isTimeout = false;
            // error or timeout
            switch (platform) {
              case PLATFORM.kWechat:
                if (data.errMsg.indexOf('request:fail abort') !== -1) {
                  isAbort = true;
                } else if (data.errMsg.indexOf('timeout') !== -1) {
                  isTimeout = true;
                }
                break;
              case PLATFORM.kAlipay:
                // https://docs.alipay.com/mini/api/network
                if ([14, 19].includes(data.error)) {
                  isAbort = true;
                } else if ([13].includes(data.error)) {
                  isTimeout = true;
                }
                break;
            }
            var error = isAbort ? createError('Request aborted', config, 'ECONNABORTED', '') : isTimeout ? createError('Request Timeout', config, 'ECONNABORTED', '') : createError('Network Error', config, null, '');
            if (isAbort) {
              onabort && onabort(error);
            }
            if (isTimeout) {
              ontimeout && ontimeout(error);
            }
            onerror && onerror(error);
          },
          complete: function complete() {
            if (timer) {
              clearTimeout(timer);
              timer = undefined;
            }
          }
        }));
        if (timeout) {
          timer = setTimeout(function () {
            ontimeout && ontimeout(createError("timeout of ".concat(config.timeout || 0, "ms exceeded"), config, 'ECONNABORTED', ''));
            timer = undefined;
          }, timeout);
        }
      },
      abort: function abort() {
        delegate.abort();
      },
      set timeout(val) {
        timeout = val;
      },
      set onabort(val) {
        onabort = val;
      },
      set onerror(val) {
        onerror = val;
      },
      set ontimeout(val) {
        ontimeout = val;
      },
      set onsuccess(val) {
        onsuccess = val;
      }
    };
  }
  var isString$1 = function isString$1(val) {
    return typeof val === 'string';
  };
  function mpAdapter(config) {
    /* eslint-disable-next-line prefer-arrow-callback */
    return new Promise(function dispatchMpRequest(resolve, reject) {
      var url = config.url,
        data = config.data,
        headers = config.headers,
        method = config.method,
        params = config.params,
        paramsSerializer = config.paramsSerializer,
        responseType = config.responseType,
        timeout = config.timeout,
        cancelToken = config.cancelToken;
      // HTTP basic authentication
      if (config.auth) {
        var username = config.auth.username || '',
          password = config.auth.password || '';
        headers.Authorization = "Basic ".concat(btoa$1("".concat(username, ":").concat(password)));
      }
      // Add headers to the request
      utils.forEach(headers, function (val, key) {
        var header = key.toLowerCase();
        if (typeof data === 'undefined' && header === 'content-type' || header === 'referer') {
          delete headers[key];
        }
      });
      var request = createRequest(config);
      var options = {
        url: buildURL(url, params, paramsSerializer),
        header: headers,
        method: method && method.toUpperCase(),
        data: isString$1(data) ? JSON.parse(data) : data,
        responseType: responseType
      };
      if (cancelToken) {
        // Handle cancellation
        cancelToken.promise.then(function (cancel) {
          if (!request) {
            return;
          }
          request.abort();
          reject(cancel);
          request = null;
        });
      }
      request.timeout = timeout;
      request.onsuccess = function handleLoad(response) {
        settle(resolve, reject, response);
        request = null;
      };
      request.onabort = function handleAbort(error) {
        if (!request) {
          return;
        }
        reject(error);
        request = null;
      };
      request.onerror = function handleError(error) {
        if (!request) {
          return;
        }
        reject(error);
        request = null;
      };
      request.ontimeout = function handleTimeout(error) {
        reject(error);
        request = null;
      };
      request.send(options);
    });
  }

  /* eslint-disable prefer-spread, prefer-rest-params */
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function objectSpread(target) {
    var _arguments = arguments;
    var _loop = function _loop() {
      var nextSource = _arguments[index];
      if (nextSource !== null && nextSource !== undefined) {
        if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(nextSource));
        } else {
          ownKeys(Object(nextSource)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(nextSource, key));
          });
        }
      }
    };
    for (var index = 1; index < arguments.length; index++) {
      _loop();
    }
    return target;
  }
  function polyfill() {
    if (typeof Object.spread !== 'function') {
      Object.defineProperty(Object, 'spread', {
        value: objectSpread,
        writable: true,
        configurable: true
      });
    }
  }
  var commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
  function getFirstMatch(regexp, ua) {
    var match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
  }
  function getSecondMatch(regexp, ua) {
    var match = ua.match(regexp);
    return match && match.length > 1 && match[2] || '';
  }
  function browser$1(name, version) {
    return {
      name: name,
      version: version,
      firefox: name === 'firefox',
      chrome: name === 'chrome' || name === 'chromium',
      wechet: name === 'wechat',
      toString: function toString() {
        return "".concat(name.toUpperCase(), " ").concat(version);
      }
    };
  }
  var browsersList = [{
    test: [/micromessenger/i],
    describe: function describe(ua) {
      return browser$1('wechat', getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || getFirstMatch(commonVersionIdentifier, ua));
    }
  }, {
    test: [/\sedg\//i],
    describe: function describe(ua) {
      return browser$1('edge', getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua));
    }
  }, {
    test: [/edg([ea]|ios)/i],
    describe: function describe(ua) {
      return browser$1('edge', getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua));
    }
  }, {
    test: [/firefox|iceweasel|fxios/i],
    describe: function describe(ua) {
      return browser$1('firefox', getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua));
    }
  }, {
    test: [/chromium/i],
    describe: function describe(ua) {
      return browser$1('chromium', getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || getFirstMatch(commonVersionIdentifier, ua));
    }
  }, {
    test: [/chrome|crios|crmo/i],
    describe: function describe(ua) {
      return browser$1('chrome', getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua));
    }
  }, {
    test: [/safari|applewebkit/i],
    describe: function describe(ua) {
      return browser$1('safari', getFirstMatch(commonVersionIdentifier, ua));
    }
  }, /* Something else */
  {
    test: [/.*/i],
    describe: function describe(ua) {
      /* Here we try to make sure that there are explicit details about the device
       * in order to decide what regexp exactly we want to apply
       * (as there is a specific decision based on that conclusion)
       */
      var regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
      var regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
      var hasDeviceSpec = ua.search('\\(') !== -1;
      var regexp = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
      return browser$1(getFirstMatch(regexp, ua), getSecondMatch(regexp, ua));
    }
  }];
  var parsed = {};
  function isMiniProgram() {
    return (typeof wx === "undefined" ? "undefined" : (0, _typeof2.default)(wx)) === 'object' || (typeof swan === "undefined" ? "undefined" : (0, _typeof2.default)(swan)) === 'object' || (typeof my === "undefined" ? "undefined" : (0, _typeof2.default)(my)) === 'object' || /miniprogram/i.test(navigator.userAgent) || window && window.__wxjs_environment === 'miniprogram';
  }
  function parseBrowser(ua) {
    if (!parsed.browser) {
      ua = ua || (isMiniProgram() ? 'miniprogram' : navigator.userAgent);
      var descriptor = browsersList.find(function (browser) {
        return browser.test.some(function (condition) {
          return condition.test(ua);
        });
      });
      if (descriptor) {
        parsed.browser = descriptor.describe(ua);
      }
    }
    return parsed.browser;
  }
  function getBrowser() {
    return parseBrowser();
  }
  var BROWSER = parseBrowser();
  var MINIPROGRAM = isMiniProgram();
  var startsWith = function startsWith(input, search) {
    return input.substr(0, search.length) === search;
  };
  var MEETNOW_PREFIX = 'meetnow:';
  var MEETNOW_SESSION_KEY = 'meetnow-persist-config';
  var Config = /*#__PURE__*/function () {
    function Config() {
      (0, _classCallCheck2.default)(this, Config);
      this.m = new Map();
    }
    (0, _createClass2.default)(Config, [{
      key: "reset",
      value: function reset(configObj) {
        this.m = new Map(Object.entries(configObj));
      }
    }, {
      key: "get",
      value: function get(key, fallback) {
        var value = this.m.get(key);
        return value !== undefined ? value : fallback;
      }
    }, {
      key: "getBoolean",
      value: function getBoolean(key) {
        var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var val = this.m.get(key);
        if (val === undefined) {
          return fallback;
        }
        if (typeof val === 'string') {
          return val === 'true';
        }
        return !!val;
      }
    }, {
      key: "getNumber",
      value: function getNumber(key, fallback) {
        var val = parseFloat(this.m.get(key));
        return Number.isNaN(val) ? fallback !== undefined ? fallback : NaN : val;
      }
    }, {
      key: "set",
      value: function set(key, value) {
        this.m.set(key, value);
      }
    }]);
    return Config;
  }();
  var CONFIG = new Config();
  var configFromSession = function configFromSession(win) {
    try {
      var configStr = win.sessionStorage.getItem(MEETNOW_SESSION_KEY);
      return configStr !== null ? JSON.parse(configStr) : {};
    } catch (e) {
      return {};
    }
  };
  var saveConfig = function saveConfig(win, c) {
    try {
      win.sessionStorage.setItem(MEETNOW_SESSION_KEY, JSON.stringify(c));
    } catch (e) {
      /* eslint-disable-next-line */
      return;
    }
  };
  var configFromURL = function configFromURL(win) {
    var configObj = {};
    try {
      win.location.search.slice(1).split('&').map(function (entry) {
        return entry.split('=');
      }).map(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return [decodeURIComponent(key), decodeURIComponent(value)];
      }).filter(function (_ref3) {
        var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
          key = _ref4[0];
        return startsWith(key, MEETNOW_PREFIX);
      }).map(function (_ref5) {
        var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return [key.slice(MEETNOW_PREFIX.length), value];
      }).forEach(function (_ref7) {
        var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];
        configObj[key] = value;
      });
    } catch (e) {
      return configObj;
    }
    return configObj;
  };
  function setupConfig(config) {
    var win = isMiniProgram() ? wx : window;
    var MeetNow = win.MeetNow = win.MeetNow || {};
    // create the Meetnow.config from raw config object (if it exists)
    // and convert Meetnow.config into a ConfigApi that has a get() fn
    var configObj = Object.spread({}, configFromSession(win), {
      persistent: false
    }, config || MeetNow.config, configFromURL(win));
    CONFIG.reset(configObj);
    if (CONFIG.getBoolean('persistent')) {
      saveConfig(win, configObj);
    }
    MeetNow.config = CONFIG;
    if (CONFIG.getBoolean('testing')) {
      CONFIG.set('debug', 'MN:*');
    }
  }
  var crypt = createCommonjsModule(function (module) {
    (function () {
      var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
        crypt = {
          // Bit-wise rotation left
          rotl: function rotl(n, b) {
            return n << b | n >>> 32 - b;
          },
          // Bit-wise rotation right
          rotr: function rotr(n, b) {
            return n << 32 - b | n >>> b;
          },
          // Swap big-endian to little-endian and vice versa
          endian: function endian(n) {
            // If number given, swap endian
            if (n.constructor == Number) {
              return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            }

            // Else, assume array and swap all items
            for (var i = 0; i < n.length; i++) {
              n[i] = crypt.endian(n[i]);
            }
            return n;
          },
          // Generate an array of any length of random bytes
          randomBytes: function randomBytes(n) {
            for (var bytes = []; n > 0; n--) {
              bytes.push(Math.floor(Math.random() * 256));
            }
            return bytes;
          },
          // Convert a byte array to big-endian 32-bit words
          bytesToWords: function bytesToWords(bytes) {
            for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8) {
              words[b >>> 5] |= bytes[i] << 24 - b % 32;
            }
            return words;
          },
          // Convert big-endian 32-bit words to a byte array
          wordsToBytes: function wordsToBytes(words) {
            for (var bytes = [], b = 0; b < words.length * 32; b += 8) {
              bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            }
            return bytes;
          },
          // Convert a byte array to a hex string
          bytesToHex: function bytesToHex(bytes) {
            for (var hex = [], i = 0; i < bytes.length; i++) {
              hex.push((bytes[i] >>> 4).toString(16));
              hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join('');
          },
          // Convert a hex string to a byte array
          hexToBytes: function hexToBytes(hex) {
            for (var bytes = [], c = 0; c < hex.length; c += 2) {
              bytes.push(parseInt(hex.substr(c, 2), 16));
            }
            return bytes;
          },
          // Convert a byte array to a base-64 string
          bytesToBase64: function bytesToBase64(bytes) {
            for (var base64 = [], i = 0; i < bytes.length; i += 3) {
              var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
              for (var j = 0; j < 4; j++) {
                if (i * 8 + j * 6 <= bytes.length * 8) {
                  base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                } else {
                  base64.push('=');
                }
              }
            }
            return base64.join('');
          },
          // Convert a base-64 string to a byte array
          base64ToBytes: function base64ToBytes(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
            for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
              if (imod4 == 0) {
                continue;
              }
              bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
          }
        };
      module.exports = crypt;
    })();
  });
  var charenc = {
    // UTF-8 encoding
    utf8: {
      // Convert a string to a byte array
      stringToBytes: function stringToBytes(str) {
        return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
      },
      // Convert a byte array to a string
      bytesToString: function bytesToString(bytes) {
        return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
      }
    },
    // Binary encoding
    bin: {
      // Convert a string to a byte array
      stringToBytes: function stringToBytes(str) {
        for (var bytes = [], i = 0; i < str.length; i++) {
          bytes.push(str.charCodeAt(i) & 0xFF);
        }
        return bytes;
      },
      // Convert a byte array to a string
      bytesToString: function bytesToString(bytes) {
        for (var str = [], i = 0; i < bytes.length; i++) {
          str.push(String.fromCharCode(bytes[i]));
        }
        return str.join('');
      }
    }
  };
  var charenc_1 = charenc;

  /*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */

  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually
  var isBuffer_1 = function isBuffer_1(obj) {
    return obj != null && (isBuffer$1(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
  };
  function isBuffer$1(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
  }

  // For Node v0.10 support. Remove this eventually.
  function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer$1(obj.slice(0, 0));
  }
  var md5 = createCommonjsModule(function (module) {
    (function () {
      var crypt$1 = crypt,
        utf8 = charenc_1.utf8,
        isBuffer = isBuffer_1,
        bin = charenc_1.bin,
        // The core
        md5 = function md5(message, options) {
          // Convert to byte array
          if (message.constructor == String) {
            if (options && options.encoding === 'binary') {
              message = bin.stringToBytes(message);
            } else {
              message = utf8.stringToBytes(message);
            }
          } else if (isBuffer(message)) {
            message = Array.prototype.slice.call(message, 0);
          } else if (!Array.isArray(message)) {
            message = message.toString();
          }
          // else, assume byte array already

          var m = crypt$1.bytesToWords(message),
            l = message.length * 8,
            a = 1732584193,
            b = -271733879,
            c = -1732584194,
            d = 271733878;

          // Swap endian
          for (var i = 0; i < m.length; i++) {
            m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
          }

          // Padding
          m[l >>> 5] |= 0x80 << l % 32;
          m[(l + 64 >>> 9 << 4) + 14] = l;

          // Method shortcuts
          var FF = md5._ff,
            GG = md5._gg,
            HH = md5._hh,
            II = md5._ii;
          for (var i = 0; i < m.length; i += 16) {
            var aa = a,
              bb = b,
              cc = c,
              dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
          }
          return crypt$1.endian([a, b, c, d]);
        };

      // Auxiliary functions
      md5._ff = function (a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
      };
      md5._gg = function (a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
      };
      md5._hh = function (a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
      };
      md5._ii = function (a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
      };

      // Package private blocksize
      md5._blocksize = 16;
      md5._digestsize = 16;
      module.exports = function (message, options) {
        if (message === undefined || message === null) {
          throw new Error('Illegal argument ' + message);
        }
        var digestbytes = crypt$1.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt$1.bytesToHex(digestbytes);
      };
    })();
  });
  var RequestMethod = {
    GET: 'get',
    POST: 'post'
  };
  var baseURL = {
    ctrl: '/conference-ctrl/api/v1/ctrl/',
    usermgr: '/user-manager/api/v1/',
    confmgr: '/conference-manager/api/v1/'
  };
  var configs = {
    // user manager
    getVirtualJWT: {
      method: RequestMethod.GET,
      url: "".concat(baseURL.usermgr, "external/virtualJwt/party")
    },
    login: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.usermgr, "login")
    },
    selectAccount: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.usermgr, "login/selectAccount")
    },
    logout: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.usermgr, "logout")
    },
    refreshToken: {
      method: RequestMethod.GET,
      url: "".concat(baseURL.usermgr, "current/user/refreshToken")
    },
    sendMobileLoginVerifyCode: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.usermgr, "sendMobileLoginVerifyCode")
    },
    // conference manager
    getConferenceInfo: {
      method: RequestMethod.GET,
      url: "".concat(baseURL.confmgr, "external/conference/info")
    },
    // info
    getURL: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "get-url-by-long-num")
    },
    getFullInfo: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "get-conference-info")
    },
    getBasicInfo: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "get-short-info")
    },
    getBasicInfoOffline: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "get-short-info-offline")
    },
    getStats: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "get-call-stats")
    },
    // lifecycle
    polling: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "polling")
    },
    keepalive: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "user-keepalive")
    },
    // focus
    joinFocus: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "join-focus")
    },
    joinWechat: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "join-wechat")
    },
    // media
    joinMedia: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "join-audio-video")
    },
    renegMedia: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "av-reneg")
    },
    // share
    joinShare: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "join-applicationsharing-v2")
    },
    leaveShare: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "bye-applicationsharing")
    },
    switchShare: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "applicationsharing-switch")
    },
    renegShare: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "applicationsharing-reneg")
    },
    // im
    pushMessage: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "im-info")
    },
    pullMessage: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "get-all-im-info")
    },
    // ctrl
    muteAll: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "mute-all")
    },
    unmuteAll: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "unmute-all")
    },
    acceptLobbyUser: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "grant-lobby-user")
    },
    acceptLobbyUserAll: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "grant-lobby-all")
    },
    rejectLobbyUserAll: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "del-lobby-all")
    },
    waitLobbyUser: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "wait-lobby-user")
    },
    waitLobbyUserAll: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "wait-lobby-all")
    },
    rejectHandupAll: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "reject-all-hand-up")
    },
    deleteUser: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "delete-user")
    },
    setUserMedia: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "modify-user-media")
    },
    setUserRole: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "modify-user-role")
    },
    setUserDisplayText: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "edit-user-display-text")
    },
    holdUser: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "wait-lobby-user")
    },
    inviteUser: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "invite-user")
    },
    setFocusVideo: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "set-focus-video")
    },
    setSpeakMode: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "set-speak-mode")
    },
    setFreeLayout: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "set-free-layout")
    },
    setCustomizeLayout: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "set-customize-layout")
    },
    setGlobalLayout: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "set-global-layout")
    },
    setFecc: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "set-fecc")
    },
    setTitle: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "set-title")
    },
    sendTitle: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "send-title")
    },
    setRecord: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "record-operate")
    },
    setRTMP: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "rtmp-operate")
    },
    setLock: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "lock-conference")
    },
    leave: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "quit-conference")
    },
    end: {
      method: RequestMethod.POST,
      url: "".concat(baseURL.ctrl, "end-conference")
    }
  };
  var CONFIGS = configs;
  var DEFAULT_ERROR = {
    msg: 'Unknown Error',
    errorCode: -1
  };
  var ApiError = /*#__PURE__*/function (_Error) {
    (0, _inherits2.default)(ApiError, _Error);
    var _super = (0, _createSuper2.default)(ApiError);
    function ApiError(bizCode) {
      var _this;
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ERROR;
      (0, _classCallCheck2.default)(this, ApiError);
      _this = _super.call(this);
      _this.name = 'ApiError';
      _this.message = error.msg;
      _this.errCode = error.errorCode;
      _this.bizCode = bizCode;
      return _this;
    }
    return (0, _createClass2.default)(ApiError);
  }( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error)); // TODO
  // api error type checker
  var log = browser('MN:Api:Request');
  var isCancel$1 = axios$1.isCancel;
  function createRequest$1(config) {
    var delegate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : axios$1;
    var source;
    var request;
    function header(header) {
      config.headers = header;
      return request;
    }
    function params(params) {
      config.params = params;
      return request;
    }
    function data(data) {
      config.data = data;
      return request;
    }
    function send() {
      log('send()');
      source = axios$1.CancelToken.source();
      config.cancelToken = source.token;
      return delegate(config);
    }
    function cancel() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'canceled';
      log('cancel()');
      return source && source.cancel(reason);
    }
    return request = {
      config: config,
      header: header,
      params: params,
      data: data,
      send: send,
      cancel: cancel
    };
  }
  // export type Request<T, B, D> = ReturnType<typeof createRequest<T, B, D>>;

  var log$1 = browser('MN:Api');
  function createApi() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    log$1('createApi()');
    var delegate = axios$1.create(Object.spread({}, {
      baseURL: '/'
    }, config));
    delegate.interceptors.response.use(function (response) {
      var _response$data = response.data,
        ret = _response$data.ret,
        bizCode = _response$data.bizCode,
        error = _response$data.error,
        data = _response$data.data;
      if (ret < 0) {
        throw new ApiError(bizCode, error);
      }
      // should not go here
      // server impl error
      if (ret === 0 && error) {
        throw new ApiError(bizCode, error);
      }
      log$1('request success: %o', data);
      // TBD
      // replace response data with actual data. eg. response.data = data;
      // TODO
      // normalize error
      return response;
    }, function (error) {
      log$1('request error: %o', error);
      throw error;
    });
    function request(apiName) {
      log$1("request() \"".concat(apiName, "\""));
      return createRequest$1(Object.spread({}, CONFIGS[apiName]), delegate);
    }
    return {
      get interceptors() {
        return delegate.interceptors;
      },
      request: request,
      delegate: delegate
    };
  }
  var isDef = function isDef(value) {
    return value !== undefined && value !== null;
  };
  var isArray$1 = Array.isArray;
  var isFunction$1 = function isFunction$1(val) {
    return typeof val === 'function';
  };
  var isObject$1 = function isObject$1(val) {
    return (0, _typeof2.default)(val) === 'object' && val !== null;
  };
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var hasOwn = function hasOwn(val, key) {
    return hasOwnProperty.call(val, key);
  };
  var camelizeRE = /-(\w)/g;
  var camelize = function camelize(str) {
    return str.replace(camelizeRE, function (_, c) {
      return c ? c.toUpperCase() : '';
    });
  };
  // compare whether a value has changed, accounting for NaN.
  var hasChanged = function hasChanged(value, oldValue) {
    /* eslint-disable-next-line no-self-compare */
    return value !== oldValue && (value === value || oldValue === oldValue);
  };
  function createUserApi(token) {
    var api = createApi({
      baseURL: CONFIG.get('baseurl', 'https://meetings.ylyun.com/webapp/'),
      timeout: CONFIG.get('timeout', 0)
    });
    api.interceptors.request.use(function (config) {
      if (token) {
        config.headers = config.headers || {};
        config.headers.token = isFunction$1(token) ? token() : token;
      }
      return config;
    });
    return api;
  }
  var log$2 = browser('MN:Worker');
  function createWorker(config) {
    var running = false;
    var working = false;
    var interval = 0;
    var times = 0;
    var timeout;
    var _config$interval = config.interval,
      nextInterval = _config$interval === void 0 ? interval : _config$interval,
      work = config.work,
      cancel = config.cancel;
    function job() {
      return _job.apply(this, arguments);
    }
    function _job() {
      _job = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var immediate,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              immediate = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
              if (!(work && immediate)) {
                _context.next = 6;
                break;
              }
              working = true;
              _context.next = 5;
              return work(times++);
            case 5:
              working = false;
            case 6:
              if (running) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              interval = isFunction$1(nextInterval) ? nextInterval() : nextInterval;
              // schedule next
              timeout = setTimeout(job, interval);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _job.apply(this, arguments);
    }
    function start() {
      return _start.apply(this, arguments);
    }
    function _start() {
      _start = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var immediate,
          _args2 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              immediate = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
              log$2('start()');
              if (!running) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              running = true;
              _context2.next = 7;
              return job(immediate);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _start.apply(this, arguments);
    }
    function stop() {
      log$2('stop()');
      if (!running) {
        return;
      }
      if (timeout) {
        clearTimeout(timeout);
        timeout = undefined;
      }
      if (working) {
        cancel && cancel();
      }
      running = false;
    }
    return {
      config: config,
      get running() {
        return running;
      },
      start: start,
      stop: stop
    };
  }
  function createDigestAuth(_x) {
    return _createDigestAuth.apply(this, arguments);
  }
  /* eslint-disable no-use-before-define */
  function _createDigestAuth() {
    _createDigestAuth = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee73(selection) {
      var token, api, response, worker, invalid, _invalid;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee73$(_context73) {
        while (1) switch (_context73.prev = _context73.next) {
          case 0:
            _invalid = function _invalid3() {
              _invalid = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee72() {
                return (0, _regeneratorRuntime2.default)().wrap(function _callee72$(_context72) {
                  while (1) switch (_context72.prev = _context72.next) {
                    case 0:
                      _context72.next = 2;
                      return api.request('logout').send()
                      // ignore error anyway
                      .catch(function () {});
                    case 2:
                      worker.stop();
                      token = undefined;
                    case 4:
                    case "end":
                      return _context72.stop();
                  }
                }, _callee72);
              }));
              return _invalid.apply(this, arguments);
            };
            invalid = function _invalid2() {
              return _invalid.apply(this, arguments);
            };
            token = selection; // create api
            api = createUserApi(function () {
              return token;
            }); // try auth
            _context73.next = 6;
            return api.request('selectAccount').send();
          case 6:
            response = _context73.sent;
            token = response.data.data.token;
            // creat auth() worker
            worker = createWorker({
              interval: 5 * 60 * 1000,
              work: function () {
                var _work = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee71() {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee71$(_context71) {
                    while (1) switch (_context71.prev = _context71.next) {
                      case 0:
                        _context71.next = 2;
                        return api.request('refreshToken').send();
                      case 2:
                      case "end":
                        return _context71.stop();
                    }
                  }, _callee71);
                }));
                function work() {
                  return _work.apply(this, arguments);
                }
                return work;
              }()
            }); // start worker
            worker.start(false);
            _context73.t0 = api;
            _context73.t1 = worker;
            _context73.t2 = invalid;
            return _context73.abrupt("return", {
              get token() {
                return token;
              },
              api: _context73.t0,
              worker: _context73.t1,
              invalid: _context73.t2
            });
          case 14:
          case "end":
            return _context73.stop();
        }
      }, _callee73);
    }));
    return _createDigestAuth.apply(this, arguments);
  }
  function createTempAuth(_x2) {
    return _createTempAuth.apply(this, arguments);
  }
  function _createTempAuth() {
    _createTempAuth = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee76(partyId) {
      var token, api, worker, auth, _auth3, invalid, _invalid4;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee76$(_context76) {
        while (1) switch (_context76.prev = _context76.next) {
          case 0:
            _invalid4 = function _invalid6() {
              _invalid4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee75() {
                return (0, _regeneratorRuntime2.default)().wrap(function _callee75$(_context75) {
                  while (1) switch (_context75.prev = _context75.next) {
                    case 0:
                      worker.stop();
                      token = undefined;
                    case 2:
                    case "end":
                      return _context75.stop();
                  }
                }, _callee75);
              }));
              return _invalid4.apply(this, arguments);
            };
            invalid = function _invalid5() {
              return _invalid4.apply(this, arguments);
            };
            _auth3 = function _auth5() {
              _auth3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee74() {
                var response;
                return (0, _regeneratorRuntime2.default)().wrap(function _callee74$(_context74) {
                  while (1) switch (_context74.prev = _context74.next) {
                    case 0:
                      _context74.next = 2;
                      return api.request('getVirtualJWT').params({
                        id: partyId
                      }).send();
                    case 2:
                      response = _context74.sent;
                      token = response.data.data.token;
                      if (token) {
                        _context74.next = 6;
                        break;
                      }
                      throw new Error('Authorization Error');
                    case 6:
                    case "end":
                      return _context74.stop();
                  }
                }, _callee74);
              }));
              return _auth3.apply(this, arguments);
            };
            auth = function _auth4() {
              return _auth3.apply(this, arguments);
            };
            // create api
            api = createUserApi(function () {
              return token;
            }); // try auth
            _context76.next = 7;
            return auth();
          case 7:
            // creat auth() worker
            worker = createWorker({
              interval: 5 * 60 * 1000,
              work: auth
            }); // start worker
            worker.start(false);
            _context76.t0 = api;
            _context76.t1 = worker;
            _context76.t2 = invalid;
            return _context76.abrupt("return", {
              get token() {
                return token;
              },
              api: _context76.t0,
              worker: _context76.t1,
              invalid: _context76.t2
            });
          case 13:
          case "end":
            return _context76.stop();
        }
      }, _callee76);
    }));
    return _createTempAuth.apply(this, arguments);
  }
  (function (AuthType) {
    AuthType["email"] = "0";
    AuthType["mobile"] = "1";
    AuthType["verifycode"] = "9";
  })(exports.AuthType || (exports.AuthType = {}));
  function bootstrap(_x3) {
    return _bootstrap.apply(this, arguments);
  }
  function _bootstrap() {
    _bootstrap = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee78(auth) {
      var api, response, _response$data$data2, account, tokens, identities;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee78$(_context78) {
        while (1) switch (_context78.prev = _context78.next) {
          case 0:
            api = createUserApi();
            _context78.next = 3;
            return api.request('login').data({
              principle: auth.principle,
              credential: md5(auth.credential),
              number: auth.enterprise,
              mobileCode: auth.areacode,
              accountType: auth.authtype
            }).send();
          case 3:
            response = _context78.sent;
            _response$data$data2 = response.data.data, account = _response$data$data2.account, tokens = _response$data$data2.tokens;
            identities = tokens.map(function (token) {
              var identityToken = token.token;
              var identityAuth;
              return Object.spread({}, token, {
                get account() {
                  return account;
                },
                get auth() {
                  return identityAuth;
                },
                confirm: function () {
                  var _confirm = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee77() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee77$(_context77) {
                      while (1) switch (_context77.prev = _context77.next) {
                        case 0:
                          if (identityAuth) {
                            _context77.next = 4;
                            break;
                          }
                          _context77.next = 3;
                          return createDigestAuth(identityToken);
                        case 3:
                          identityAuth = _context77.sent;
                        case 4:
                          return _context77.abrupt("return", identityAuth);
                        case 5:
                        case "end":
                          return _context77.stop();
                      }
                    }, _callee77);
                  }));
                  function confirm() {
                    return _confirm.apply(this, arguments);
                  }
                  return confirm;
                }()
              });
            });
            return _context78.abrupt("return", {
              account: account,
              identities: identities
            });
          case 7:
          case "end":
            return _context78.stop();
        }
      }, _callee78);
    }));
    return _bootstrap.apply(this, arguments);
  }
  function fetchControlUrl(_x4, _x5, _x6) {
    return _fetchControlUrl.apply(this, arguments);
  }
  function _fetchControlUrl() {
    _fetchControlUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee79(identity, number, baseurl) {
      var auth, party, api, token, partyNumber, response, _response$data$data3, conferenceNo, domain, vmr, scheduledConference, shortNo, planId, sequence, encode, source, parts, url;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee79$(_context79) {
        while (1) switch (_context79.prev = _context79.next) {
          case 0:
            if (identity.auth) {
              _context79.next = 3;
              break;
            }
            _context79.next = 3;
            return identity.confirm();
          case 3:
            auth = identity.auth, party = identity.party;
            api = auth.api, token = auth.token;
            partyNumber = party.number;
            _context79.next = 8;
            return api.request('getConferenceInfo').params({
              conferenceNo: number,
              searchNotStartedScheduledConference: false
            }).send();
          case 8:
            response = _context79.sent;
            _response$data$data3 = response.data.data, conferenceNo = _response$data$data3.conferenceNo, domain = _response$data$data3.domain, vmr = _response$data$data3.vmr, scheduledConference = _response$data$data3.scheduledConference;
            shortNo = conferenceNo.split('.')[1];
            planId = '';
            sequence = 1;
            if (vmr) {
              planId = vmr.vmrId;
            }
            if (scheduledConference) {
              planId = scheduledConference.planId;
              sequence = scheduledConference.sequence;
            }
            encode = btoa$1;
            source = 'WEBUSER';
            parts = ["source=".concat(source), // TODO base64
            "conference=".concat(encode("".concat(shortNo, "@").concat(domain))), "sequence=".concat(sequence), "id=".concat(planId), // TODO base64
            "client=".concat(encode("".concat(partyNumber, "@").concat(domain))), "t=".concat(encode(token))];
            baseurl = baseurl || api.delegate.defaults.baseURL;
            baseurl = baseurl.replace('webapp', 'control');
            url = "".concat(baseurl, "?").concat(parts.join('&'));
            return _context79.abrupt("return", url);
          case 22:
          case "end":
            return _context79.stop();
        }
      }, _callee79);
    }));
    return _fetchControlUrl.apply(this, arguments);
  }
  function createContext(delegate) {
    return new Proxy({}, {
      get: function get(target, key) {
        return key in target ? target[key] : Reflect.get(delegate, key);
      }
    });
  }
  // export function createMessageSender(delegate: any) {
  //   return new Proxy({}, {
  //     get(target: object, key: string) {
  //       return Reflect.get(delegate, hyphenate(key));
  //     },
  //   }) as Context;
  // }

  var log$3 = browser('MN:Events');
  function createEvents() {
    var scopedlog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : log$3;
    var instance;
    var events = {};
    function on(event, fn) {
      if (isArray$1(event)) {
        event.forEach(function (ev) {
          return on(ev, fn);
        });
        return instance;
      }
      (events[event] || (events[event] = [])).push(fn);
      return instance;
    }
    function off(event, fn) {
      if (isArray$1(event)) {
        event.forEach(function (e) {
          return off(e, fn);
        });
        return instance;
      }
      var callbacks = events[event];
      if (!callbacks) {
        return instance;
      }
      if (!fn) {
        events[event] = null;
        return instance;
      }
      var callback;
      var index = callbacks.length;
      while (index--) {
        callback = callbacks[index];
        if (callback === fn || callback.fn === fn) {
          callbacks.splice(index, 1);
          break;
        }
      }
      return instance;
    }
    function once(event, fn) {
      function wrapper() {
        off(event, wrapper);
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        fn.apply(this, args);
      }
      wrapper.fn = fn;
      on(event, wrapper);
      return instance;
    }
    function toArray(list, start) {
      start = start || 0;
      var i = list.length - start;
      var ret = new Array(i);
      while (i--) {
        ret[i] = list[i + start];
      }
      return ret;
    }
    function emit(event) {
      scopedlog("emit() \"".concat(event, "\""));
      var callbacks = events[event];
      if (!callbacks) {
        return instance;
      }
      callbacks = callbacks.length > 1 ? toArray(callbacks) : callbacks;
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      var _iterator = (0, _createForOfIteratorHelper2.default)(callbacks),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var callback = _step.value;
          try {
            callback.apply(void 0, args);
          } catch (error) {
            scopedlog("invoke \"".concat(event, "\" callback failed: %o"), error);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return instance;
    }
    return instance = {
      on: on,
      off: off,
      once: once,
      emit: emit
    };
  }
  var log$4 = browser('MN:Keepalive');
  var DEFAULT_INTERVAL = 30 * 1000;
  var MIN_INTERVAL = 2;
  var MAX_INTERVAL = 30;
  var MAX_ATTEMPTS = 15;
  function computeNextTimeout(attempts) {
    log$4("computeNextTimeout() attempts: ".concat(attempts));
    /* eslint-disable-next-line no-restricted-properties */
    var k = Math.floor(Math.random() * Math.pow(2, attempts) + 1);
    if (k < MIN_INTERVAL) {
      k = MIN_INTERVAL;
    }
    if (k > MAX_INTERVAL) {
      k = MAX_INTERVAL;
    }
    return k * 1000;
  }
  function createKeepAlive(config) {
    var api = config.api;
    var request;
    var canceled = false;
    var _interval = config.interval || DEFAULT_INTERVAL;
    var attempts = 0;
    function keepalive() {
      return _keepalive.apply(this, arguments);
    }
    function _keepalive() {
      _keepalive = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var response, error, _response$data2, bizCode, _response$data2$data, data, expectedInterval;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              log$4('keepalive()');
              _context3.prev = 1;
              canceled = false;
              request = api.request('keepalive');
              _context3.next = 6;
              return request.send();
            case 6:
              response = _context3.sent;
              _context3.next = 19;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](1);
              error = _context3.t0;
              canceled = isCancel$1(_context3.t0);
              if (!canceled) {
                _context3.next = 15;
                break;
              }
              return _context3.abrupt("return");
            case 15:
              // if request failed by network or server error,
              // increase next request timeout
              attempts++;
              _interval = computeNextTimeout(attempts);
              log$4('keepalive error: %o', error);
              config.onError && config.onError(error, attempts);
            case 19:
              if (attempts > MAX_ATTEMPTS) {
                config.onError && config.onError(new Error('Max Attempts'), attempts);
              }
              if (!error) {
                _context3.next = 22;
                break;
              }
              return _context3.abrupt("return");
            case 22:
              _response$data2 = response.data, bizCode = _response$data2.bizCode, _response$data2$data = _response$data2.data, data = _response$data2$data === void 0 ? {
                interval: _interval
              } : _response$data2$data;
              expectedInterval = data.interval; // TODO
              // check bizCode
              _interval = Math.min(expectedInterval * 1000, _interval);
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 9]]);
      }));
      return _keepalive.apply(this, arguments);
    }
    var worker = createWorker({
      work: function work() {
        return keepalive();
      },
      interval: function interval() {
        return _interval;
      },
      cancel: function cancel() {
        return request.cancel();
      }
    });
    return Object.spread({}, worker, {
      keepalive: keepalive
    });
  }
  var log$5 = browser('MN:Polling');
  var DEFAULT_INTERVAL$1 = 100;
  var MIN_INTERVAL$1 = 2;
  var MAX_INTERVAL$1 = 30;
  var MAX_ATTEMPTS$1 = 5;
  function computeNextTimeout$1(attempts) {
    log$5("computeNextTimeout() attempts: ".concat(attempts));
    /* eslint-disable-next-line no-restricted-properties */
    var k = Math.floor(Math.random() * Math.pow(2, attempts) + 1);
    if (k < MIN_INTERVAL$1) {
      k = MIN_INTERVAL$1;
    }
    if (k > MAX_INTERVAL$1) {
      k = MAX_INTERVAL$1;
    }
    return k * 1000;
  }
  function createPolling(config) {
    var api = config.api;
    var request;
    var _interval2 = DEFAULT_INTERVAL$1;
    var attempts = 0;
    var version = 0;
    function analyze(data) {
      if (!data) {
        return;
      }
      var newVersion = data.version,
        category = data.category,
        body = data.body;
      if (!isDef(newVersion) || newVersion <= version) {
        log$5("illegal version: ".concat(newVersion, ", current version: ").concat(version, "."));
        return;
      }
      switch (category) {
        case 'conference-info':
          config.onInformation && config.onInformation(body);
          break;
        case 'im-record':
          config.onMessage && config.onMessage(body);
          break;
        case 'port-change':
          config.onRenegotiate && config.onRenegotiate(body);
          break;
        case 'call-record-list':
          config.onCallRecord && config.onCallRecord(body);
          break;
        case 'quit-conference':
          config.onQuit && config.onQuit(body);
          break;
        default:
          log$5("unsupported category: ".concat(category));
          break;
      }
      version = newVersion;
    }
    function poll() {
      return _poll.apply(this, arguments);
    }
    function _poll() {
      _poll = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var response, error, canceled, timeouted, _response$data3, bizCode, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              log$5('poll()');
              canceled = false;
              timeouted = false;
              _context4.prev = 3;
              request = api.request('polling').data({
                version: version
              });
              _context4.next = 7;
              return request.send();
            case 7:
              response = _context4.sent;
              _context4.next = 23;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](3);
              error = _context4.t0;
              canceled = isCancel$1(_context4.t0);
              if (!canceled) {
                _context4.next = 16;
                break;
              }
              return _context4.abrupt("return");
            case 16:
              // polling timeout
              timeouted = !!error && [900408, 901323].includes(error.bizCode);
              if (!timeouted) {
                _context4.next = 19;
                break;
              }
              return _context4.abrupt("return");
            case 19:
              // if request failed by network or server error,
              // increase next polling timeout
              attempts++;
              _interval2 = computeNextTimeout$1(attempts);
              log$5('polling error: %o', error);
              config.onError && config.onError(error, attempts);
            case 23:
              if (attempts > MAX_ATTEMPTS$1) {
                config.onError && config.onError(new Error('Max Attempts'), attempts);
              }
              if (!error) {
                _context4.next = 26;
                break;
              }
              return _context4.abrupt("return");
            case 26:
              _response$data3 = response.data, bizCode = _response$data3.bizCode, data = _response$data3.data; // TODO
              // check bizCode
              try {
                analyze(data);
              } catch (error) {
                log$5('process data failed. %o', error);
              }
              attempts = 0;
            case 29:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 10]]);
      }));
      return _poll.apply(this, arguments);
    }
    var worker = createWorker({
      work: function work() {
        return poll();
      },
      interval: function interval() {
        return _interval2;
      },
      cancel: function cancel() {
        return request.cancel();
      }
    });
    return Object.spread({}, worker, {
      poll: poll,
      analyze: analyze
    });
  }
  var log$6 = browser('MN:Reactive');
  function createReactive(data, events) {
    events = events || createEvents(log$6);
    return new Proxy(data, {
      set: function set(target, prop, value, receiver) {
        var oldValue = target[prop];
        var hadKey = hasOwn(target, prop);
        var result = Reflect.set(target, prop, value, receiver);
        if (!hadKey) {
          events.emit("".concat(camelize(prop), "Added"), value);
        }
        if (hasChanged(value, oldValue)) {
          events.emit("".concat(camelize(prop), "Changed"), value, oldValue);
        }
        return result;
      }
    });
  }
  var log$7 = browser('MN:Information:Description');
  function createDescription(data, context) {
    var api = context.api;
    var events = createEvents(log$7);
    /* eslint-disable-next-line no-use-before-define */
    var reactive = createReactive(watch({}), events);
    var description;
    function watch(target) {
      /* eslint-disable no-use-before-define */
      target.locked = isLocked();
      /* eslint-enable no-use-before-define */
      return target;
    }
    function update(diff) {
      // fire status change events
      watch(reactive);
      events.emit('updated', description);
    }
    function getLock() {
      return {
        admissionPolicy: data['admission-policy'],
        attendeeByPass: data['attendee-by-pass']
      };
    }
    function setLock(_x7) {
      return _setLock.apply(this, arguments);
    }
    function _setLock() {
      _setLock = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(options) {
        var admissionPolicy, _options$attendeeByPa, attendeeByPass;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              log$7('setLock()');
              admissionPolicy = options.admissionPolicy, _options$attendeeByPa = options.attendeeByPass, attendeeByPass = _options$attendeeByPa === void 0 ? true : _options$attendeeByPa;
              _context5.next = 4;
              return api.request('setLock').data({
                'admission-policy': admissionPolicy,
                'attendee-lobby-bypass': attendeeByPass
              }).send();
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return _setLock.apply(this, arguments);
    }
    function lock() {
      return _lock.apply(this, arguments);
    }
    function _lock() {
      _lock = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var attendeeByPass,
          presenterOnly,
          _args6 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              attendeeByPass = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : false;
              presenterOnly = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : true;
              log$7('lock()');
              _context6.next = 5;
              return setLock({
                admissionPolicy: presenterOnly ? 'closedAuthenticated' : 'openAuthenticated',
                attendeeByPass: attendeeByPass
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return _lock.apply(this, arguments);
    }
    function unlock() {
      return _unlock.apply(this, arguments);
    }
    function _unlock() {
      _unlock = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              log$7('unlock()');
              _context7.next = 3;
              return setLock({
                admissionPolicy: 'anonymous'
              });
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return _unlock.apply(this, arguments);
    }
    function isLocked() {
      return getLock().admissionPolicy !== 'anonymous';
    }
    return description = Object.spread({}, events, {
      get data() {
        return data;
      },
      get subject() {
        return data.subject;
      },
      get: function get(key) {
        return data[key];
      },
      update: update,
      getLock: getLock,
      setLock: setLock,
      lock: lock,
      unlock: unlock,
      isLocked: isLocked
    });
  }
  var log$8 = browser('MN:Information:State');
  function createState(data, context) {
    var events = createEvents(log$8);
    /* eslint-disable-next-line no-use-before-define */
    var reactive = createReactive(watch({}), events);
    var description;
    function watch(target) {
      var active = data.active,
        locked = data.locked;
      /* eslint-disable no-use-before-define */
      target.active = active;
      target.locked = locked;
      target.sharingUserEntity = getSharingUserEntity();
      target.speechUserEntity = getSpeechUserEntity();
      /* eslint-enable no-use-before-define */
      return target;
    }
    function update(diff) {
      // fire status change events
      watch(reactive);
      events.emit('updated', description);
    }
    function getSharingUserEntity() {
      var applicationsharer = data.applicationsharer;
      return applicationsharer.user && applicationsharer.user.entity;
    }
    function getSpeechUserEntity() {
      var speechUserEntity = data['speech-user-entity'];
      return speechUserEntity;
    }
    function getSharingType() {
      var applicationsharer = data.applicationsharer;
      return applicationsharer.user && applicationsharer.user['share-type'];
    }
    return description = Object.spread({}, events, {
      get data() {
        return data;
      },
      get: function get(key) {
        return data[key];
      },
      update: update,
      getSharingUserEntity: getSharingUserEntity,
      getSpeechUserEntity: getSpeechUserEntity,
      getSharingType: getSharingType
    });
  }
  var log$9 = browser('MN:Information:Layout');
  function createLayoutCtrl(api) {
    function setLayout(_x8) {
      return _setLayout.apply(this, arguments);
    }
    function _setLayout() {
      _setLayout = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8(options) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              log$9('setLayout()');
              _context8.next = 3;
              return api.request('setFreeLayout').data(options).send();
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return _setLayout.apply(this, arguments);
    }
    function setCustomizeLayout(_x9) {
      return _setCustomizeLayout.apply(this, arguments);
    }
    function _setCustomizeLayout() {
      _setCustomizeLayout = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9(options) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              log$9('setCustomizeLayout()');
              options.viewer = options.viewer || 'attendee';
              _context9.next = 4;
              return api.request('setCustomizeLayout').data(options).send();
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return _setCustomizeLayout.apply(this, arguments);
    }
    function setPresenterLayout(_x10) {
      return _setPresenterLayout.apply(this, arguments);
    }
    function _setPresenterLayout() {
      _setPresenterLayout = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10(options) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              log$9('setPresenterLayout()');
              options.viewer = 'presenter';
              _context10.next = 4;
              return setCustomizeLayout(options);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return _setPresenterLayout.apply(this, arguments);
    }
    function setAttendeeLayout(_x11) {
      return _setAttendeeLayout.apply(this, arguments);
    }
    function _setAttendeeLayout() {
      _setAttendeeLayout = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee11(options) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              log$9('setAttendeeLayout()');
              options.viewer = 'attendee';
              _context11.next = 4;
              return setCustomizeLayout(options);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      return _setAttendeeLayout.apply(this, arguments);
    }
    function setCastViewerLayout(_x12) {
      return _setCastViewerLayout.apply(this, arguments);
    }
    function _setCastViewerLayout() {
      _setCastViewerLayout = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee12(options) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              log$9('setCastViewerLayout()');
              options.viewer = 'castviewer';
              _context12.next = 4;
              return setCustomizeLayout(options);
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return _setCastViewerLayout.apply(this, arguments);
    }
    function setOSD() {
      return _setOSD.apply(this, arguments);
    }
    function _setOSD() {
      _setOSD = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee13() {
        var options,
          name,
          icon,
          _args13 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              options = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {
                name: true,
                icon: true
              };
              log$9('setOSD()');
              name = options.name, icon = options.icon;
              _context13.next = 5;
              return api.request('setGlobalLayout').data({
                'hide-osd-site-icon': icon,
                'hide-osd-site-name': name
              }).send();
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return _setOSD.apply(this, arguments);
    }
    function setSpeakMode(_x13) {
      return _setSpeakMode.apply(this, arguments);
    }
    function _setSpeakMode() {
      _setSpeakMode = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee14(mode) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              log$9('setSpeakMode()');
              _context14.next = 3;
              return api.request('setSpeakMode').data({
                'speak-mode': mode
              }).send();
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return _setSpeakMode.apply(this, arguments);
    }
    return {
      setLayout: setLayout,
      setCustomizeLayout: setCustomizeLayout,
      setPresenterLayout: setPresenterLayout,
      setAttendeeLayout: setAttendeeLayout,
      setCastViewerLayout: setCastViewerLayout,
      setOSD: setOSD,
      setSpeakMode: setSpeakMode
    };
  }
  var log$a = browser('MN:Information:Danmaku');
  var DANMAKU_CONFIGS = {
    position: 'top',
    type: 'static',
    displayTime: 30,
    repeatCount: 2,
    repeatInterval: 5,
    rollDirection: 'R2L'
  };
  function createDanmakuCtrl(api) {
    var lastConfig = DANMAKU_CONFIGS;
    function setDanmaku(_x14) {
      return _setDanmaku.apply(this, arguments);
    }
    function _setDanmaku() {
      _setDanmaku = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee15(config) {
        var finalConfig, type, position, displayTime, repeatCount, repeatInterval, rollDirection;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              log$a('setDanmaku()');
              finalConfig = Object.spread({}, lastConfig, {
                config: config
              });
              type = finalConfig.type, position = finalConfig.position, displayTime = finalConfig.displayTime, repeatCount = finalConfig.repeatCount, repeatInterval = finalConfig.repeatInterval, rollDirection = finalConfig.rollDirection;
              _context15.next = 5;
              return api.request('setTitle').data({
                type: type,
                position: position,
                'display-time': displayTime,
                'repeat-count': repeatCount,
                'repeat-interval': repeatInterval,
                'roll-direction': rollDirection
              }).send();
            case 5:
              lastConfig = finalConfig;
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return _setDanmaku.apply(this, arguments);
    }
    function sendDanmaku(_x15, _x16) {
      return _sendDanmaku.apply(this, arguments);
    }
    function _sendDanmaku() {
      _sendDanmaku = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee16(msg, options) {
        var _ref9, _ref9$attendee, attendee, _ref9$castviewer, castviewer, _ref9$presenter, presenter;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              log$a('sendDanmaku()');
              _ref9 = options || {}, _ref9$attendee = _ref9.attendee, attendee = _ref9$attendee === void 0 ? true : _ref9$attendee, _ref9$castviewer = _ref9.castviewer, castviewer = _ref9$castviewer === void 0 ? true : _ref9$castviewer, _ref9$presenter = _ref9.presenter, presenter = _ref9$presenter === void 0 ? true : _ref9$presenter;
              _context16.next = 4;
              return api.request('sendTitle').data({
                'display-text': msg,
                'all-attendee': attendee,
                'all-castviewer': castviewer,
                'all-presenter': presenter
              });
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      return _sendDanmaku.apply(this, arguments);
    }
    return {
      setDanmaku: setDanmaku,
      sendDanmaku: sendDanmaku
    };
  }
  var log$b = browser('MN:Information:View');
  function createView(data, context) {
    var api = context.api;
    var events = createEvents(log$b);
    /* eslint-disable-next-line no-use-before-define */
    var reactive = createReactive(watch({}), events);
    var layout = createLayoutCtrl(api);
    var danmaku = createDanmakuCtrl(api);
    var view;
    function watch(target) {
      /* eslint-disable no-use-before-define */
      target.focusUserEntity = getFocusUserEntity();
      /* eslint-enable no-use-before-define */
      return target;
    }
    function update(diff) {
      // fire status change events
      watch(reactive);
      events.emit('updated', view);
    }
    function getVideoView() {
      return data['entity-view'].find(function (view) {
        return view.entity === 'audio-video';
      });
    }
    function getLayout() {
      return getVideoView()['entity-state'];
    }
    function getFocusUserEntity() {
      return getLayout()['focus-video-user-entity'];
    }
    function getDanmaku() {
      return getVideoView().title;
    }
    return view = Object.spread({}, events, {
      get data() {
        return data;
      },
      get: function get(key) {
        return data[key];
      }
    }, layout, danmaku, {
      update: update,
      getVideoView: getVideoView,
      getLayout: getLayout,
      getFocusUserEntity: getFocusUserEntity,
      getDanmaku: getDanmaku
    });
  }
  var log$c = browser('MN:Information:Camera');
  var ActionTypes;
  (function (ActionTypes) {
    ActionTypes["LEFT"] = "PanLeft";
    ActionTypes["RIGHT"] = "PanRight";
    ActionTypes["DOWN"] = "TiltDown";
    ActionTypes["UP"] = "TiltUp";
    ActionTypes["ZOOMOUT"] = "ZoomOut";
    ActionTypes["ZOOMIN"] = "ZoomIn";
    ActionTypes["FOCUSOUT"] = "FocusOut";
    ActionTypes["FOCUSIN"] = "FocusIn";
  })(ActionTypes || (ActionTypes = {}));
  function createCameraCtrl(api, entity) {
    function action(_x17) {
      return _action.apply(this, arguments);
    }
    function _action() {
      _action = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee17(type) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              log$c('action()');
              _context17.next = 3;
              return api.request('setFecc').data({
                'user-entity': entity,
                action: type
              }).send();
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      return _action.apply(this, arguments);
    }
    function left() {
      log$c('left()');
      return action(ActionTypes.LEFT);
    }
    function right() {
      log$c('right()');
      return action(ActionTypes.RIGHT);
    }
    function down() {
      log$c('down()');
      return action(ActionTypes.DOWN);
    }
    function up() {
      log$c('up()');
      return action(ActionTypes.UP);
    }
    function zoomout() {
      log$c('zoomout()');
      return action(ActionTypes.ZOOMOUT);
    }
    function zoomin() {
      log$c('zoomin()');
      return action(ActionTypes.ZOOMIN);
    }
    function focusout() {
      log$c('focusout()');
      return action(ActionTypes.FOCUSOUT);
    }
    function focusin() {
      log$c('focusin()');
      return action(ActionTypes.FOCUSIN);
    }
    return {
      action: action,
      left: left,
      right: right,
      down: down,
      up: up,
      zoomout: zoomout,
      zoomin: zoomin,
      focusout: focusout,
      focusin: focusin
    };
  }
  var log$d = browser('MN:Information:User');
  function createUser(data, context) {
    var api = context.api,
      userId = context.userId;
    var events = createEvents(log$d);
    /* eslint-disable-next-line no-use-before-define */
    var reactive = createReactive(watch({}), events);
    /* eslint-disable-next-line no-use-before-define */
    var entity = getEntity();
    var camera = createCameraCtrl(api, entity);
    var user;
    function watch(target) {
      /* eslint-disable no-use-before-define */
      target.displayText = data['display-text'];
      target.role = getRole();
      target.hold = isOnHold();
      target.audio = !isAudioBlocked();
      target.video = !isVideoBlocked();
      target.handup = isHandup();
      target.media = hasMedia();
      target.sharing = isSharing();
      /* eslint-enable no-use-before-define */
      return target;
    }
    function update(diff) {
      if (diff && (diff.state === 'full' || !data)) {
        data = diff;
      }
      // fire status change events
      watch(reactive);
      events.emit('updated', user);
    }
    function getEntity() {
      return data.entity;
    }
    function getUID() {
      return data['subject-id'];
    }
    function getDisplayText() {
      return data['display-text'];
    }
    function getRole() {
      return data.roles && data.roles.role;
    }
    function isCurrent() {
      return entity === userId;
    }
    function isAttendee() {
      return getRole() === 'attendee';
    }
    function isPresenter() {
      return getRole() === 'presenter';
    }
    function isCastviewer() {
      return getRole() === 'castviewer';
    }
    function isOrganizer() {
      return getRole() === 'organizer';
    }
    function getEndpoint(type) {
      return data.endpoint.find(function (ep) {
        return ep['session-type'] === type;
      });
    }
    function isOnHold() {
      var endpoint = getEndpoint('audio-video');
      return !!endpoint && endpoint.status === 'on-hold';
    }
    function hasFocus() {
      return !!getEndpoint('focus');
    }
    function hasMedia() {
      return !!getEndpoint('audio-video');
    }
    function hasSharing() {
      return !!getEndpoint('applicationsharing');
    }
    function hasFECC() {
      return !!getEndpoint('fecc');
    }
    function getMedia(label) {
      var mediaList = data.endpoint.reduce(function (previous, current) {
        return previous.concat(current.media || []);
      }, []);
      return mediaList.find(function (m) {
        return m.label === label;
      });
    }
    function getMediaFilter(label) {
      var media = getMedia(label);
      var _ref10 = media || {},
        _ref10$mediaIngress = _ref10['media-ingress-filter'],
        ingress = _ref10$mediaIngress === void 0 ? {
          type: 'unblock'
        } : _ref10$mediaIngress,
        _ref10$mediaEgressF = _ref10['media-egress-filter'],
        egress = _ref10$mediaEgressF === void 0 ? {
          type: 'unblock'
        } : _ref10$mediaEgressF;
      return {
        ingress: ingress.type,
        egress: egress.type
      };
    }
    function getAudioFilter() {
      return getMediaFilter('main-audio');
    }
    function getVideoFilter() {
      return getMediaFilter('main-video');
    }
    function isAudioBlocked() {
      var _getAudioFilter = getAudioFilter(),
        ingress = _getAudioFilter.ingress;
      return ingress === 'block';
    }
    function isVideoBlocked() {
      var _getVideoFilter = getVideoFilter(),
        ingress = _getVideoFilter.ingress;
      return ingress === 'block';
    }
    function isHandup() {
      var _getAudioFilter2 = getAudioFilter(),
        ingress = _getAudioFilter2.ingress;
      return ingress === 'unblocking';
    }
    function isSharing() {
      var media = getMedia('applicationsharing');
      return !!media && media.status === 'sendonly';
    }
    function isSIP() {
      return data.protocol.toLowerCase() === 'sip';
    }
    function isHTTP() {
      return data.protocol.toLowerCase() === 'http';
    }
    function isRTMP() {
      return data.protocol.toLowerCase() === 'rtmp';
    }
    // user ctrl
    function setFilter(_x18) {
      return _setFilter.apply(this, arguments);
    }
    function _setFilter() {
      _setFilter = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee18(options) {
        var label, enable, endpoint, media;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              log$d('setFilter()');
              label = options.label, enable = options.enable;
              endpoint = user.getEndpoint('audio-video');
              media = user.getMedia(label);
              _context18.next = 6;
              return api.request('setUserMedia').data({
                'user-entity': entity,
                'endpoint-entity': endpoint.entity,
                'media-id': media.id,
                'media-ingress-filter': enable ? 'unblock' : 'block'
              }).send();
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      return _setFilter.apply(this, arguments);
    }
    function setAudioFilter(_x19) {
      return _setAudioFilter.apply(this, arguments);
    }
    function _setAudioFilter() {
      _setAudioFilter = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee19(enable) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              log$d('setAudioFilter()');
              _context19.next = 3;
              return setFilter({
                label: 'main-audio',
                enable: enable
              });
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return _setAudioFilter.apply(this, arguments);
    }
    function setVideoFilter(_x20) {
      return _setVideoFilter.apply(this, arguments);
    }
    function _setVideoFilter() {
      _setVideoFilter = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee20(enable) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              log$d('setVideoFilter()');
              _context20.next = 3;
              return setFilter({
                label: 'main-video',
                enable: enable
              });
            case 3:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return _setVideoFilter.apply(this, arguments);
    }
    function setDisplayText(_x21) {
      return _setDisplayText.apply(this, arguments);
    }
    function _setDisplayText() {
      _setDisplayText = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee21(displayText) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              log$d('setDisplayText()');
              _context21.next = 3;
              return api.request('setUserDisplayText').data({
                'user-entity': entity,
                'display-text': displayText
              }).send();
            case 3:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      return _setDisplayText.apply(this, arguments);
    }
    function setRole(_x22) {
      return _setRole.apply(this, arguments);
    }
    function _setRole() {
      _setRole = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee22(role) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              log$d('setRole()');
              _context22.next = 3;
              return api.request('setUserRole').data({
                'user-entity': entity,
                role: role
              }).send();
            case 3:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      return _setRole.apply(this, arguments);
    }
    function setFocus() {
      return _setFocus.apply(this, arguments);
    }
    function _setFocus() {
      _setFocus = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee23() {
        var enable,
          _args23 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              enable = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : true;
              log$d('setFocus()');
              _context23.next = 4;
              return api.request('setFocusVideo').data({
                'user-entity': enable ? entity : ''
              }).send();
            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
      return _setFocus.apply(this, arguments);
    }
    function getStats() {
      return _getStats.apply(this, arguments);
    }
    function _getStats() {
      _getStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee24() {
        var _yield$api$request$da, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              log$d('getStats()');
              _context24.next = 3;
              return api.request('getStats').data({
                'user-entity-list': [entity]
              }).send();
            case 3:
              _yield$api$request$da = _context24.sent;
              data = _yield$api$request$da.data;
              return _context24.abrupt("return", data);
            case 6:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }));
      return _getStats.apply(this, arguments);
    }
    function kick() {
      return _kick.apply(this, arguments);
    }
    function _kick() {
      _kick = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee25() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              log$d('kick()');
              _context25.next = 3;
              return api.request('deleteUser').data({
                'user-entity': entity
              }).send();
            case 3:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }));
      return _kick.apply(this, arguments);
    }
    function hold() {
      return _hold.apply(this, arguments);
    }
    function _hold() {
      _hold = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee26() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              log$d('hold()');
              _context26.next = 3;
              return api.request('waitLobbyUser').data({
                'user-entity': entity
              }).send();
            case 3:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }));
      return _hold.apply(this, arguments);
    }
    function unhold() {
      return _unhold.apply(this, arguments);
    }
    function _unhold() {
      _unhold = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee27() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              log$d('unhold()');
              _context27.next = 3;
              return api.request('acceptLobbyUser').data({
                'user-entity': entity
              }).send();
            case 3:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }));
      return _unhold.apply(this, arguments);
    }
    function allow() {
      return _allow.apply(this, arguments);
    }
    function _allow() {
      _allow = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee28() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              log$d('allow()');
              _context28.next = 3;
              return api.request('acceptLobbyUser').data({
                'user-entity': entity
              }).send();
            case 3:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }));
      return _allow.apply(this, arguments);
    }
    function accept() {
      return _accept.apply(this, arguments);
    }
    function _accept() {
      _accept = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee29() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              log$d('accept()');
              _context29.next = 3;
              return setAudioFilter(true);
            case 3:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }));
      return _accept.apply(this, arguments);
    }
    function reject() {
      return _reject.apply(this, arguments);
    }
    function _reject() {
      _reject = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee30() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              log$d('reject()');
              _context30.next = 3;
              return setAudioFilter(false);
            case 3:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }));
      return _reject.apply(this, arguments);
    }
    function sendMessage(_x23) {
      return _sendMessage.apply(this, arguments);
    }
    function _sendMessage() {
      _sendMessage = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee31(msg) {
        var chatChannel;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              log$d('sendMessage()');
              chatChannel = context.chatChannel;
              if (!(chatChannel && chatChannel.ready)) {
                _context31.next = 5;
                break;
              }
              _context31.next = 5;
              return chatChannel.sendMessage(msg, [entity]);
            case 5:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }));
      return _sendMessage.apply(this, arguments);
    }
    return user = Object.spread({}, events, {
      get data() {
        return data;
      },
      get: function get(key) {
        return data[key];
      },
      update: update,
      getEntity: getEntity,
      getUID: getUID,
      getDisplayText: getDisplayText,
      getRole: getRole,
      isCurrent: isCurrent,
      isAttendee: isAttendee,
      isPresenter: isPresenter,
      isCastviewer: isCastviewer,
      isOrganizer: isOrganizer,
      getEndpoint: getEndpoint,
      isOnHold: isOnHold,
      hasFocus: hasFocus,
      hasMedia: hasMedia,
      hasSharing: hasSharing,
      hasFECC: hasFECC,
      getMedia: getMedia,
      getAudioFilter: getAudioFilter,
      getVideoFilter: getVideoFilter,
      isAudioBlocked: isAudioBlocked,
      isVideoBlocked: isVideoBlocked,
      isHandup: isHandup,
      isSharing: isSharing,
      isSIP: isSIP,
      isHTTP: isHTTP,
      isRTMP: isRTMP,
      // user ctrl
      setFilter: setFilter,
      setAudioFilter: setAudioFilter,
      setVideoFilter: setVideoFilter,
      setDisplayText: setDisplayText,
      setRole: setRole,
      setFocus: setFocus,
      getStats: getStats,
      kick: kick,
      hold: hold,
      unhold: unhold,
      allow: allow,
      accept: accept,
      reject: reject,
      sendMessage: sendMessage,
      // camera ctrl
      camera: camera
    });
  }
  var log$e = browser('MN:Information:Lobby');
  function createLobbyCtrl(api) {
    function remove(_x24) {
      return _remove.apply(this, arguments);
    }
    function _remove() {
      _remove = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee32(entity) {
        var apiName;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              log$e('remove()');
              apiName = entity ? 'deleteUser' : 'rejectLobbyUserAll';
              _context32.next = 4;
              return api.request(apiName).data({
                'user-entity': entity
              }).send();
            case 4:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }));
      return _remove.apply(this, arguments);
    }
    function unhold(_x25) {
      return _unhold2.apply(this, arguments);
    }
    function _unhold2() {
      _unhold2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee33(entity) {
        var apiName;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              log$e('unhold()');
              apiName = entity ? 'acceptLobbyUser' : 'acceptLobbyUserAll';
              _context33.next = 4;
              return api.request(apiName).data({
                'user-entity': entity
              }).send();
            case 4:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }));
      return _unhold2.apply(this, arguments);
    }
    function allow(_x26) {
      return _allow2.apply(this, arguments);
    }
    function _allow2() {
      _allow2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee34(entity) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              log$e('allow()');
              _context34.next = 3;
              return unhold(entity);
            case 3:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }));
      return _allow2.apply(this, arguments);
    }
    function hold(_x27) {
      return _hold2.apply(this, arguments);
    }
    function _hold2() {
      _hold2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee35(entity) {
        var apiName;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              log$e('hold()');
              apiName = entity ? 'waitLobbyUser' : 'waitLobbyUserAll';
              _context35.next = 4;
              return api.request(apiName).data({
                'user-entity': entity
              }).send();
            case 4:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }));
      return _hold2.apply(this, arguments);
    }
    return {
      remove: remove,
      unhold: unhold,
      hold: hold,
      allow: allow
    };
  }
  var log$f = browser('MN:Information:Users');
  function createUsers(data, context) {
    var api = context.api;
    var events = createEvents(log$f);
    var userMap = new Map();
    var userList;
    var users;
    /* eslint-disable-next-line no-use-before-define */
    var reactive = createReactive(watch({}), events);
    var lobby = createLobbyCtrl(api);
    function watch(target) {
      /* eslint-disable no-use-before-define */
      // update user list
      userList = data.user.map(function (userdata) {
        var entity = userdata.entity;
        var user = userMap.get(entity);
        if (!user) {
          user = createUser(userdata, context);
          userMap.set(entity, user);
        }
        return user;
      });
      /* eslint-enable no-use-before-define */
      return target;
    }
    function update(diff) {
      var added = [];
      var updated = [];
      var deleted = [];
      if (diff) {
        var user = diff.user;
        /* eslint-disable no-use-before-define */
        user.forEach(function (userdata) {
          var entity = userdata.entity,
            state = userdata.state;
          hasUser(entity) ? state === 'deleted' ? deleted.push(userdata) : updated.push(userdata) : added.push(userdata);
        });
        /* eslint-enable no-use-before-define */
      }
      // fire status change events
      watch(reactive);
      added.forEach(function (userdata) {
        var entity = userdata.entity;
        var user = userMap.get(entity);
        log$f('added user:\n\n %s(%s) \n', user.getDisplayText(), user.getEntity());
        users.emit('user:added', user);
      });
      updated.forEach(function (userdata) {
        var entity = userdata.entity;
        var user = userMap.get(entity);
        // user data is not proxied, so update it here
        // if user data is 'full', it will replace the old one
        user.update(userdata);
        log$f('updated user:\n\n %s(%s)  \n', user.getDisplayText(), user.getEntity());
        users.emit('user:updated', user);
      });
      deleted.forEach(function (userdata) {
        var entity = userdata.entity;
        var user = userMap.get(entity);
        log$f('deleted user:\n\n %s(%s)  \n', user.getDisplayText(), user.getEntity());
        users.emit('user:deleted', user);
        userMap.delete(entity);
      });
      // updated event must come after watch()
      // as user can access userlit via updated event
      events.emit('updated', users);
    }
    function getUserList(filter) {
      return filter ? userList.filter(filter) : userList;
    }
    function getUser(entity) {
      return userMap.get(entity);
    }
    function hasUser(entity) {
      return userMap.has(entity);
    }
    function getCurrent() {
      return userList.find(function (user) {
        return user.isCurrent();
      });
    }
    function getAttendee() {
      return userList.filter(function (user) {
        return user.isAttendee() && !user.isOnHold();
      });
    }
    function getPresenter() {
      return userList.filter(function (user) {
        return user.isPresenter();
      });
    }
    function getCastviewer() {
      return userList.filter(function (user) {
        return user.isCastviewer();
      });
    }
    function getOrganizer() {
      return userList.filter(function (user) {
        return user.isOrganizer();
      });
    }
    function getOnhold() {
      return userList.filter(function (user) {
        return user.isOnHold();
      });
    }
    function getHandup() {
      return userList.filter(function (user) {
        return user.isHandup();
      });
    }
    function getSharing() {
      return userList.filter(function (user) {
        return user.isSharing();
      });
    }
    function getAudioBlocked() {
      return userList.filter(function (user) {
        return user.isAudioBlocked();
      });
    }
    function getVideoBlocked() {
      return userList.filter(function (user) {
        return user.isVideoBlocked();
      });
    }
    function getSIP() {
      return userList.filter(function (user) {
        return user.isSIP();
      });
    }
    function getHTTP() {
      return userList.filter(function (user) {
        return user.isHTTP();
      });
    }
    function getRTMP() {
      return userList.filter(function (user) {
        return user.isRTMP();
      });
    }
    function invite(_x28) {
      return _invite.apply(this, arguments);
    }
    function _invite() {
      _invite = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee36(option) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              log$f('invite');
              _context36.next = 3;
              return api.request('inviteUser').data({
                uid: option.uid,
                'sip-url': option.sipURL,
                'h323-url': option.h323URL
              }).send();
            case 3:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      return _invite.apply(this, arguments);
    }
    function kick(_x29) {
      return _kick2.apply(this, arguments);
    }
    function _kick2() {
      _kick2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee37(entity) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              log$f('kick');
              _context37.next = 3;
              return api.request('deleteUser').data({
                'user-entity': entity
              }).send();
            case 3:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }));
      return _kick2.apply(this, arguments);
    }
    function mute() {
      return _mute.apply(this, arguments);
    }
    function _mute() {
      _mute = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee38() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              log$f('mute');
              _context38.next = 3;
              return api.request('muteAll').send();
            case 3:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      }));
      return _mute.apply(this, arguments);
    }
    function unmute() {
      return _unmute.apply(this, arguments);
    }
    function _unmute() {
      _unmute = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee39() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              log$f('unmute');
              _context39.next = 3;
              return api.request('unmuteAll').send();
            case 3:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
      return _unmute.apply(this, arguments);
    }
    function reject() {
      return _reject2.apply(this, arguments);
    }
    function _reject2() {
      _reject2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee40() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              log$f('reject');
              _context40.next = 3;
              return api.request('rejectHandupAll').send();
            case 3:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }));
      return _reject2.apply(this, arguments);
    }
    return users = Object.spread({}, events, {
      get data() {
        return data;
      },
      get: function get(key) {
        return data[key];
      }
    }, lobby, {
      update: update,
      getUserList: getUserList,
      getUser: getUser,
      hasUser: hasUser,
      getCurrent: getCurrent,
      getAttendee: getAttendee,
      getPresenter: getPresenter,
      getCastviewer: getCastviewer,
      getOrganizer: getOrganizer,
      getOnhold: getOnhold,
      getHandup: getHandup,
      getSharing: getSharing,
      getAudioBlocked: getAudioBlocked,
      getVideoBlocked: getVideoBlocked,
      getSIP: getSIP,
      getHTTP: getHTTP,
      getRTMP: getRTMP,
      invite: invite,
      kick: kick,
      mute: mute,
      unmute: unmute,
      reject: reject
    });
  }
  var log$g = browser('MN:Information:RTMP');
  var RTMPOperationTypes;
  (function (RTMPOperationTypes) {
    RTMPOperationTypes["START"] = "start";
    RTMPOperationTypes["STOP"] = "stop";
    RTMPOperationTypes["PAUSE"] = "pause";
    RTMPOperationTypes["RESUME"] = "resume";
  })(RTMPOperationTypes || (RTMPOperationTypes = {}));
  function createRTMPCtrl(api) {
    function operation(_x30) {
      return _operation.apply(this, arguments);
    }
    function _operation() {
      _operation = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee41(type) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              log$g('operation');
              _context41.next = 3;
              return api.request('setRTMP').data({
                operate: type
              }).send();
            case 3:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
      return _operation.apply(this, arguments);
    }
    function start() {
      log$g('start');
      return operation(RTMPOperationTypes.START);
    }
    function stop() {
      log$g('stop');
      return operation(RTMPOperationTypes.STOP);
    }
    function pause() {
      log$g('pause');
      return operation(RTMPOperationTypes.PAUSE);
    }
    function resume() {
      log$g('resume');
      return operation(RTMPOperationTypes.RESUME);
    }
    return {
      operation: operation,
      start: start,
      stop: stop,
      pause: pause,
      resume: resume
    };
  }
  var log$h = browser('MN:Information:RTMP');
  function createRTMP(data, context) {
    var api = context.api;
    var events = createEvents(log$h);
    /* eslint-disable-next-line no-use-before-define */
    var reactive = createReactive(watch({}), events);
    var ctrl = createRTMPCtrl(api);
    var rtmp;
    function watch(target) {
      /* eslint-disable no-use-before-define */
      target.enable = getEnable();
      target.status = getStatus();
      /* eslint-enable no-use-before-define */
      return target;
    }
    function update(diff) {
      // fire status change events
      watch(reactive);
      events.emit('updated', rtmp);
    }
    function getUser(entity) {
      return entity ? data.users.find(function (userdata) {
        return userdata.entity === entity;
      }) : data.users.find(function (userdata) {
        return userdata.default;
      }) || data.users[0];
    }
    function getEnable() {
      return data['rtmp-enable'];
    }
    function getStatus(entity) {
      var userdata = getUser(entity);
      return userdata && userdata['rtmp-status'];
    }
    function getReason(entity) {
      var userdata = getUser(entity);
      return userdata && userdata.reason;
    }
    function getDetail(entity) {
      var userdata = getUser(entity);
      if (!userdata) {
        return undefined;
      }
      var status = userdata['rtmp-status'],
        lastStartTime = userdata['rtmp-last-start-time'],
        lastStopDuration = userdata['rtmp-last-stop-duration'],
        reason = userdata.reason;
      return {
        reason: reason,
        status: status,
        lastStartTime: lastStartTime,
        lastStopDuration: lastStopDuration
      };
    }
    return rtmp = Object.spread({}, events, {
      get data() {
        return data;
      },
      get: function get(key) {
        return data[key];
      },
      update: update,
      getEnable: getEnable,
      getStatus: getStatus,
      getReason: getReason,
      getDetail: getDetail
    },
    // rtmp ctrl
    ctrl);
  }
  var log$i = browser('MN:Information:Record');
  var RecordOperationTypes;
  (function (RecordOperationTypes) {
    RecordOperationTypes["START"] = "start";
    RecordOperationTypes["STOP"] = "stop";
    RecordOperationTypes["PAUSE"] = "pause";
    RecordOperationTypes["RESUME"] = "resume";
  })(RecordOperationTypes || (RecordOperationTypes = {}));
  function createRecordCtrl(api) {
    function operation(_x31) {
      return _operation2.apply(this, arguments);
    }
    function _operation2() {
      _operation2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee42(type) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return api.request('setRecord').data({
                operate: type
              }).send();
            case 2:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }));
      return _operation2.apply(this, arguments);
    }
    function start() {
      log$i('start()');
      return operation(RecordOperationTypes.START);
    }
    function stop() {
      log$i('stop()');
      return operation(RecordOperationTypes.STOP);
    }
    function pause() {
      log$i('pause()');
      return operation(RecordOperationTypes.PAUSE);
    }
    function resume() {
      log$i('resume()');
      return operation(RecordOperationTypes.RESUME);
    }
    return {
      operation: operation,
      start: start,
      stop: stop,
      pause: pause,
      resume: resume
    };
  }
  var log$j = browser('MN:Information:Record');
  function createRecord(data, context) {
    var api = context.api;
    var events = createEvents(log$j);
    /* eslint-disable-next-line no-use-before-define */
    var reactive = createReactive(watch({}), events);
    var ctrl = createRecordCtrl(api);
    var record;
    function watch(target) {
      /* eslint-disable no-use-before-define */
      target.status = getStatus();
      /* eslint-enable no-use-before-define */
      return target;
    }
    function update(diff) {
      // fire status change events
      watch(reactive);
      events.emit('updated', record);
    }
    function getUser() {
      return data.user;
    }
    function getStatus() {
      return getUser()['record-status'];
    }
    function getReason() {
      return getUser().reason;
    }
    function getDetail() {
      var userdata = getUser();
      var status = userdata['record-status'],
        lastStartTime = userdata['record-last-start-time'],
        lastStopDuration = userdata['record-last-stop-duration'],
        reason = userdata.reason;
      return {
        reason: reason,
        status: status,
        lastStartTime: lastStartTime,
        lastStopDuration: lastStopDuration
      };
    }
    return record = Object.spread({}, events, {
      get data() {
        return data;
      },
      get: function get(key) {
        return data[key];
      },
      update: update,
      getStatus: getStatus,
      getReason: getReason,
      getDetail: getDetail
    },
    // record ctrl
    ctrl);
  }
  var log$k = browser('MN:Information:Item');
  function isItem(item) {
    return isDef(item) && isObject$1(item) && !isArray$1(item);
  }
  function isPartialableItem(item) {
    return isItem(item) && hasOwn(item, 'state');
  }
  function mergeItemList(rhys, items) {
    log$k('mergelist()');
    var _iterator2 = (0, _createForOfIteratorHelper2.default)(items),
      _step2;
    try {
      var _loop2 = function _loop2() {
        var item = _step2.value;
        if (!isPartialableItem(item)) {
          log$k('we don not know how to process a non-partialable item in a list, because it is undocumented');
          log$k('treat it as full state item');
        }
        var id = item.id,
          entity = item.entity,
          _item$state = item.state,
          state = _item$state === void 0 ? 'full' : _item$state;
        var key = entity || id;
        if (!key) {
          log$k('missing item identity(entity or id).');
          return "continue";
        }
        var index = rhys.findIndex(function (it) {
          return it.entity === key || it.id === key;
        });
        log$k('item identity: %o', key);
        // not find
        if (index === -1) {
          if (state === 'deleted') {
            log$k('can not delete item not exist.');
            return "continue";
          }
          log$k('item added');
          rhys.push(item);
          return "continue";
        }
        // finded
        // this is weird as we don't know whether the item list is partial or not
        if (state === 'full') {
          rhys.splice(index, 1, item);
          return "continue";
        }
        // wanna delete
        if (state === 'deleted') {
          log$k('item deleted');
          rhys.splice(index, 1);
          return "continue";
        }
        // wanna update
        /* eslint-disable-next-line no-use-before-define */
        mergeItem(rhys[index], item);
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _ret = _loop2();
        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return rhys;
  }
  function mergeItem(rhys, item) {
    log$k('merge()');
    if (rhys === item) {
      return rhys;
    }
    if (!isPartialableItem(item)) {
      return item;
    }
    var state = item.state;
    if (state === 'full') {
      return item;
    }
    if (state === 'deleted') {
      return null;
    }
    if (state !== 'partial') {
      log$k("Error: unknown item state. ".concat(state));
      log$k('use merge policy as "partial"');
    }
    for (var key in item) {
      if (hasOwn(item, key)) {
        var value = item[key];
        var current = rhys[key];
        log$k('item key: %s value: %o -> %o', key, current, value);
        rhys[key] = isArray$1(value) ? mergeItemList(current, value) : isItem(value) ? mergeItem(current, value) : value;
      }
    }
    return rhys;
  }
  var log$l = browser('MN:Information');
  function createInformation(data, context) {
    var events = createEvents(log$l);
    var api = context.api;
    function createdata(datakey) {
      return new Proxy({}, {
        get: function get(target, key) {
          var delegate = data[datakey];
          return delegate && Reflect.get(delegate, key);
        }
      });
    }
    // create information parts
    var description = createDescription(createdata('conference-description'), context);
    var state = createState(createdata('conference-state'));
    var view = createView(createdata('conference-view'), context);
    var users = createUsers(createdata('users'), context);
    var rtmp = createRTMP(createdata('rtmp-state'), context);
    var record = createRecord(createdata('record-users'), context);
    var information;
    function update(val) {
      log$l('update()');
      var version = data.version;
      var newVersion = val.version,
        newState = val.state;
      if (!newVersion) {
        log$l('receive information without version.');
        return;
      }
      if (newVersion <= version) {
        log$l('receive information with invalid version.');
        return;
      }
      if (newVersion - version > 1) {
        log$l('information version jumped.');
        api.request('getFullInfo').send().then(function (response) {
          return update(response.data.data);
        }).catch(function (error) {
          return log$l('get full information failed: %o', error);
        });
        return;
      }
      if (newState === 'deleted') {
        log$l('can not delete root information.');
        return;
      }
      if (newState === 'full') {
        // hack item state
        // as we want to keep 'data' reference to the same object
        // otherwise we need to re-create all information parts
        Object.assign(data, val);
      } else {
        mergeItem(data, val);
      }
      // update & prepare all parts
      [{
        key: 'conference-description',
        part: description
      }, {
        key: 'conference-state',
        part: state
      }, {
        key: 'conference-view',
        part: view
      }, {
        key: 'users',
        part: users
      }, {
        key: 'rtmp-state',
        part: rtmp
      }, {
        key: 'record-users',
        part: record
      }].forEach(function (parts) {
        var key = parts.key,
          part = parts.part;
        if (hasOwn(val, key)) {
          part.update(val[key]);
        }
      });
      events.emit('updated', information);
    }
    return information = Object.spread({}, events, {
      get data() {
        return data;
      },
      get version() {
        return data && data.version;
      },
      get: function get(key) {
        return data[key];
      },
      get description() {
        return description;
      },
      get state() {
        return state;
      },
      get view() {
        return view;
      },
      get users() {
        return users;
      },
      get rtmp() {
        return rtmp;
      },
      get record() {
        return record;
      },
      update: update
    });
  }

  /* eslint-disable no-useless-escape */
  /* eslint-disable max-len */
  var grammar = {
    v: [{
      name: 'version',
      reg: /^(\d*)$/
    }],
    o: [{
      // NB: sessionId will be a String in most cases because it is huge
      name: 'origin',
      reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
      names: ['username', 'sessionId', 'sessionVersion', 'netType', 'ipVer', 'address'],
      format: '%s %s %d %s IP%d %s'
    }],
    // default parsing of these only (though some of these feel outdated)
    s: [{
      name: 'name'
    }],
    i: [{
      name: 'description'
    }],
    u: [{
      name: 'uri'
    }],
    e: [{
      name: 'email'
    }],
    p: [{
      name: 'phone'
    }],
    z: [{
      name: 'timezones'
    }],
    r: [{
      name: 'repeats'
    }],
    // k: [{}], // outdated thing ignored
    t: [{
      name: 'timing',
      reg: /^(\d*) (\d*)/,
      names: ['start', 'stop'],
      format: '%d %d'
    }],
    c: [{
      name: 'connection',
      reg: /^IN IP(\d) (\S*)/,
      names: ['version', 'ip'],
      format: 'IN IP%d %s'
    }],
    b: [{
      push: 'bandwidth',
      reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
      names: ['type', 'limit'],
      format: '%s:%s'
    }],
    m: [{
      // NB: special - pushes to session
      // TODO: rtp/fmtp should be filtered by the payloads found here?
      reg: /^(\w*) (\d*) ([\w\/]*)(?: (.*))?/,
      names: ['type', 'port', 'protocol', 'payloads'],
      format: '%s %d %s %s'
    }],
    a: [{
      push: 'rtp',
      reg: /^rtpmap:(\d*) ([\w\-\.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
      names: ['payload', 'codec', 'rate', 'encoding'],
      format: function format(o) {
        return o.encoding ? 'rtpmap:%d %s/%s/%s' : o.rate ? 'rtpmap:%d %s/%s' : 'rtpmap:%d %s';
      }
    }, {
      // a=fmtp:111 minptime=10; useinbandfec=1
      push: 'fmtp',
      reg: /^fmtp:(\d*) ([\S| ]*)/,
      names: ['payload', 'config'],
      format: 'fmtp:%d %s'
    }, {
      name: 'control',
      reg: /^control:(.*)/,
      format: 'control:%s'
    }, {
      name: 'rtcp',
      reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
      names: ['port', 'netType', 'ipVer', 'address'],
      format: function format(o) {
        return o.address != null ? 'rtcp:%d %s IP%d %s' : 'rtcp:%d';
      }
    }, {
      push: 'rtcpFbTrrInt',
      reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
      names: ['payload', 'value'],
      format: 'rtcp-fb:%d trr-int %d'
    }, {
      push: 'rtcpFb',
      reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
      names: ['payload', 'type', 'subtype'],
      format: function format(o) {
        return o.subtype != null ? 'rtcp-fb:%s %s %s' : 'rtcp-fb:%s %s';
      }
    }, {
      // a=extmap:1/recvonly URI-gps-string
      push: 'ext',
      reg: /^extmap:(\d+)(?:\/(\w+))? (\S*)(?: (\S*))?/,
      names: ['value', 'direction', 'uri', 'config'],
      format: function format(o) {
        return "extmap:%d".concat(o.direction ? '/%s' : '%v', " %s").concat(o.config ? ' %s' : '');
      }
    }, {
      push: 'crypto',
      reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
      names: ['id', 'suite', 'config', 'sessionConfig'],
      format: function format(o) {
        return o.sessionConfig != null ? 'crypto:%d %s %s %s' : 'crypto:%d %s %s';
      }
    }, {
      name: 'setup',
      reg: /^setup:(\w*)/,
      format: 'setup:%s'
    }, {
      name: 'mid',
      reg: /^mid:([^\s]*)/,
      format: 'mid:%s'
    }, {
      name: 'msid',
      reg: /^msid:(.*)/,
      format: 'msid:%s'
    }, {
      name: 'ptime',
      reg: /^ptime:(\d*)/,
      format: 'ptime:%d'
    }, {
      name: 'maxptime',
      reg: /^maxptime:(\d*)/,
      format: 'maxptime:%d'
    }, {
      name: 'direction',
      reg: /^(sendrecv|recvonly|sendonly|inactive)/
    }, {
      name: 'icelite',
      reg: /^(ice-lite)/
    }, {
      name: 'iceUfrag',
      reg: /^ice-ufrag:(\S*)/,
      format: 'ice-ufrag:%s'
    }, {
      name: 'icePwd',
      reg: /^ice-pwd:(\S*)/,
      format: 'ice-pwd:%s'
    }, {
      name: 'fingerprint',
      reg: /^fingerprint:(\S*) (\S*)/,
      names: ['type', 'hash'],
      format: 'fingerprint:%s %s'
    }, {
      // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
      // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
      // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
      // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
      push: 'candidates',
      reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
      names: ['foundation', 'component', 'transport', 'priority', 'ip', 'port', 'type', 'raddr', 'rport', 'tcptype', 'generation', 'network-id', 'network-cost'],
      format: function format(o) {
        var str = 'candidate:%s %d %s %d %s %d typ %s';
        str += o.raddr != null ? ' raddr %s rport %d' : '%v%v';
        // NB: candidate has three optional chunks, so %void middles one if it's missing
        str += o.tcptype != null ? ' tcptype %s' : '%v';
        if (o.generation != null) {
          str += ' generation %d';
        }
        str += o['network-id'] != null ? ' network-id %d' : '%v';
        str += o['network-cost'] != null ? ' network-cost %d' : '%v';
        return str;
      }
    }, {
      name: 'endOfCandidates',
      reg: /^(end-of-candidates)/
    }, {
      name: 'remoteCandidates',
      reg: /^remote-candidates:(.*)/,
      format: 'remote-candidates:%s'
    }, {
      name: 'iceOptions',
      reg: /^ice-options:(\S*)/,
      format: 'ice-options:%s'
    }, {
      push: 'ssrcs',
      reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
      names: ['id', 'attribute', 'value'],
      format: function format(o) {
        var str = 'ssrc:%d';
        if (o.attribute != null) {
          str += ' %s';
          if (o.value != null) {
            str += ':%s';
          }
        }
        return str;
      }
    }, {
      // a=ssrc-group:FEC-FR 3004364195 1080772241
      push: 'ssrcGroups',
      // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
      reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
      names: ['semantics', 'ssrcs'],
      format: 'ssrc-group:%s %s'
    }, {
      name: 'msidSemantic',
      reg: /^msid-semantic:\s?(\w*) (\S*)/,
      names: ['semantic', 'token'],
      format: 'msid-semantic: %s %s'
    }, {
      push: 'groups',
      reg: /^group:(\w*) (.*)/,
      names: ['type', 'mids'],
      format: 'group:%s %s'
    }, {
      name: 'rtcpMux',
      reg: /^(rtcp-mux)/
    }, {
      name: 'rtcpRsize',
      reg: /^(rtcp-rsize)/
    }, {
      name: 'sctpmap',
      reg: /^sctpmap:([\w_\/]*) (\S*)(?: (\S*))?/,
      names: ['sctpmapNumber', 'app', 'maxMessageSize'],
      format: function format(o) {
        return o.maxMessageSize != null ? 'sctpmap:%s %s %s' : 'sctpmap:%s %s';
      }
    }, {
      name: 'xGoogleFlag',
      reg: /^x-google-flag:([^\s]*)/,
      format: 'x-google-flag:%s'
    }, {
      name: 'content',
      reg: /^content:([^\s]*)/,
      format: 'content:%s'
    }, {
      name: 'label',
      reg: /^label:([\d]*)/,
      format: 'label:%d'
    }, {
      push: 'rids',
      reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
      names: ['id', 'direction', 'params'],
      format: function format(o) {
        return o.params ? 'rid:%s %s %s' : 'rid:%s %s';
      }
    }, {
      // a=imageattr:* send [x=800,y=640] recv *
      // a=imageattr:100 recv [x=320,y=240]
      push: 'imageattrs',
      reg: new RegExp(
      // a=imageattr:97
      '^imageattr:(\\d+|\\*)'
      // send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320]
      + '[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)'
      // recv [x=330,y=250]
      + '(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?'),
      names: ['pt', 'dir1', 'attrs1', 'dir2', 'attrs2'],
      format: function format(o) {
        return "imageattr:%s %s %s".concat(o.dir2 ? ' %s %s' : '');
      }
    }, {
      // a=simulcast:recv 1;4,5 send 6;7
      name: 'simulcast',
      reg: new RegExp(
      // a=simulcast:
      '^simulcast:'
      // send 1,2,3;~4,~5
      + '(send|recv) ([a-zA-Z0-9\\-_~;,]+)'
      // space + recv 6;~7,~8
      + '(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?'
      // end
      + '$'),
      names: ['dir1', 'list1', 'dir2', 'list2'],
      format: function format(o) {
        return "simulcast:%s %s".concat(o.dir2 ? ' %s %s' : '');
      }
    }, {
      //  https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
      // a=simulcast: recv pt=97;98 send pt=97
      // a=simulcast: send rid=5;6;7 paused=6,7
      name: 'simulcast_03',
      reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
      names: ['value'],
      format: 'simulcast: %s'
    }, {
      // a=framerate:25
      // a=framerate:29.97
      name: 'framerate',
      reg: /^framerate:(\d+(?:$|\.\d+))/,
      format: 'framerate:%s'
    }, {
      // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
      name: 'sourceFilter',
      reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
      names: ['filterMode', 'netType', 'addressTypes', 'destAddress', 'srcList'],
      format: 'source-filter: %s %s %s %s %s'
    }, {
      push: 'invalid',
      names: ['value']
    }]
  };
  // set sensible defaults to avoid polluting the grammar with boring details
  Object.keys(grammar).forEach(function (key) {
    var objs = grammar[key];
    objs.forEach(function (obj) {
      if (!obj.reg) {
        obj.reg = /(.*)/;
      }
      if (!obj.format) {
        obj.format = '%s';
      }
    });
  });

  /* eslint-disable no-useless-escape */
  function toIntIfInt(v) {
    return String(Number(v)) === v ? Number(v) : v;
  }
  function attachProperties(match, location, names, rawName) {
    if (rawName && !names) {
      location[rawName] = toIntIfInt(match[1]);
    } else {
      for (var i = 0; i < names.length; i += 1) {
        if (match[i + 1] != null) {
          location[names[i]] = toIntIfInt(match[i + 1]);
        }
      }
    }
  }
  function parseReg(obj, location, content) {
    var needsBlank = obj.name && obj.names;
    if (obj.push && !location[obj.push]) {
      location[obj.push] = [];
    } else if (needsBlank && !location[obj.name]) {
      location[obj.name] = {};
    }
    var keyLocation = obj.push ? {} // blank object that will be pushed
    : needsBlank ? location[obj.name] : location; // otherwise, named location or root
    attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
    if (obj.push) {
      location[obj.push].push(keyLocation);
    }
  }
  var validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
  function parse$1(sdp) {
    var media = [];
    var session = {
      media: media
    };
    var location = session; // points at where properties go under (one of the above)
    // parse lines we understand
    sdp.split(/(\r\n|\r|\n)/).filter(validLine).forEach(function (l) {
      var type = l[0];
      var content = l.slice(2);
      if (type === 'm') {
        media.push({
          rtp: [],
          fmtp: []
        });
        location = media[media.length - 1]; // point at latest media line
      }

      for (var j = 0; j < (grammar[type] || []).length; j += 1) {
        var obj = grammar[type][j];
        if (obj.reg.test(content)) {
          parseReg(obj, location, content);
          return;
        }
      }
    });
    session.media = media; // link it up
    return session;
  }

  // customized util.format - discards excess arguments and can void middle ones
  var formatRegExp = /%[sdv%]/g;
  var format = function format(formatStr) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }
    var i = 0;
    var len = args.length;
    return formatStr.replace(formatRegExp, function (x) {
      if (i >= len) {
        return x; // missing argument
      }

      var arg = args[i];
      i += 1;
      switch (x) {
        case '%%':
          return '%';
        case '%s':
          return String(arg);
        case '%d':
          return Number(arg);
        case '%v':
          return '';
        default:
          return arg;
      }
    });
    // NB: we discard excess arguments - they are typically undefined from makeLine
  };

  var makeLine = function makeLine(type, obj, location) {
    var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
    var formatStr = "".concat(type, "=").concat(str);
    var args = [];
    if (obj.names) {
      for (var i = 0; i < obj.names.length; i += 1) {
        var n = obj.names[i];
        if (obj.name) {
          args.push(location[obj.name][n]);
        } else {
          // for mLine and push attributes
          args.push(location[obj.names[i]]);
        }
      }
    } else {
      args.push(location[obj.name]);
    }
    return format.apply(void 0, [formatStr].concat(args));
  };
  // RFC specified order
  // TODO: extend this with all the rest
  var defaultOuterOrder = ['v', 'o', 's', 'i', 'u', 'e', 'p', 'c', 'b', 't', 'r', 'z', 'a'];
  var defaultInnerOrder = ['i', 'c', 'b', 'a'];
  function write(session, opts) {
    opts = opts || {};
    // ensure certain properties exist
    if (session.version == null) {
      session.version = 0; // 'v=0' must be there (only defined version atm)
    }

    if (session.name == null) {
      session.name = ' '; // 's= ' must be there if no meaningful name set
    }

    session.media.forEach(function (mLine) {
      if (mLine.payloads == null) {
        mLine.payloads = '';
      }
    });
    var outerOrder = opts.outerOrder || defaultOuterOrder;
    var innerOrder = opts.innerOrder || defaultInnerOrder;
    var sdp = [];
    // loop through outerOrder for matching properties on session
    outerOrder.forEach(function (type) {
      grammar[type].forEach(function (obj) {
        if (obj.name in session && session[obj.name] != null) {
          sdp.push(makeLine(type, obj, session));
        } else if (obj.push in session && session[obj.push] != null) {
          session[obj.push].forEach(function (el) {
            sdp.push(makeLine(type, obj, el));
          });
        }
      });
    });
    // then for each media line, follow the innerOrder
    session.media.forEach(function (mLine) {
      sdp.push(makeLine('m', grammar.m[0], mLine));
      innerOrder.forEach(function (type) {
        grammar[type].forEach(function (obj) {
          if (obj.name in mLine && mLine[obj.name] != null) {
            sdp.push(makeLine(type, obj, mLine));
          } else if (obj.push in mLine && mLine[obj.push] != null) {
            mLine[obj.push].forEach(function (el) {
              sdp.push(makeLine(type, obj, el));
            });
          }
        });
      });
    });
    return "".concat(sdp.join('\r\n'), "\r\n");
  }
  function closeMediaStream(stream) {
    if (!stream) {
      return;
    }
    // Latest spec states that MediaStream has no stop() method and instead must
    // call stop() on every MediaStreamTrack.
    try {
      if (stream.getTracks) {
        stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      } else {
        stream.getAudioTracks().forEach(function (track) {
          return track.stop();
        });
        stream.getVideoTracks().forEach(function (track) {
          return track.stop();
        });
      }
    } catch (error) {
      // Deprecated by the spec, but still in use.
      // NOTE: In Temasys IE plugin stream.stop is a callable 'object'.
      if (typeof stream.stop === 'function' || (0, _typeof2.default)(stream.stop) === 'object') {
        stream.stop();
      }
    }
  }
  function setup$1(stream) {
    stream.close = stream.stop = function close() {
      closeMediaStream(this);
    };
    stream.pause = function pause() {
      this.getTracks().forEach(function (track) {
        return track.enabled = false;
      });
    };
    stream.play = function play() {
      this.getTracks().forEach(function (track) {
        return track.enabled = true;
      });
    };
    stream.muteAudio = function muteAudio() {
      var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.getAudioTracks().forEach(function (track) {
        return track.enabled = !mute;
      });
    };
    stream.muteVideo = function muteVideo() {
      var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.getVideoTracks().forEach(function (track) {
        return track.enabled = !mute;
      });
    };
    return stream;
  }
  function getUserMedia(_x32) {
    return _getUserMedia.apply(this, arguments);
  }
  function _getUserMedia() {
    _getUserMedia = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee80(constraints) {
      var stream;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee80$(_context80) {
        while (1) switch (_context80.prev = _context80.next) {
          case 0:
            if (!navigator.mediaDevices.getUserMedia) {
              _context80.next = 6;
              break;
            }
            _context80.next = 3;
            return navigator.mediaDevices.getUserMedia(constraints);
          case 3:
            stream = _context80.sent;
            _context80.next = 13;
            break;
          case 6:
            if (!navigator.getUserMedia) {
              _context80.next = 12;
              break;
            }
            _context80.next = 9;
            return new Promise(function (resolve, reject) {
              navigator.getUserMedia(constraints, resolve, reject);
            });
          case 9:
            stream = _context80.sent;
            _context80.next = 13;
            break;
          case 12:
            throw new Error('Not Supported');
          case 13:
            return _context80.abrupt("return", setup$1(stream));
          case 14:
          case "end":
            return _context80.stop();
        }
      }, _callee80);
    }));
    return _getUserMedia.apply(this, arguments);
  }
  var MAX_ARCHIVE_SIZE = 10;
  function createRTCStats() {
    var quality = -1;
    var inbound = {};
    var outbound = {};
    var archives = [];
    var maxArchiveSize = MAX_ARCHIVE_SIZE;
    var rtcstats;
    function clear() {
      quality = -1;
      inbound = {};
      outbound = {};
      archives = [];
    }
    function update(report) {
      var latestInbound = {};
      var latestOutbound = {};
      var isLegacyStats = false;
      report.forEach(function (stats) {
        if (typeof stats.stat === 'function') {
          isLegacyStats = true;
        }
        switch (stats.type) {
          case 'codec':
            break;
          case 'inbound-rtp':
            if (!stats.isRemote || stats.isRemote === false) {
              /* eslint-disable-next-line no-use-before-define */
              latestInbound[stats.mediaType] = parseRTPStats(report, stats);
            }
            break;
          case 'outbound-rtp':
            if (!stats.isRemote || stats.isRemote === false) {
              /* eslint-disable-next-line no-use-before-define */
              latestOutbound[stats.mediaType] = parseRTPStats(report, stats);
            }
            break;
          // case 'remote-inbound-rtp':
          //   break;
          // case 'remote-outbound-rtp':
          //   break;
          // case 'csrc':
          //   break;
          // case 'peer-connection':
          //   break;
          // case 'data-channel':
          //   break;
          // case 'stream':
          //   break;
          // case 'track':
          //   break;
          // case 'sender':
          //   break;
          // case 'receiver':
          //   break;
          // case 'transport':
          //   break;
          // case 'candidate-pair':
          //   break;
          // case 'local-candidate':
          //   break;
          // case 'remote-candidate':
          //   break;
          // case 'certificate':
          //   break;
          case 'ssrc':
            /* eslint-disable-next-line no-use-before-define */
            parseSSRCStats(report, stats, isLegacyStats);
            if (/recv/g.test(stats.id)) {
              latestInbound[stats.mediaType] = stats;
            }
            if (/send/g.test(stats.id)) {
              latestOutbound[stats.mediaType] = stats;
            }
            break;
        }
      });
      /* eslint-disable-next-line no-use-before-define */
      updateRTPStats(latestInbound.audio, 'inbound');
      /* eslint-disable-next-line no-use-before-define */
      updateRTPStats(latestInbound.video, 'inbound');
      /* eslint-disable-next-line no-use-before-define */
      updateRTPStats(latestOutbound.audio, 'outbound');
      /* eslint-disable-next-line no-use-before-define */
      updateRTPStats(latestOutbound.video, 'outbound');
      var totalPacketsLostRate = 0;
      var totalChannel = 0;
      if (inbound.audio) {
        totalChannel++;
        totalPacketsLostRate += inbound.audio.packetsLostRate || 0;
      }
      if (inbound.video) {
        totalChannel++;
        totalPacketsLostRate += inbound.video.packetsLostRate || 0;
      }
      if (totalChannel) {
        var average = totalPacketsLostRate / totalChannel;
        quality = average >= 12 ? 0 : average >= 5 ? 1 : average >= 3 ? 2 : average >= 2 ? 3 : 4;
      }
      /* eslint-disable-next-line no-use-before-define */
      archive();
    }
    function parseRTPStats(report, stats) {
      var codec = report.get(stats.codecId);
      var track = report.get(stats.trackId);
      var transport = report.get(stats.transportId);
      var remote = report.get(stats.remoteId);
      if (codec) {
        codec.name = codec.mimeType.split('/')[1];
      }
      if (!stats.codecId || !stats.trackId || !stats.transportId) ;
      if (transport) {
        var localCertificate = report.get(transport.localCertificateId);
        var remoteCertificate = report.get(transport.remoteCertificateId);
        var selectedCandidatePair = report.get(transport.selectedCandidatePairId);
        transport.localCertificate = localCertificate;
        transport.remoteCertificate = remoteCertificate;
        transport.selectedCandidatePair = selectedCandidatePair;
      }
      if (remote) {
        stats.packetsLost = remote.packetsLost || stats.packetsLost;
      }
      stats.codec = codec;
      stats.track = track;
      stats.transport = transport;
      return stats;
    }
    function parseSSRCStats(report, stats) {
      var isLegacyStats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (isLegacyStats) {
        stats.mediaType = stats.stat('mediaType');
        stats.googCodecName = stats.stat('googCodecName');
        stats.codecImplementationName = stats.stat('codecImplementationName');
        stats.googFrameHeightReceived = stats.stat('googFrameHeightReceived');
        stats.googFrameHeightSent = stats.stat('googFrameHeightSent');
        stats.googFrameWidthReceived = stats.stat('googFrameWidthReceived');
        stats.googFrameWidthSent = stats.stat('googFrameWidthSent');
        stats.googFrameRateReceived = stats.stat('googFrameRateReceived');
        stats.googFrameRateSent = stats.stat('googFrameRateSent');
        stats.packetsLost = stats.stat('packetsLost');
        stats.packetsSent = stats.stat('packetsSent');
        stats.packetsReceived = stats.stat('packetsReceived');
        stats.bytesSent = stats.stat('bytesSent');
        stats.bytesReceived = stats.stat('bytesReceived');
      }
      var codec = {
        name: stats.googCodecName,
        implementationName: stats.codecImplementationName
      };
      var track = {
        frameHeight: stats.googFrameHeightReceived || stats.googFrameHeightSent,
        frameWidth: stats.googFrameWidthReceived || stats.googFrameWidthSent,
        frameRate: stats.googFrameRateReceived || stats.googFrameRateSent
      };
      stats.codec = codec;
      stats.track = track;
      return stats;
    }
    function updateRTPStats(stats, direction) {
      if (!stats) {
        return;
      }
      var prestats = rtcstats[direction][stats.mediaType];
      var diff = function diff() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var key = arguments.length > 2 ? arguments[2] : undefined;
        if (typeof x[key] !== 'undefined' && typeof y[key] !== 'undefined') {
          return Math.abs(x[key] - y[key]);
        }
        return 0;
      };
      var safe = function safe(x) {
        if (!Number.isFinite(x)) {
          return 0;
        }
        if (Number.isNaN(x)) {
          return 0;
        }
        return x;
      };
      if (prestats) {
        if (prestats.trackId ? Boolean(stats.trackId) : true) {
          var timeDiff = diff(stats, prestats, 'timestamp');
          var valueDiff;
          // calc packetsLostRate
          if (direction === 'outbound' && !stats.packetsLostRate) {
            /* eslint-disable-next-line no-use-before-define */
            var archived = getArchive()[direction][stats.mediaType];
            var lostDiff = diff(stats, archived, 'packetsLost');
            var sentDiff = diff(stats, archived, 'packetsSent');
            var totalPackets = lostDiff + sentDiff;
            stats.packetsLostRate = totalPackets === 0 ? 0 : safe(lostDiff / totalPackets);
            stats.packetsLostRate *= 100;
          }
          if (direction === 'inbound' && !stats.packetsLostRate) {
            /* eslint-disable-next-line no-use-before-define */
            var _archived = getArchive()[direction][stats.mediaType];
            var _lostDiff = diff(stats, _archived, 'packetsLost');
            var receivedDiff = diff(stats, _archived, 'packetsReceived');
            var _totalPackets = _lostDiff + receivedDiff;
            stats.packetsLostRate = _totalPackets === 0 ? 0 : safe(_lostDiff / _totalPackets);
            stats.packetsLostRate *= 100;
          }
          // calc outgoingBitrate
          if (direction === 'outbound' && !stats.outgoingBitrate) {
            valueDiff = diff(stats, prestats, 'bytesSent');
            stats.outgoingBitrate = safe(valueDiff * 8 / timeDiff);
          }
          // calc incomingBitrate
          if (direction === 'inbound' && !stats.incomingBitrate) {
            valueDiff = diff(stats, prestats, 'bytesReceived');
            stats.incomingBitrate = safe(valueDiff * 8 / timeDiff);
          }
          // calc transport outgoingBitrate
          if (stats.transport && prestats.transport && !stats.transport.outgoingBitrate) {
            valueDiff = diff(stats.transport, prestats.transport, 'bytesSent');
            stats.transport.outgoingBitrate = safe(valueDiff * 8 / timeDiff);
          }
          // calc transport incomingBitrate
          if (stats.transport && prestats.transport && !stats.transport.incomingBitrate) {
            valueDiff = diff(stats.transport, prestats.transport, 'bytesReceived');
            stats.transport.incomingBitrate = safe(valueDiff * 8 / timeDiff);
          }
          // calc frameRate
          if (stats.mediaType === 'video' && stats.track && prestats.track && !stats.track.frameRate) {
            if (direction === 'inbound') {
              valueDiff = diff(stats.track, prestats.track, 'framesReceived');
            }
            if (direction === 'outbound') {
              valueDiff = diff(stats.track, prestats.track, 'framesSent');
            }
            stats.track.frameRate = valueDiff ? safe(valueDiff / timeDiff * 1000) : 0;
          }
          rtcstats[direction][stats.mediaType] = stats;
        }
      } else {
        rtcstats[direction][stats.mediaType] = stats;
      }
    }
    function archive() {
      if (archives.length === maxArchiveSize) {
        archives.shift();
      }
      archives.push({
        quality: quality,
        inbound: inbound,
        outbound: outbound
      });
    }
    function getArchive() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _archives = archives,
        length = _archives.length;
      index = Math.max(index, 0);
      index = Math.min(index, length - 1);
      return archives[index];
    }
    return rtcstats = {
      get quality() {
        return quality;
      },
      get inbound() {
        return inbound;
      },
      get outbound() {
        return outbound;
      },
      update: update,
      clear: clear
    };
  }
  var log$m = browser('MN:Channel');
  var browser$2 = getBrowser();
  var STATUS;
  (function (STATUS) {
    STATUS[STATUS["kNull"] = 0] = "kNull";
    STATUS[STATUS["kProgress"] = 1] = "kProgress";
    STATUS[STATUS["kOffered"] = 2] = "kOffered";
    STATUS[STATUS["kAnswered"] = 3] = "kAnswered";
    STATUS[STATUS["kAccepted"] = 4] = "kAccepted";
    STATUS[STATUS["kCanceled"] = 5] = "kCanceled";
    STATUS[STATUS["kTerminated"] = 6] = "kTerminated";
  })(STATUS || (STATUS = {}));
  /**
   * Local variables.
   */
  var holdMediaTypes = ['audio', 'video'];
  function createChannel(config) {
    var invite = config.invite,
      confirm = config.confirm,
      cancel = config.cancel,
      bye = config.bye,
      localstream = config.localstream;
    var events = createEvents(log$m);
    // The RTCPeerConnection instance (public attribute).
    var connection;
    var status = STATUS.kNull;
    var canceled = false;
    var rtcStats = createRTCStats();
    // Default rtcOfferConstraints(passed in connect()).
    var rtcConstraints;
    var rtcOfferConstraints;
    // Local MediaStream.
    var localMediaStream;
    var localMediaStreamLocallyGenerated = false;
    // Flag to indicate PeerConnection ready for new actions.
    var rtcReady = false;
    var startTime;
    var endTime;
    // Mute/Hold state.
    var audioMuted = false;
    var videoMuted = false;
    var localHold = false;
    // there is no in dialog sdp offer, so remote hold is alway false
    var remoteHold = false;
    function throwIfStatus(condition, message) {
      if (status !== condition) {
        return;
      }
      throw new Error(message || 'Invalid State');
    }
    function throwIfTerminated() {
      var message = 'Terminated';
      if (canceled) {
        throw new Error(message);
      }
      throwIfStatus(STATUS.kTerminated, message);
    }
    function isInProgress() {
      switch (status) {
        case STATUS.kProgress:
        case STATUS.kOffered:
        case STATUS.kAnswered:
          return true;
        default:
          return false;
      }
    }
    function isEstablished() {
      return status === STATUS.kAccepted;
    }
    function isEnded() {
      switch (status) {
        case STATUS.kCanceled:
        case STATUS.kTerminated:
          return true;
        default:
          return false;
      }
    }
    function getMute() {
      return {
        audio: audioMuted,
        video: videoMuted
      };
    }
    function getHold() {
      return {
        local: localHold,
        remote: remoteHold
      };
    }
    function createRTCConnection(rtcConstraints) {
      log$m('createRTCConnection()');
      /* tslint:disable */
      connection = new RTCPeerConnection(rtcConstraints);
      connection.addEventListener('iceconnectionstatechange', function () {
        if (!connection) {
          return;
        }
        var _connection = connection,
          state = _connection.iceConnectionState;
        if (state === 'failed') {
          events.emit('peerconnection:connectionfailed');
          /* eslint-disable-next-line no-use-before-define */
          terminate('RTP Timeout');
        }
      });
      events.emit('peerconnection', connection);
    }
    function createLocalDescription(_x33, _x34) {
      return _createLocalDescription.apply(this, arguments);
    }
    function _createLocalDescription() {
      _createLocalDescription = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee43(type, constraints) {
        var desc, sdp;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              log$m('createLocalDescription()');
              rtcReady = false;
              if (!(type === 'offer')) {
                _context43.next = 16;
                break;
              }
              _context43.prev = 3;
              _context43.next = 6;
              return connection.createOffer(constraints);
            case 6:
              desc = _context43.sent;
              _context43.next = 14;
              break;
            case 9:
              _context43.prev = 9;
              _context43.t0 = _context43["catch"](3);
              log$m('createOffer failed: %o', _context43.t0);
              events.emit('peerconnection:createofferfailed', _context43.t0);
              throw _context43.t0;
            case 14:
              _context43.next = 31;
              break;
            case 16:
              if (!(type === 'answer')) {
                _context43.next = 30;
                break;
              }
              _context43.prev = 17;
              _context43.next = 20;
              return connection.createAnswer(constraints);
            case 20:
              desc = _context43.sent;
              _context43.next = 28;
              break;
            case 23:
              _context43.prev = 23;
              _context43.t1 = _context43["catch"](17);
              log$m('createAnswer failed: %o', _context43.t1);
              events.emit('peerconnection:createanswerfailed', _context43.t1);
              throw _context43.t1;
            case 28:
              _context43.next = 31;
              break;
            case 30:
              throw new TypeError('Invalid Type');
            case 31:
              _context43.prev = 31;
              _context43.next = 34;
              return connection.setLocalDescription(desc);
            case 34:
              _context43.next = 42;
              break;
            case 36:
              _context43.prev = 36;
              _context43.t2 = _context43["catch"](31);
              log$m('setLocalDescription failed: %o', _context43.t2);
              rtcReady = true;
              events.emit('peerconnection:setlocaldescriptionfailed', _context43.t2);
              throw _context43.t2;
            case 42:
              _context43.next = 44;
              return new Promise(function (resolve) {
                // When remote fingerprint is changed, setRemoteDescription will not restart ice immediately,
                // and iceGatheringState stay complete for a while.
                // We will get a local sdp without ip candidates, if resolve right away.
                // if (type === 'offer' && connection.iceGatheringState === 'complete')
                // Resolve right away if 'pc.iceGatheringState' is 'complete'.
                if (connection.iceGatheringState === 'complete') {
                  resolve();
                  return;
                }
                var finished = false;
                var listener;
                var ready = function ready() {
                  connection.removeEventListener('icecandidate', listener);
                  finished = true;
                  resolve();
                };
                connection.addEventListener('icecandidate', listener = function listener(event) {
                  var candidate = event.candidate;
                  if (candidate) {
                    events.emit('icecandidate', {
                      candidate: candidate,
                      ready: ready
                    });
                  } else if (!finished) {
                    ready();
                  }
                });
              });
            case 44:
              rtcReady = true;
              sdp = connection.localDescription.sdp;
              desc = {
                originator: 'local',
                type: type,
                sdp: sdp
              };
              events.emit('sdp', desc);
              return _context43.abrupt("return", desc.sdp);
            case 49:
            case "end":
              return _context43.stop();
          }
        }, _callee43, null, [[3, 9], [17, 23], [31, 36]]);
      }));
      return _createLocalDescription.apply(this, arguments);
    }
    function connect() {
      return _connect.apply(this, arguments);
    }
    function _connect() {
      _connect = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee44() {
        var options,
          _options$rtcConstrain,
          _options$rtcOfferCons,
          mediaStream,
          _options$mediaConstra,
          mediaConstraints,
          localSDP,
          answer,
          _answer,
          remoteSDP,
          desc,
          offer,
          _args44 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              options = _args44.length > 0 && _args44[0] !== undefined ? _args44[0] : {};
              log$m('connect()');
              throwIfStatus(STATUS.kProgress);
              throwIfStatus(STATUS.kOffered);
              throwIfStatus(STATUS.kAnswered);
              throwIfStatus(STATUS.kAccepted);
              if (window.RTCPeerConnection) {
                _context44.next = 8;
                break;
              }
              throw new Error('WebRTC not supported');
            case 8:
              status = STATUS.kProgress;
              /* eslint-disable-next-line no-use-before-define */
              onProgress('local');
              events.emit('connecting');
              _options$rtcConstrain = options.rtcConstraints;
              rtcConstraints = _options$rtcConstrain === void 0 ? {
                sdpSemantics: 'plan-b',
                iceServers: [{
                  urls: 'stun:stun.l.google.com:19302'
                }]
              } : _options$rtcConstrain;
              _options$rtcOfferCons = options.rtcOfferConstraints;
              rtcOfferConstraints = _options$rtcOfferCons === void 0 ? {
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
              } : _options$rtcOfferCons;
              mediaStream = options.mediaStream, _options$mediaConstra = options.mediaConstraints, mediaConstraints = _options$mediaConstra === void 0 ? {
                audio: true,
                video: true
              } : _options$mediaConstra;
              createRTCConnection(rtcConstraints);
              if (!mediaStream) {
                _context44.next = 22;
                break;
              }
              localMediaStream = mediaStream;
              localMediaStreamLocallyGenerated = false;
              _context44.next = 27;
              break;
            case 22:
              if (!(mediaConstraints.audio || mediaConstraints.video)) {
                _context44.next = 27;
                break;
              }
              _context44.next = 25;
              return getUserMedia(mediaConstraints).catch(function (error) {
                /* eslint-disable-next-line no-use-before-define */
                onFailed('local', 'User Denied Media Access');
                log$m('getusermedia failed: %o', error);
                throw error;
              });
            case 25:
              localMediaStream = _context44.sent;
              localMediaStreamLocallyGenerated = true;
            case 27:
              throwIfTerminated();
              if (!localMediaStream) {
                _context44.next = 37;
                break;
              }
              localMediaStream.getTracks().forEach(function (track) {
                connection.addTrack(track, localMediaStream);
              });
              _context44.prev = 30;
              _context44.next = 33;
              return localstream(localMediaStream);
            case 33:
              _context44.next = 37;
              break;
            case 35:
              _context44.prev = 35;
              _context44.t0 = _context44["catch"](30);
            case 37:
              _context44.next = 39;
              return createLocalDescription('offer', rtcOfferConstraints).catch(function (error) {
                /* eslint-disable-next-line no-use-before-define */
                onFailed('local', 'WebRTC Error');
                log$m('createOff|setLocalDescription failed: %o', error);
                throw error;
              });
            case 39:
              localSDP = _context44.sent;
              throwIfTerminated();
              status = STATUS.kOffered;
              _context44.prev = 42;
              _context44.next = 45;
              return invite({
                sdp: localSDP,
                renegotiate: false
              });
            case 45:
              answer = _context44.sent;
              _context44.next = 53;
              break;
            case 48:
              _context44.prev = 48;
              _context44.t1 = _context44["catch"](42);
              /* eslint-disable-next-line no-use-before-define */
              onFailed('local', 'Request Error');
              log$m('invite failed: %o', _context44.t1);
              throw _context44.t1;
            case 53:
              throwIfTerminated();
              status = STATUS.kAnswered;
              _answer = answer, remoteSDP = _answer.sdp;
              desc = {
                originator: 'remote',
                type: 'answer',
                sdp: remoteSDP
              };
              events.emit('sdp', desc);
              if (!(connection.signalingState === 'stable')) {
                _context44.next = 74;
                break;
              }
              _context44.prev = 59;
              _context44.next = 62;
              return connection.createOffer();
            case 62:
              offer = _context44.sent;
              _context44.next = 65;
              return connection.setLocalDescription(offer);
            case 65:
              _context44.next = 74;
              break;
            case 67:
              _context44.prev = 67;
              _context44.t2 = _context44["catch"](59);
              /* eslint-disable-next-line no-use-before-define */
              onFailed('local', 'WebRTC Error');
              log$m('createOff|setLocalDescription failed: %o', _context44.t2);
              _context44.next = 73;
              return bye();
            case 73:
              throw _context44.t2;
            case 74:
              _context44.prev = 74;
              _context44.next = 77;
              return connection.setRemoteDescription({
                type: 'answer',
                sdp: desc.sdp
              });
            case 77:
              _context44.next = 87;
              break;
            case 79:
              _context44.prev = 79;
              _context44.t3 = _context44["catch"](74);
              /* eslint-disable-next-line no-use-before-define */
              onFailed('remote', 'Bad Media Description');
              events.emit('peerconnection:setremotedescriptionfailed', _context44.t3);
              log$m('setRemoteDescription failed: %o', _context44.t3);
              _context44.next = 86;
              return bye();
            case 86:
              throw _context44.t3;
            case 87:
              _context44.prev = 87;
              _context44.next = 90;
              return confirm();
            case 90:
              _context44.next = 97;
              break;
            case 92:
              _context44.prev = 92;
              _context44.t4 = _context44["catch"](87);
              /* eslint-disable-next-line no-use-before-define */
              onFailed('local', 'Request Error');
              log$m('confirm failed: %o', _context44.t4);
              throw _context44.t4;
            case 97:
              status = STATUS.kAccepted;
              /* eslint-disable-next-line no-use-before-define */
              onAccepted('local');
              events.emit('connected');
            case 100:
            case "end":
              return _context44.stop();
          }
        }, _callee44, null, [[30, 35], [42, 48], [59, 67], [74, 79], [87, 92]]);
      }));
      return _connect.apply(this, arguments);
    }
    function terminate(_x35) {
      return _terminate.apply(this, arguments);
    }
    function _terminate() {
      _terminate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee45(reason) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              log$m('terminate()');
              _context45.t0 = status;
              _context45.next = _context45.t0 === STATUS.kNull ? 4 : _context45.t0 === STATUS.kTerminated ? 4 : _context45.t0 === STATUS.kProgress ? 5 : _context45.t0 === STATUS.kOffered ? 5 : _context45.t0 === STATUS.kAnswered ? 15 : _context45.t0 === STATUS.kAccepted ? 15 : 19;
              break;
            case 4:
              return _context45.abrupt("break", 19);
            case 5:
              log$m('canceling channel');
              if (!(status === STATUS.kOffered)) {
                _context45.next = 11;
                break;
              }
              _context45.next = 9;
              return cancel(reason);
            case 9:
              _context45.next = 12;
              break;
            case 11:
              canceled = true;
            case 12:
              status = STATUS.kCanceled;
              /* eslint-disable-next-line no-use-before-define */
              onFailed('local', reason || 'Canceled');
              return _context45.abrupt("break", 19);
            case 15:
              _context45.next = 17;
              return bye(reason);
            case 17:
              /* eslint-disable-next-line no-use-before-define */
              onEnded('local', reason || 'Terminated');
              return _context45.abrupt("break", 19);
            case 19:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      }));
      return _terminate.apply(this, arguments);
    }
    function close() {
      log$m('close()');
      if (status === STATUS.kTerminated) {
        return;
      }
      if (connection) {
        try {
          connection.close();
          connection = undefined;
        } catch (error) {
          log$m('error closing RTCPeerConnection %o', error);
        }
      }
      /* eslint-disable-next-line no-use-before-define */
      maybeCloseLocalMediaStream();
      localMediaStream = undefined;
      localMediaStreamLocallyGenerated = false;
      rtcStats.clear();
      status = STATUS.kTerminated;
    }
    function toggleMuteAudio(mute) {
      connection.getSenders().forEach(function (sender) {
        if (sender.track && sender.track.kind === 'audio') {
          sender.track.enabled = !mute;
        }
      });
    }
    function toggleMuteVideo(mute) {
      connection.getSenders().forEach(function (sender) {
        if (sender.track && sender.track.kind === 'video') {
          sender.track.enabled = !mute;
        }
      });
    }
    function setLocalMediaStatus() {
      var enableAudio = true;
      var enableVideo = true;
      if (localHold || remoteHold) {
        enableAudio = false;
        enableVideo = false;
      }
      if (audioMuted) {
        enableAudio = false;
      }
      if (videoMuted) {
        enableVideo = false;
      }
      toggleMuteAudio(!enableAudio);
      toggleMuteVideo(!enableVideo);
    }
    function maybeCloseLocalMediaStream() {
      if (localMediaStream && localMediaStreamLocallyGenerated) {
        closeMediaStream(localMediaStream);
        localMediaStream = undefined;
        localMediaStreamLocallyGenerated = false;
      }
    }
    function onProgress(originator, message) {
      log$m('channel progress');
      events.emit('progress', {
        originator: originator,
        message: message
      });
    }
    function onAccepted(originator, message) {
      log$m('channel accepted');
      events.emit('accepted', {
        originator: originator,
        message: message
      });
      startTime = new Date();
    }
    function onEnded(originator, message) {
      log$m('channel ended');
      endTime = new Date();
      close();
      events.emit('ended', {
        originator: originator,
        message: message
      });
    }
    function onFailed(originator, message) {
      log$m('channel failed');
      close();
      events.emit('failed', {
        originator: originator,
        message: message
      });
    }
    function onMute() {
      setLocalMediaStatus();
      events.emit('mute', {
        audio: audioMuted,
        video: videoMuted
      });
    }
    function onUnMute() {
      setLocalMediaStatus();
      events.emit('unmute', {
        audio: !audioMuted,
        video: !videoMuted
      });
    }
    function onHold(originator) {
      setLocalMediaStatus();
      events.emit('hold', {
        originator: originator,
        localHold: localHold,
        remoteHold: remoteHold
      });
    }
    function onUnHold(originator) {
      setLocalMediaStatus();
      events.emit('unhold', {
        originator: originator,
        localHold: localHold,
        remoteHold: remoteHold
      });
    }
    function mute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        audio: true,
        video: false
      };
      log$m('mute()');
      var changed = false;
      if (audioMuted === false && options.audio) {
        changed = true;
        audioMuted = true;
      }
      if (videoMuted === false && options.video) {
        changed = true;
        videoMuted = true;
      }
      if (changed) {
        onMute();
      }
    }
    function unmute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        audio: true,
        video: true
      };
      log$m('unmute()');
      var changed = false;
      if (audioMuted === true && options.audio) {
        changed = true;
        audioMuted = false;
      }
      if (videoMuted === true && options.video) {
        changed = true;
        videoMuted = false;
      }
      if (changed) {
        onUnMute();
      }
    }
    function hold() {
      return _hold3.apply(this, arguments);
    }
    function _hold3() {
      _hold3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee46() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              log$m('unhold()');
              if (!localHold) {
                _context46.next = 4;
                break;
              }
              log$m('Already hold');
              return _context46.abrupt("return");
            case 4:
              localHold = true;
              onHold('local');
              /* eslint-disable-next-line no-use-before-define */
              _context46.next = 8;
              return renegotiate();
            case 8:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      }));
      return _hold3.apply(this, arguments);
    }
    function unhold() {
      return _unhold3.apply(this, arguments);
    }
    function _unhold3() {
      _unhold3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee47() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              log$m('unhold()');
              if (localHold) {
                _context47.next = 4;
                break;
              }
              log$m('Already unhold');
              return _context47.abrupt("return");
            case 4:
              localHold = false;
              onUnHold('local');
              /* eslint-disable-next-line no-use-before-define */
              _context47.next = 8;
              return renegotiate();
            case 8:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      }));
      return _unhold3.apply(this, arguments);
    }
    function renegotiate() {
      return _renegotiate.apply(this, arguments);
    }
    function _renegotiate() {
      _renegotiate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee48() {
        var options,
          localSDP,
          answer,
          desc,
          _args48 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              options = _args48.length > 0 && _args48[0] !== undefined ? _args48[0] : {};
              log$m('renegotiate()');
              if (rtcReady) {
                _context48.next = 5;
                break;
              }
              log$m('RTC not ready');
              return _context48.abrupt("return");
            case 5:
              _context48.next = 7;
              return createLocalDescription('offer', rtcOfferConstraints);
            case 7:
              localSDP = _context48.sent;
              _context48.next = 10;
              return invite({
                sdp: mangleOffer(localSDP),
                renegotiate: true
              });
            case 10:
              answer = _context48.sent;
              desc = {
                originator: 'remote',
                type: 'answer',
                sdp: answer.sdp
              };
              events.emit('sdp', desc);
              _context48.prev = 13;
              connection.setRemoteDescription({
                type: 'answer',
                sdp: desc.sdp
              });
              _context48.next = 21;
              break;
            case 17:
              _context48.prev = 17;
              _context48.t0 = _context48["catch"](13);
              events.emit('peerconnection:setremotedescriptionfailed', _context48.t0);
              throw _context48.t0;
            case 21:
              _context48.prev = 21;
              _context48.next = 24;
              return confirm();
            case 24:
              _context48.next = 31;
              break;
            case 26:
              _context48.prev = 26;
              _context48.t1 = _context48["catch"](21);
              /* eslint-disable-next-line no-use-before-define */
              onFailed('local', 'Request Error');
              log$m('confirm failed: %o', _context48.t1);
              throw _context48.t1;
            case 31:
            case "end":
              return _context48.stop();
          }
        }, _callee48, null, [[13, 17], [21, 26]]);
      }));
      return _renegotiate.apply(this, arguments);
    }
    function mangleOffer(offer) {
      log$m('mangleOffer()');
      // nothing to do
      if (!localHold && !remoteHold) {
        return offer;
      }
      var sdp = parse$1(offer);
      // Local hold.
      if (localHold && !remoteHold) {
        var _iterator3 = (0, _createForOfIteratorHelper2.default)(sdp.media),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _m = _step3.value;
            if (holdMediaTypes.indexOf(_m.type) === -1) {
              continue;
            }
            if (!_m.direction) {
              _m.direction = 'sendonly';
            } else if (_m.direction === 'sendrecv') {
              _m.direction = 'sendonly';
            } else if (_m.direction === 'recvonly') {
              _m.direction = 'inactive';
            }
          }
          // Local and remote hold.
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else if (localHold && remoteHold) {
        var _iterator4 = (0, _createForOfIteratorHelper2.default)(sdp.media),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _m2 = _step4.value;
            if (holdMediaTypes.indexOf(_m2.type) === -1) {
              continue;
            }
            _m2.direction = 'inactive';
          }
          // Remote hold.
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      return write(sdp);
    }
    function getRemoteStream() {
      log$m('getRemoteStream()');
      var stream;
      // @ts-ignore
      if (connection.getReceivers) {
        stream = new window.MediaStream();
        connection.getReceivers().forEach(function (receiver) {
          var track = receiver.track;
          if (track) {
            stream.addTrack(track);
          }
        });
      } else if (connection.getRemoteStreams) {
        stream = connection.getRemoteStreams()[0];
      }
      return stream;
    }
    function getLocalStream() {
      log$m('getLocalStream()');
      var stream;
      // @ts-ignore
      if (connection.getSenders) {
        stream = new window.MediaStream();
        connection.getSenders().forEach(function (sender) {
          var track = sender.track;
          if (track) {
            stream.addTrack(track);
          }
        });
      } else if (connection.getLocalStreams) {
        stream = connection.getLocalStreams()[0];
      }
      return stream;
    }
    function addLocalStream(stream) {
      log$m('addLocalStream()');
      if (!stream) {
        return;
      }
      // @ts-ignore
      if (connection.addTrack) {
        stream.getTracks().forEach(function (track) {
          connection.addTrack(track, stream);
        });
      } else if (connection.addStream) {
        connection.addStream(stream);
      }
    }
    function removeLocalStream() {
      log$m('removeLocalStream()');
      if (connection.getSenders && connection.removeTrack) {
        connection.getSenders().forEach(function (sender) {
          connection.removeTrack(sender);
        });
      } else if (connection.getLocalStreams && connection.removeStream) {
        connection.getLocalStreams().forEach(function (stream) {
          connection.removeStream(stream);
        });
      }
    }
    function replaceLocalStream(_x36) {
      return _replaceLocalStream.apply(this, arguments);
    }
    function _replaceLocalStream() {
      _replaceLocalStream = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee51(stream) {
        var renegotiation,
          audioTrack,
          videoTrack,
          queue,
          renegotiationNeeded,
          peerHasAudio,
          peerHasVideo,
          shimReplaceTrack,
          _args51 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              shimReplaceTrack = function _shimReplaceTrack(sender) {
                sender.replaceTrack = /*#__PURE__*/function () {
                  var _replaceTrack = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee49(newTrack) {
                    var offer;
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee49$(_context49) {
                      while (1) switch (_context49.prev = _context49.next) {
                        case 0:
                          connection.removeTrack(sender);
                          connection.addTrack(newTrack, stream);
                          _context49.next = 4;
                          return connection.createOffer();
                        case 4:
                          offer = _context49.sent;
                          offer.type = connection.localDescription.type;
                          /* eslint-disable-next-line no-use-before-define */
                          offer.sdp = replaceSSRCs(connection.localDescription.sdp, offer.sdp);
                          _context49.next = 9;
                          return connection.setLocalDescription(offer);
                        case 9:
                          _context49.next = 11;
                          return connection.setRemoteDescription(connection.remoteDescription);
                        case 11:
                        case "end":
                          return _context49.stop();
                      }
                    }, _callee49);
                  }));
                  function replaceTrack(_x39) {
                    return _replaceTrack.apply(this, arguments);
                  }
                  return replaceTrack;
                }();
              };
              renegotiation = _args51.length > 1 && _args51[1] !== undefined ? _args51[1] : false;
              log$m('replaceLocalStream()');
              audioTrack = stream ? stream.getAudioTracks()[0] : null;
              videoTrack = stream ? stream.getVideoTracks()[0] : null;
              queue = [];
              renegotiationNeeded = false;
              peerHasAudio = false;
              peerHasVideo = false; // @ts-ignore
              if (connection.getSenders) {
                connection.getSenders().forEach(function (sender) {
                  if (!sender.track) {
                    return;
                  }
                  peerHasAudio = sender.track.kind === 'audio' || peerHasAudio;
                  peerHasVideo = sender.track.kind === 'video' || peerHasVideo;
                });
                renegotiationNeeded = Boolean(audioTrack) !== peerHasAudio || Boolean(videoTrack) !== peerHasVideo || renegotiation;
                /* eslint-disable-next-line no-use-before-define */
                maybeCloseLocalMediaStream();
                if (renegotiationNeeded) {
                  removeLocalStream();
                  addLocalStream(stream);
                  queue.push(renegotiate());
                } else {
                  connection.getSenders().forEach(function (sender) {
                    if (!sender.track) {
                      return;
                    }
                    if (!sender.replaceTrack && !(sender.prototype && sender.prototype.replaceTrack)) {
                      /* eslint-disable-next-line no-use-before-define */
                      shimReplaceTrack(sender);
                    }
                    if (audioTrack && sender.track.kind === 'audio') {
                      queue.push(sender.replaceTrack(audioTrack).catch(function (e) {
                        log$m('replace audio track error: %o', e);
                      }));
                    }
                    if (videoTrack && sender.track.kind === 'video') {
                      queue.push(sender.replaceTrack(videoTrack).catch(function (e) {
                        log$m('replace video track error: %o', e);
                      }));
                    }
                  });
                }
              }
              _context51.next = 12;
              return Promise.all(queue).finally( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee50() {
                return (0, _regeneratorRuntime2.default)().wrap(function _callee50$(_context50) {
                  while (1) switch (_context50.prev = _context50.next) {
                    case 0:
                      localMediaStream = getLocalStream();
                      localMediaStreamLocallyGenerated = false;
                    case 2:
                    case "end":
                      return _context50.stop();
                  }
                }, _callee50);
              })));
            case 12:
              _context51.prev = 12;
              _context51.next = 15;
              return localstream(localMediaStream);
            case 15:
              _context51.next = 19;
              break;
            case 17:
              _context51.prev = 17;
              _context51.t0 = _context51["catch"](12);
            case 19:
            case "end":
              return _context51.stop();
          }
        }, _callee51, null, [[12, 17]]);
      }));
      return _replaceLocalStream.apply(this, arguments);
    }
    function replaceSSRCs(currentDescription, newDescription) {
      var ssrcs = currentDescription.match(/a=ssrc-group:FID (\d+) (\d+)\r\n/);
      var newssrcs = newDescription.match(/a=ssrc-group:FID (\d+) (\d+)\r\n/);
      if (!ssrcs) {
        // Firefox offers wont have FID yet
        ssrcs = currentDescription.match(/a=ssrc:(\d+) cname:(.*)\r\n/g)[1].match(/a=ssrc:(\d+)/);
        newssrcs = newDescription.match(/a=ssrc:(\d+) cname:(.*)\r\n/g)[1].match(/a=ssrc:(\d+)/);
      }
      for (var i = 1; i < ssrcs.length; i++) {
        newDescription = newDescription.replace(new RegExp(newssrcs[i], 'g'), ssrcs[i]);
      }
      return newDescription;
    }
    function adjustBandWidth(_x37) {
      return _adjustBandWidth.apply(this, arguments);
    }
    function _adjustBandWidth() {
      _adjustBandWidth = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee52(options) {
        var audio, video, queue;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              log$m('adjustBandWidth()');
              audio = options.audio, video = options.video;
              queue = [];
              if ('RTCRtpSender' in window && 'setParameters' in window.RTCRtpSender.prototype) {
                connection.getSenders().forEach(function (sender) {
                  if (sender.track) {
                    return;
                  }
                  var parameters = sender.getParameters();
                  if (typeof audio !== 'undefined' && sender.track.kind === 'audio') {
                    if (audio === 0) {
                      delete parameters.encodings[0].maxBitrate;
                    } else {
                      parameters.encodings[0].maxBitrate = audio * 1024;
                    }
                    queue.push(sender.setParameters(parameters).catch(function (e) {
                      log$m('apply audio parameters error: %o', e);
                    }));
                  }
                  if (typeof video !== 'undefined' && sender.track.kind === 'video') {
                    if (video === 0) {
                      delete parameters.encodings[0].maxBitrate;
                    } else {
                      parameters.encodings[0].maxBitrate = video * 1024;
                    }
                    queue.push(sender.setParameters(parameters).catch(function (e) {
                      log$m('apply video parameters error: %o', e);
                    }));
                  }
                });
              } else {
                // Fallback to the SDP munging with local renegotiation way of limiting
                // the bandwidth.
                queue.push(connection.createOffer().then(function (offer) {
                  return connection.setLocalDescription(offer);
                }).then(function () {
                  var sdp = parse$1(connection.remoteDescription.sdp);
                  var _iterator5 = (0, _createForOfIteratorHelper2.default)(sdp.media),
                    _step5;
                  try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      var _m3 = _step5.value;
                      if (typeof audio !== 'undefined' && _m3.type === 'audio') {
                        if (audio === 0) {
                          _m3.bandwidth = [];
                        } else {
                          _m3.bandwidth = [{
                            type: 'TIAS',
                            limit: Math.ceil(audio * 1024)
                          }];
                        }
                      }
                      if (typeof video !== 'undefined' && _m3.type === 'video') {
                        if (video === 0) {
                          _m3.bandwidth = [];
                        } else {
                          _m3.bandwidth = [{
                            type: 'TIAS',
                            limit: Math.ceil(video * 1024)
                          }];
                        }
                      }
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                  var desc = {
                    type: connection.remoteDescription.type,
                    sdp: write(sdp)
                  };
                  return connection.setRemoteDescription(desc);
                }).catch(function (e) {
                  log$m('applying bandwidth restriction to setRemoteDescription error: %o', e);
                }));
              }
              _context52.next = 6;
              return Promise.all(queue);
            case 6:
            case "end":
              return _context52.stop();
          }
        }, _callee52);
      }));
      return _adjustBandWidth.apply(this, arguments);
    }
    function applyConstraints(_x38) {
      return _applyConstraints.apply(this, arguments);
    }
    function _applyConstraints() {
      _applyConstraints = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee53(options) {
        var audio, video, queue;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              log$m('applyConstraints()');
              audio = options.audio, video = options.video;
              queue = [];
              if (connection.getSenders && window.MediaStreamTrack.prototype.applyConstraints) {
                connection.getSenders().forEach(function (sender) {
                  if (audio && sender.track && sender.track.kind === 'audio') {
                    queue.push(sender.track.applyConstraints(audio).catch(function (e) {
                      log$m('apply audio constraints error: %o', e);
                    }));
                  }
                  if (video && sender.track && sender.track.kind === 'video') {
                    queue.push(sender.track.applyConstraints(video).catch(function (e) {
                      log$m('apply video constraints error: %o', e);
                    }));
                  }
                });
              }
              _context53.next = 6;
              return Promise.all(queue);
            case 6:
            case "end":
              return _context53.stop();
          }
        }, _callee53);
      }));
      return _applyConstraints.apply(this, arguments);
    }
    function getStats() {
      return _getStats2.apply(this, arguments);
    }
    function _getStats2() {
      _getStats2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee54() {
        var stats;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              log$m('getStats()');
              if (!(connection.signalingState === 'stable')) {
                _context54.next = 14;
                break;
              }
              if (!browser$2.chrome) {
                _context54.next = 8;
                break;
              }
              _context54.next = 5;
              return new Promise(function (resolve) {
                connection.getStats(function (stats) {
                  resolve(stats.result());
                });
              });
            case 5:
              stats = _context54.sent;
              _context54.next = 11;
              break;
            case 8:
              _context54.next = 10;
              return connection.getStats();
            case 10:
              stats = _context54.sent;
            case 11:
              rtcStats.update(stats);
              _context54.next = 15;
              break;
            case 14:
              log$m('update rtc stats failed since connection is unstable.');
            case 15:
              return _context54.abrupt("return", rtcStats);
            case 16:
            case "end":
              return _context54.stop();
          }
        }, _callee54);
      }));
      return _getStats2.apply(this, arguments);
    }
    var getConnectOptions = function getConnectOptions() {
      return {
        rtcConstraints: rtcConstraints,
        rtcOfferConstraints: rtcOfferConstraints,
        localMediaStream: localMediaStream,
        localMediaStreamLocallyGenerated: localMediaStreamLocallyGenerated
      };
    };
    return Object.spread({}, events, {
      get status() {
        return status;
      },
      get connection() {
        return connection;
      },
      get startTime() {
        return startTime;
      },
      get endTime() {
        return endTime;
      },
      getConnectOptions: getConnectOptions,
      isInProgress: isInProgress,
      isEstablished: isEstablished,
      isEnded: isEnded,
      getMute: getMute,
      getHold: getHold,
      connect: connect,
      terminate: terminate,
      renegotiate: renegotiate,
      mute: mute,
      unmute: unmute,
      hold: hold,
      unhold: unhold,
      getRemoteStream: getRemoteStream,
      getLocalStream: getLocalStream,
      replaceLocalStream: replaceLocalStream,
      adjustBandWidth: adjustBandWidth,
      applyConstraints: applyConstraints,
      getStats: getStats
    });
  }
  var log$n = browser('MN:SDP');
  var browser$3 = getBrowser();
  function createModifier() {
    var _content = 'main';
    var _width = 1920;
    var _height = 1080;
    var _frameRate = 30;
    var _highFrameRate = false;
    var _prefer;
    var _unsupport;
    var modifier;
    function build() {
      return function (data) {
        var originator = data.originator,
          type = data.type;
        var sdp = parse$1(data.sdp);
        var maxWidth = _width;
        var maxHeight = _height;
        var maxFrameRate = _frameRate;
        var maxFrameSize = Math.ceil(maxWidth * maxHeight / 255);
        var maxMbps = Math.ceil(maxFrameRate * maxFrameSize);
        var bandwidth = maxHeight >= 1080 ? 2048 : maxHeight >= 720 ? 1280 : maxHeight >= 360 ? 512 : 512;
        bandwidth = Math.ceil(bandwidth * maxFrameRate / 30); // calc frameRate ratio
        // process sdp
        var _iterator6 = (0, _createForOfIteratorHelper2.default)(sdp.media),
          _step6;
        try {
          var _loop3 = function _loop3() {
            var m = _step6.value;
            /*
            m.candidates = m.candidates.filter((c) =>
            {
              return c.component === 1;
            });
            */
            if (m.type === 'video') {
              m.content = _content;
              m.bandwidth = [{
                type: 'TIAS',
                limit: Math.ceil(bandwidth * 1024)
              }];
              var vp8Payloads = new Set();
              var h264Payloads = new Set();
              var vp8Config = ["max-fr=".concat(maxFrameRate), "max-fs=".concat(maxFrameSize)];
              var h264Config = ["max-mbps=".concat(maxMbps), "max-fs=".concat(maxFrameSize)];
              // find codec payload
              var _iterator7 = (0, _createForOfIteratorHelper2.default)(m.rtp),
                _step7;
              try {
                var _loop4 = function _loop4() {
                  var r = _step7.value;
                  var codec = r.codec.toUpperCase();
                  var fmtp;
                  switch (codec) {
                    case 'VP8':
                    case 'VP9':
                      vp8Payloads.add(Number(r.payload));
                      fmtp = m.fmtp.find(function (f) {
                        return f.payload === r.payload;
                      });
                      if (fmtp) {
                        fmtp.config = fmtp.config.split(';').filter(function (p) {
                          return !(/^max-fr/.test(p) || /^max-fs/.test(p));
                        }).concat(vp8Config).join(';');
                      } else {
                        m.fmtp.push({
                          payload: r.payload,
                          config: vp8Config.join(';')
                        });
                      }
                      break;
                    case 'H264':
                      h264Payloads.add(Number(r.payload));
                      fmtp = m.fmtp.find(function (f) {
                        return f.payload === r.payload;
                      });
                      if (fmtp) {
                        if (_highFrameRate && fmtp.config.indexOf('profile-level-id=42e01f') !== -1 && originator === 'local' && type === 'offer') {
                          fmtp.config = fmtp.config.split(';').filter(function (p) {
                            return !(/^max-mbps/.test(p) || /^max-fs/.test(p) || /^profile-level-id/.test(p));
                          }).concat(['profile-level-id=64001f']).concat(h264Config).join(';');
                        } else if (_highFrameRate && fmtp.config.indexOf('profile-level-id=64001f') !== -1 && originator === 'remote' && type === 'answer') {
                          fmtp.config = fmtp.config.split(';').filter(function (p) {
                            return !(/^max-mbps/.test(p) || /^max-fs/.test(p) || /^profile-level-id/.test(p));
                          }).concat(['profile-level-id=42e01f']).concat(h264Config).join(';');
                        } else {
                          fmtp.config = fmtp.config.split(';').filter(function (p) {
                            return !(/^max-mbps/.test(p) || /^max-fs/.test(p));
                          }).concat(h264Config).join(';');
                        }
                      } else {
                        m.fmtp.push({
                          payload: r.payload,
                          config: h264Config.join(';')
                        });
                      }
                      break;
                  }
                };
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  _loop4();
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              var _iterator8 = (0, _createForOfIteratorHelper2.default)(m.fmtp),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var f = _step8.value;
                  var aptConfig = f.config.split(';').find(function (p) {
                    return /^apt=/.test(p);
                  });
                  if (!aptConfig) {
                    continue;
                  }
                  var apt = aptConfig.split('=')[1];
                  if (vp8Payloads.has(Number(apt))) {
                    vp8Payloads.add(Number(f.payload));
                  } else if (h264Payloads.has(Number(apt))) {
                    h264Payloads.add(Number(f.payload));
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              var preferCodec = _prefer === 'vp8' ? vp8Payloads : _prefer === 'h264' ? h264Payloads : new Set();
              var unsupportCodec = _unsupport === 'vp8' ? vp8Payloads : _unsupport === 'h264' ? h264Payloads : new Set();
              // firefox do not support multiple h264 codec/decode insts
              // when content sharing or using multiple tab, codec/decode might be error.
              // and chrome ver58 has a really low resolution in h264 codec when content sharing.
              // use VP8/VP9 first
              if (browser$3.firefox || browser$3.chrome && parseInt(browser$3.version, 10) < 63 && _content === 'slides') {
                preferCodec = vp8Payloads;
              }
              if (!preferCodec.size || !unsupportCodec.size) {
                var payloads = String(m.payloads).split(' ');
                payloads = payloads.filter(function (p) {
                  return !preferCodec.has(Number(p));
                });
                payloads = payloads.filter(function (p) {
                  return !unsupportCodec.has(Number(p));
                });
                payloads = Array.from(preferCodec).sort(function (x, y) {
                  return x - y;
                }).concat(payloads);
                m.rtp = m.rtp.filter(function (r) {
                  return !unsupportCodec.has(Number(r.payload));
                });
                m.fmtp = m.fmtp.filter(function (r) {
                  return !unsupportCodec.has(Number(r.payload));
                });
                var rtps = [];
                var fmtps = [];
                payloads.forEach(function (p) {
                  var rtp = m.rtp.find(function (r) {
                    return r.payload === Number(p);
                  });
                  var fmtp = m.fmtp.find(function (f) {
                    return f.payload === Number(p);
                  });
                  if (rtp) {
                    rtps.push(rtp);
                  }
                  if (fmtp) {
                    fmtps.push(fmtp);
                  }
                });
                m.rtp = rtps;
                m.fmtp = fmtps;
                m.payloads = payloads.join(' ');
              }
            }
            if (m.type === 'audio') {
              m.bandwidth = [{
                type: 'TIAS',
                limit: Math.ceil(128 * 1024)
              }];
            }
          };
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
          // filter out unsupported application media
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        sdp.media = sdp.media.filter(function (m) {
          return m.type !== 'application' || /TLS/.test(m.protocol);
        });
        if (originator === 'remote') {
          sdp.media.forEach(function (m) {
            var payloads = String(m.payloads).split(' ');
            if (m.rtcpFb) {
              var rtcpFb = [];
              m.rtcpFb.forEach(function (fb) {
                if (fb.payload === '*' || payloads.includes("".concat(fb.payload))) {
                  rtcpFb.push(fb);
                }
              });
              m.rtcpFb = rtcpFb;
            }
            if (m.fmtp) {
              var fmtp = [];
              m.fmtp.forEach(function (fm) {
                if (fm.payload === '*' || payloads.includes("".concat(fm.payload))) {
                  fmtp.push(fm);
                }
              });
              m.fmtp = fmtp;
            }
            if (m.rtp) {
              var rtp = [];
              m.rtp.forEach(function (r) {
                if (r.payload === '*' || payloads.includes("".concat(r.payload))) {
                  rtp.push(r);
                }
              });
              m.rtp = rtp;
            }
          });
          if (type === 'offer' && browser$3.firefox) {
            sdp.media.forEach(function (m) {
              if (m.mid === undefined) {
                m.mid = m.type === 'audio' ? 0 : m.type === 'video' ? 1 : m.mid;
              }
            });
          }
        }
        data.sdp = write(sdp);
        log$n("".concat(originator, " sdp: \n\n %s \n"), data.sdp);
      };
    }
    return modifier = {
      content: function content(val) {
        _content = val;
        return modifier;
      },
      width: function width(val) {
        _width = val;
        return modifier;
      },
      height: function height(val) {
        _height = val;
        return modifier;
      },
      frameRate: function frameRate(val) {
        _frameRate = val;
        return modifier;
      },
      highFrameRate: function highFrameRate(val) {
        _highFrameRate = val;
        return modifier;
      },
      prefer: function prefer(val) {
        _prefer = val;
        return modifier;
      },
      unsupport: function unsupport(val) {
        _unsupport = val;
        return modifier;
      },
      build: build
    };
  }
  var log$o = browser('MN:MediaChannel');
  function createMediaChannel(config) {
    var api = config.api,
      _config$type = config.type,
      type = _config$type === void 0 ? 'main' : _config$type;
    var mediaVersion;
    var callId;
    var request;
    var icetimmeout;
    var _localstream;
    var remotestream;
    var channel = createChannel({
      invite: function () {
        var _invite2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee55(offer) {
          var sdp, apiName, response, _response$data$data, _response$data$data$m, _response$data$data$m2;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee55$(_context55) {
            while (1) switch (_context55.prev = _context55.next) {
              case 0:
                log$o('invite()');
                sdp = offer.sdp;
                apiName = offer.renegotiate ? type === 'main' ? 'renegMedia' : 'renegShare' : type === 'main' ? 'joinMedia' : 'joinShare';
                request = api.request(apiName).data({
                  sdp: sdp,
                  'media-version': mediaVersion
                });
                _context55.next = 6;
                return request.send();
              case 6:
                response = _context55.sent;
                _response$data$data = response.data.data;
                sdp = _response$data$data.sdp;
                _response$data$data$m = _response$data$data['media-version'];
                mediaVersion = _response$data$data$m === void 0 ? mediaVersion : _response$data$data$m;
                _response$data$data$m2 = _response$data$data['mcu-callid'];
                callId = _response$data$data$m2 === void 0 ? callId : _response$data$data$m2;
                log$o('MCU call-id: %s', callId);
                return _context55.abrupt("return", {
                  sdp: sdp
                });
              case 15:
              case "end":
                return _context55.stop();
            }
          }, _callee55);
        }));
        function invite(_x40) {
          return _invite2.apply(this, arguments);
        }
        return invite;
      }(),
      confirm: function confirm() {
        log$o('confirm()');
        request = undefined;
        // send confirm
      },

      cancel: function cancel() {
        log$o('cancel()');
        request && request.cancel();
        request = undefined;
        mediaVersion = undefined;
      },
      bye: function bye() {
        log$o('bye()');
        request = undefined;
        mediaVersion = undefined;
      },
      localstream: function localstream(stream) {
        _localstream = stream;
        channel.emit('localstream', _localstream);
      }
    });
    channel.on('sdp', function (data) {
      if (data.originator === 'local') {
        createModifier().content(type).prefer('h264').build()(data);
        return;
      }
      log$o("".concat(data.originator, " sdp: \n\n %s \n"), data.sdp);
    });
    channel.on('peerconnection', function (pc) {
      pc.addEventListener('connectionstatechange', function () {
        log$o('peerconnection:connectionstatechange : %s', pc.connectionState);
      });
      pc.addEventListener('iceconnectionstatechange', function () {
        log$o('peerconnection:iceconnectionstatechange : %s', pc.iceConnectionState);
      });
      pc.addEventListener('icegatheringstatechange', function () {
        log$o('peerconnection:icegatheringstatechange : %s', pc.iceGatheringState);
      });
      pc.addEventListener('negotiationneeded', function () {
        log$o('peerconnection:negotiationneeded');
        channel.emit('negotiationneeded');
      });
      pc.addEventListener('track', function (event) {
        log$o('peerconnection:track: %o', event);
        remotestream = event.streams[0];
        channel.emit('remotestream', remotestream);
      });
      // for old browser(firefox)
      pc.addEventListener('addstream', function (event) {
        log$o('peerconnection:addstream: %o', event);
        remotestream = event.stream;
        channel.emit('remotestream', remotestream);
      });
      pc.addEventListener('removestream', function (event) {
        log$o('peerconnection:removestream: %o', event);
        remotestream = channel.getRemoteStream();
        channel.emit('removestream', remotestream);
      });
    });
    channel.on('icecandidate', function (data) {
      var candidate = data.candidate,
        ready = data.ready;
      if (icetimmeout) {
        clearTimeout(icetimmeout);
        icetimmeout = undefined;
      }
      if (candidate) {
        icetimmeout = setTimeout(function () {
          log$o('ICE gathering timeout in 3 seconds');
          ready();
        }, 3000);
      }
    });
    return Object.spread({}, channel, {
      get status() {
        return channel.status;
      },
      get connection() {
        return channel.connection;
      },
      get startTime() {
        return channel.startTime;
      },
      get endTime() {
        return channel.endTime;
      },
      get version() {
        return mediaVersion;
      },
      get callId() {
        return callId;
      }
    });
  }
  var MessageStatus;
  (function (MessageStatus) {
    MessageStatus[MessageStatus["kNull"] = 0] = "kNull";
    MessageStatus[MessageStatus["kSending"] = 1] = "kSending";
    MessageStatus[MessageStatus["kSuccess"] = 2] = "kSuccess";
    MessageStatus[MessageStatus["kFailed"] = 3] = "kFailed";
  })(MessageStatus || (MessageStatus = {}));
  var log$p = browser('MN:Message');
  function createMessage(config) {
    var api = config.api;
    var events = createEvents(log$p);
    var status = MessageStatus.kNull;
    var direction = 'outgoing';
    var timestamp;
    var version;
    /* eslint-disable-next-line prefer-destructuring */
    var content = config.content;
    /* eslint-disable-next-line prefer-destructuring */
    var sender = config.sender;
    var receiver;
    var isPrivate = false;
    var message;
    var request;
    function send(_x41) {
      return _send.apply(this, arguments);
    }
    function _send() {
      _send = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee56(target) {
        var response, _response, data, _data$data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              log$p('send()');
              if (!(direction === 'incoming')) {
                _context56.next = 3;
                break;
              }
              throw new Error('Invalid Status');
            case 3:
              status = MessageStatus.kSending;
              events.emit('sending', message);
              request = api.request('pushMessage').data({
                'im-context': message.content,
                'user-entity-list': target
              });
              _context56.prev = 6;
              _context56.next = 9;
              return request.send();
            case 9:
              response = _context56.sent;
              _context56.next = 17;
              break;
            case 12:
              _context56.prev = 12;
              _context56.t0 = _context56["catch"](6);
              status = MessageStatus.kFailed;
              events.emit('failed', message);
              throw _context56.t0;
            case 17:
              _response = response, data = _response.data;
              receiver = target;
              _data$data = data.data;
              version = _data$data['im-version'];
              timestamp = _data$data['im-timestamp'];
              status = MessageStatus.kSuccess;
              events.emit('succeeded', message);
            case 24:
            case "end":
              return _context56.stop();
          }
        }, _callee56, null, [[6, 12]]);
      }));
      return _send.apply(this, arguments);
    }
    function retry() {
      return _retry.apply(this, arguments);
    }
    function _retry() {
      _retry = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee57() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              log$p('retry()');
              if (content) {
                _context57.next = 3;
                break;
              }
              throw new Error('Invalid Message');
            case 3:
              _context57.next = 5;
              return send(receiver);
            case 5:
            case "end":
              return _context57.stop();
          }
        }, _callee57);
      }));
      return _retry.apply(this, arguments);
    }
    function cancel() {
      log$p('cancel()');
      if (request) {
        request.cancel();
        request = undefined;
      }
    }
    function incoming(data) {
      direction = 'incoming';
      content = data['im-context'];
      timestamp = data['im-timestamp'];
      version = data['im-version'];
      isPrivate = data['is-private'];
      sender = {
        entity: data['sender-entity'],
        subjectId: data['sender-subject-id'],
        displayText: data['sender-display-text']
      };
      return message;
    }
    return message = Object.spread({}, events, {
      get status() {
        return status;
      },
      get direction() {
        return direction;
      },
      get content() {
        return content;
      },
      get timestamp() {
        return timestamp;
      },
      get version() {
        return version;
      },
      get sender() {
        return sender;
      },
      get receiver() {
        return receiver;
      },
      get private() {
        return receiver && receiver.length > 0 || isPrivate;
      },
      send: send,
      retry: retry,
      cancel: cancel,
      incoming: incoming
    });
  }
  var log$q = browser('MN:ChatChannel');
  function createChatChannel(config) {
    var api = config.api,
      sender = config.sender;
    var events = createEvents(log$q);
    var messages = [];
    var request;
    var ready = false;
    function connect() {
      return _connect2.apply(this, arguments);
    }
    function _connect2() {
      _connect2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee58() {
        var count,
          response,
          data,
          _args58 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              count = _args58.length > 0 && _args58[0] !== undefined ? _args58[0] : 2000;
              log$q('connect()');
              if (!ready) {
                _context58.next = 4;
                break;
              }
              return _context58.abrupt("return");
            case 4:
              request = api.request('pullMessage').data({
                count: count
              });
              _context58.next = 7;
              return request.send();
            case 7:
              response = _context58.sent;
              data = response.data.data;
              messages = data.imInfos.map(function (msg) {
                return createMessage({
                  api: api
                }).incoming(msg);
              });
              ready = true;
              events.emit('ready');
              events.emit('connected');
            case 13:
            case "end":
              return _context58.stop();
          }
        }, _callee58);
      }));
      return _connect2.apply(this, arguments);
    }
    function terminate() {
      return _terminate2.apply(this, arguments);
    }
    function _terminate2() {
      _terminate2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee59() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              log$q('terminate()');
              messages = [];
              ready = false;
              if (request) {
                request.cancel();
                request = undefined;
              }
              events.emit('disconnected');
            case 5:
            case "end":
              return _context59.stop();
          }
        }, _callee59);
      }));
      return _terminate2.apply(this, arguments);
    }
    function sendMessage(_x42, _x43) {
      return _sendMessage2.apply(this, arguments);
    }
    function _sendMessage2() {
      _sendMessage2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee60(content, target) {
        var message;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              log$q('sendMessage()');
              message = createMessage({
                api: api,
                content: content,
                sender: sender
              });
              events.emit('message', {
                originator: 'local',
                message: message
              });
              _context60.next = 5;
              return message.send(target);
            case 5:
              messages.push(message);
              return _context60.abrupt("return", message);
            case 7:
            case "end":
              return _context60.stop();
          }
        }, _callee60);
      }));
      return _sendMessage2.apply(this, arguments);
    }
    function incoming(data) {
      log$q('incoming()');
      var message = createMessage({
        api: api
      }).incoming(data);
      events.emit('message', {
        originator: 'remote',
        message: message
      });
      messages.push(message);
      return message;
    }
    return Object.spread({}, events, {
      get ready() {
        return ready;
      },
      get messages() {
        return messages;
      },
      connect: connect,
      terminate: terminate,
      sendMessage: sendMessage,
      incoming: incoming
    });
  }
  var log$r = browser('MN:Conference');
  var miniprogram = isMiniProgram();
  var browser$4 = getBrowser();
  var STATUS$1;
  (function (STATUS) {
    STATUS[STATUS["kNull"] = 0] = "kNull";
    STATUS[STATUS["kConnecting"] = 1] = "kConnecting";
    STATUS[STATUS["kConnected"] = 2] = "kConnected";
    STATUS[STATUS["kDisconnecting"] = 3] = "kDisconnecting";
    STATUS[STATUS["kDisconnected"] = 4] = "kDisconnected";
  })(STATUS$1 || (STATUS$1 = {}));
  function createConference(config) {
    var api = config.api;
    var events = createEvents(log$r);
    var keepalive;
    var polling;
    var information;
    var interceptor;
    var conference;
    var mediaChannel;
    var shareChannel;
    var chatChannel;
    var user; // current user
    var status = STATUS$1.kNull;
    var uuid;
    var userId; // as conference entity
    var url;
    var request; // request chain
    var trtc;
    function getCurrentUser() {
      if (!user) {
        // try to get current user
        user = information.users.getCurrent();
        if (user) {
          events.emit('user', user);
          /* eslint-disable-next-line no-use-before-define */
          user.on('holdChanged', maybeChat);
        }
      }
      return user;
    }
    function throwIfStatus(condition, message) {
      if (status !== condition) {
        return;
      }
      throw new Error(message || 'Invalid State');
    }
    function throwIfNotStatus(condition, message) {
      if (status === condition) {
        return;
      }
      throw new Error(message || 'Invalid State');
    }
    function onConnecting() {
      log$r('conference connecting');
      status = STATUS$1.kConnecting;
      events.emit('connecting');
    }
    function onConnected() {
      log$r('conference connected');
      /* eslint-disable-next-line no-use-before-define */
      setup();
      status = STATUS$1.kConnected;
      events.emit('connected');
    }
    function onDisconnecting() {
      log$r('conference disconnecting');
      status = STATUS$1.kDisconnecting;
      events.emit('disconnecting');
    }
    function onDisconnected(data) {
      log$r('conference disconnected');
      /* eslint-disable-next-line no-use-before-define */
      cleanup();
      status = STATUS$1.kDisconnected;
      events.emit('disconnected', data);
    }
    function onAccepted() {
      log$r('conference accepted');
      events.emit('accepted');
    }
    function maybeChat() {
      return _maybeChat.apply(this, arguments);
    }
    function _maybeChat() {
      _maybeChat = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee61() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              if (chatChannel) {
                _context61.next = 2;
                break;
              }
              return _context61.abrupt("return");
            case 2:
              if (!chatChannel.ready) {
                _context61.next = 4;
                break;
              }
              return _context61.abrupt("return");
            case 4:
              _context61.next = 6;
              return chatChannel.connect().catch(function () {});
            case 6:
            case "end":
              return _context61.stop();
          }
        }, _callee61);
      }));
      return _maybeChat.apply(this, arguments);
    }
    function retryChannel(_x44) {
      return _retryChannel.apply(this, arguments);
    }
    function _retryChannel() {
      _retryChannel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee62(channel) {
        var _channel$getConnectOp, localMediaStream, rtcConstraints, rtcOfferConstraints;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee62$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              if (!(status !== STATUS$1.kConnected)) {
                _context62.next = 3;
                break;
              }
              log$r('retry channel in wrong conference status: %s', status);
              return _context62.abrupt("return");
            case 3:
              _channel$getConnectOp = channel.getConnectOptions(), localMediaStream = _channel$getConnectOp.localMediaStream, rtcConstraints = _channel$getConnectOp.rtcConstraints, rtcOfferConstraints = _channel$getConnectOp.rtcOfferConstraints;
              _context62.next = 6;
              return channel.terminate('Retry');
            case 6:
              _context62.next = 8;
              return channel.connect({
                rtcConstraints: rtcConstraints,
                rtcOfferConstraints: rtcOfferConstraints,
                mediaStream: localMediaStream,
                mediaConstraints: {
                  audio: false,
                  video: false
                }
              });
            case 8:
            case "end":
              return _context62.stop();
          }
        }, _callee62);
      }));
      return _retryChannel.apply(this, arguments);
    }
    function join() {
      return _join.apply(this, arguments);
    }
    function _join() {
      _join = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee63() {
        var options,
          response,
          data,
          hasMedia,
          _response2,
          useragent,
          clientinfo,
          apiName,
          _response3,
          _data$data2,
          _response4,
          info,
          context,
          _args63 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              options = _args63.length > 0 && _args63[0] !== undefined ? _args63[0] : {};
              log$r('join()');
              throwIfNotStatus(STATUS$1.kNull);
              if (!(!options.url && !options.number)) {
                _context63.next = 5;
                break;
              }
              throw new TypeError('Invalid Number');
            case 5:
              status = STATUS$1.kConnecting;
              onConnecting();
              hasMedia = true;
              if (!(!options.url && options.number)) {
                _context63.next = 16;
                break;
              }
              request = api.request('getURL').data({
                'long-number': options.number
              });
              _context63.next = 12;
              return request.send();
            case 12:
              response = _context63.sent;
              _response2 = response;
              data = _response2.data;
              options.url = data.data.url;
            case 16:
              useragent = CONFIG.get('useragent', "Yealink ".concat(miniprogram ? 'WECHAT' : 'WEB-APP', " ", "1.0.4"));
              clientinfo = CONFIG.get('clientinfo', "".concat(miniprogram ? 'Apollo_WeChat' : 'Apollo_WebRTC', " ", "1.0.4")); // join focus
              apiName = miniprogram ? 'joinWechat' : 'joinFocus';
              request = api.request(apiName).data({
                // 'conference-uuid'     : null,
                // 'conference-user-id'  : null,
                'conference-url': options.url,
                'conference-pwd': options.password,
                'user-agent': useragent,
                'client-url': options.url.replace(/\w+@/g, miniprogram ? 'wechat@' : 'webrtc@'),
                'client-display-text': options.displayName || "".concat(browser$4),
                'client-type': 'http',
                'client-info': clientinfo,
                'pure-ctrl-channel': !hasMedia,
                // if join with media
                'is-webrtc': !miniprogram && hasMedia,
                'is-wechat': miniprogram,
                'video-session-info': miniprogram && {
                  bitrate: 600 * 1024,
                  'video-width': 640,
                  'video-height': 360,
                  'frame-rate': 15
                }
              });
              _context63.prev = 20;
              _context63.next = 23;
              return request.send();
            case 23:
              response = _context63.sent;
              _context63.next = 30;
              break;
            case 26:
              _context63.prev = 26;
              _context63.t0 = _context63["catch"](20);
              events.emit('failed', _context63.t0);
              throw _context63.t0;
            case 30:
              _response3 = response;
              data = _response3.data;
              _data$data2 = data.data;
              userId = _data$data2['conference-user-id'];
              uuid = _data$data2['conference-uuid'];
              trtc = miniprogram ? data.data : {};
              onAccepted();
              if (!(!userId || !uuid)) {
                _context63.next = 40;
                break;
              }
              log$r('internal error');
              throw new Error('Internal Error');
            case 40:
              url = options.url;
              // setup request interceptor for ctrl api
              interceptor = api.interceptors.request.use(function (config) {
                if (/conference-ctrl/.test(config.url) && config.method === 'post') {
                  config.data = Object.spread({}, {
                    'conference-user-id': userId,
                    'conference-uuid': uuid
                  }, config.data);
                }
                return config;
              });
              // get full info
              request = api.request('getFullInfo');
              _context63.prev = 43;
              _context63.next = 46;
              return request.send();
            case 46:
              response = _context63.sent;
              _context63.next = 53;
              break;
            case 49:
              _context63.prev = 49;
              _context63.t1 = _context63["catch"](43);
              events.emit('failed', _context63.t1);
              throw _context63.t1;
            case 53:
              _response4 = response;
              data = _response4.data;
              info = data.data; // create context
              context = createContext(conference); // create information
              information = createInformation(info, context);
              onConnected();
              return _context63.abrupt("return", conference);
            case 60:
            case "end":
              return _context63.stop();
          }
        }, _callee63, null, [[20, 26], [43, 49]]);
      }));
      return _join.apply(this, arguments);
    }
    function leave() {
      return _leave.apply(this, arguments);
    }
    function _leave() {
      _leave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee64() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              throwIfStatus(STATUS$1.kDisconnecting);
              throwIfStatus(STATUS$1.kDisconnected);
              _context64.t0 = status;
              _context64.next = _context64.t0 === STATUS$1.kNull ? 5 : _context64.t0 === STATUS$1.kConnecting ? 6 : _context64.t0 === STATUS$1.kConnected ? 6 : _context64.t0 === STATUS$1.kDisconnecting ? 15 : _context64.t0 === STATUS$1.kDisconnected ? 15 : 15;
              break;
            case 5:
              return _context64.abrupt("break", 15);
            case 6:
              if (!(status === STATUS$1.kConnected)) {
                _context64.next = 13;
                break;
              }
              onDisconnecting();
              _context64.next = 10;
              return api.request('leave').send().catch(function (error) {
                log$r('leave error: ', error);
              });
            case 10:
              onDisconnected();
              _context64.next = 14;
              break;
            case 13:
              if (request) {
                request.cancel();
                onDisconnected();
              }
            case 14:
              return _context64.abrupt("break", 15);
            case 15:
              return _context64.abrupt("return", conference);
            case 16:
            case "end":
              return _context64.stop();
          }
        }, _callee64);
      }));
      return _leave.apply(this, arguments);
    }
    function end() {
      return _end.apply(this, arguments);
    }
    function _end() {
      _end = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee65() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee65$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              throwIfNotStatus(STATUS$1.kConnected);
              _context65.next = 3;
              return Promise.all([leave(), api.request('end').data({
                'conference-url': url
              }).send()]);
            case 3:
              return _context65.abrupt("return", conference);
            case 4:
            case "end":
              return _context65.stop();
          }
        }, _callee65);
      }));
      return _end.apply(this, arguments);
    }
    function setup() {
      getCurrentUser();
      var _information = information,
        state = _information.state,
        users = _information.users;
      state.on('sharingUserEntityChanged', function (val) {
        // in some cases, eg. whitebord sharing
        // sharing use entity is an new unique id, which can not be finded in user list
        // use the second param the help making sharing detection strategy
        // 1. no user & no entity => no sharing
        // 2. no user & has entity => sharing(whitebord)
        // 3. has user => sharing
        events.emit('sharinguser', users.getUser(val), val);
      });
      state.on('speechUserEntityChanged', function (val) {
        // just in case, for the same reason with sharing use entity
        events.emit('speechuser', users.getUser(val), val);
      });
      users.on('user:added', function () {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        return events.emit.apply(events, ['user:added'].concat(args));
      });
      users.on('user:updated', function () {
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }
        return events.emit.apply(events, ['user:updated'].concat(args));
      });
      users.on('user:deleted', function () {
        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }
        return events.emit.apply(events, ['user:deleted'].concat(args));
      });
      // create keepalive worker
      keepalive = createKeepAlive({
        api: api
      });
      // create polling worker
      polling = createPolling({
        api: api,
        onInformation: function onInformation(data) {
          log$r('receive information: %o', data);
          information.update(data);
          events.emit('information', information);
          getCurrentUser();
        },
        onMessage: function onMessage(data) {
          log$r('receive message: %o', data);
          chatChannel.incoming(data);
        },
        onCallRecord: function onCallRecord(data) {
          log$r('receive callRecord: %o', data);
          events.emit('callrecord', data);
        },
        onRenegotiate: function onRenegotiate(data) {
          log$r('receive renegotiate: %o', data);
          retryChannel(mediaChannel);
          retryChannel(shareChannel);
        },
        onQuit: function onQuit(data) {
          log$r('receive quit: %o', data);
          if (status === STATUS$1.kDisconnecting || status === STATUS$1.kDisconnected) {
            log$r('receive quit while disconnecting, ignore it');
            return;
          }
          // bizCode = 901314 ended by presenter
          // bizCode = 901320 kicked by presenter
          onDisconnected(data);
        },
        onError: function onError(data) {
          log$r('polling error: %o', data);
          if (status === STATUS$1.kDisconnecting || status === STATUS$1.kDisconnected) {
            log$r('polling error while disconnecting, ignore it');
            return;
          }
          if (data.message === 'Network Error') {
            log$r('polling error while network error');
            return;
          }
          events.emit('error', data);
          // there are some problems with polling
          // leave conference
          //
          onDisconnected(data);
        }
      });
      // start keepalive & polling
      keepalive.start();
      polling.start();
      // create channels
      mediaChannel = createMediaChannel({
        api: api,
        type: 'main'
      });
      shareChannel = createMediaChannel({
        api: api,
        type: 'slides'
      });
      chatChannel = createChatChannel({
        api: api
      });
      chatChannel.on('message', function () {
        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }
        return events.emit.apply(events, ['message'].concat(args));
      });
      chatChannel.on('ready', function () {
        for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          args[_key9] = arguments[_key9];
        }
        return events.emit.apply(events, ['chatready'].concat(args));
      });
      maybeChat();
    }
    function cleanup() {
      if (keepalive) {
        keepalive.stop();
      }
      if (polling) {
        polling.stop();
      }
      if (interceptor) {
        api.interceptors.request.eject(interceptor);
      }
      if (mediaChannel) {
        mediaChannel.terminate();
      }
      if (shareChannel) {
        shareChannel.terminate();
      }
      if (chatChannel) {
        chatChannel.terminate();
      }
      request = undefined;
    }
    function share(_x45) {
      return _share.apply(this, arguments);
    }
    function _share() {
      _share = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee66(options) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              throwIfNotStatus(STATUS$1.kConnected);
              if (!(!shareChannel.isInProgress() && !shareChannel.isEstablished())) {
                _context66.next = 4;
                break;
              }
              _context66.next = 4;
              return shareChannel.connect(options);
            case 4:
              _context66.next = 6;
              return api.request('switchShare').data({
                share: true
              }).send();
            case 6:
            case "end":
              return _context66.stop();
          }
        }, _callee66);
      }));
      return _share.apply(this, arguments);
    }
    function setSharing() {
      return _setSharing.apply(this, arguments);
    }
    function _setSharing() {
      _setSharing = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee67() {
        var enable,
          _args67 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee67$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              enable = _args67.length > 0 && _args67[0] !== undefined ? _args67[0] : true;
              throwIfNotStatus(STATUS$1.kConnected);
              _context67.next = 4;
              return api.request('switchShare').data({
                share: enable
              }).send();
            case 4:
            case "end":
              return _context67.stop();
          }
        }, _callee67);
      }));
      return _setSharing.apply(this, arguments);
    }
    function sendMessage(_x46, _x47) {
      return _sendMessage3.apply(this, arguments);
    }
    function _sendMessage3() {
      _sendMessage3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee68(msg, target) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee68$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              throwIfNotStatus(STATUS$1.kConnected);
              if (!(!chatChannel || !chatChannel.ready)) {
                _context68.next = 3;
                break;
              }
              throw new Error('Not Ready');
            case 3:
              _context68.next = 5;
              return chatChannel.sendMessage(msg, target);
            case 5:
            case "end":
              return _context68.stop();
          }
        }, _callee68);
      }));
      return _sendMessage3.apply(this, arguments);
    }
    return conference = Object.spread({}, events, {
      get api() {
        return api;
      },
      get url() {
        return url;
      },
      get uuid() {
        return uuid;
      },
      // in conference info
      // user entity is string type
      // while we may receive number type
      // cast to string type
      get userId() {
        return "".concat(userId);
      },
      get user() {
        return user;
      },
      get information() {
        return information;
      },
      get description() {
        return information && information.description;
      },
      get state() {
        return information && information.state;
      },
      get view() {
        return information && information.view;
      },
      get users() {
        return information && information.users;
      },
      get rtmp() {
        return information && information.rtmp;
      },
      get record() {
        return information && information.record;
      },
      get mediaChannel() {
        return mediaChannel;
      },
      get shareChannel() {
        return shareChannel;
      },
      get chatChannel() {
        return chatChannel;
      },
      get trtc() {
        return trtc;
      },
      join: join,
      leave: leave,
      end: end,
      share: share,
      setSharing: setSharing,
      sendMessage: sendMessage
    });
  }
  var log$s = browser('MN:UA');
  function createUA() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var auth = config.auth;
    var api;
    if (auth) {
      var _auth = auth;
      api = _auth.api;
    }
    // fetch conference basic info
    function fetch(_x48) {
      return _fetch.apply(this, arguments);
    }
    function _fetch() {
      _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee69(number) {
        var response, data, info, partyId, url, _response5, _data$data3, _response6, _response7;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              log$s('fetch()');
              if (!api) {
                api = createUserApi();
              }
              // get conference url
              _context69.next = 4;
              return api.request('getURL').data({
                'long-number': number
              }).send();
            case 4:
              response = _context69.sent;
              _response5 = response;
              data = _response5.data;
              _data$data3 = data.data;
              partyId = _data$data3['party-id'];
              url = _data$data3.url;
              _context69.prev = 10;
              _context69.next = 13;
              return api.request('getBasicInfo').data({
                'conference-url': url
              }).send();
            case 13:
              response = _context69.sent;
              _response6 = response;
              data = _response6.data;
              info = data.data;
              _context69.next = 34;
              break;
            case 19:
              _context69.prev = 19;
              _context69.t0 = _context69["catch"](10);
              log$s('Conference not started.');
              _context69.prev = 22;
              _context69.next = 25;
              return api.request('getBasicInfoOffline').data({
                'long-number': number
              }).send();
            case 25:
              response = _context69.sent;
              _response7 = response;
              data = _response7.data;
              info = data.data;
              _context69.next = 34;
              break;
            case 31:
              _context69.prev = 31;
              _context69.t1 = _context69["catch"](22);
              log$s('Conference not exist.');
            case 34:
              if (info) {
                _context69.next = 36;
                break;
              }
              throw new Error('Not Exist');
            case 36:
              return _context69.abrupt("return", {
                partyId: partyId,
                number: number,
                url: url,
                info: info
              });
            case 37:
            case "end":
              return _context69.stop();
          }
        }, _callee69, null, [[10, 19], [22, 31]]);
      }));
      return _fetch.apply(this, arguments);
    }
    function connect(_x49) {
      return _connect3.apply(this, arguments);
    }
    function _connect3() {
      _connect3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee70(options) {
        var partyId, url, number, response, data, _data$data4, isTempAuthLocallyGenerated, _auth2, conference, join;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              log$s('connect()');
              // create user api
              if (!api) {
                api = createUserApi();
              }
              if (options.number) {
                _context70.next = 4;
                break;
              }
              throw new TypeError('Invalid Number');
            case 4:
              number = options.number; // get conference url
              _context70.next = 7;
              return api.request('getURL').data({
                'long-number': number
              }).send();
            case 7:
              response = _context70.sent;
              data = response.data;
              /* eslint-disable-next-line prefer-const */
              _data$data4 = data.data;
              partyId = _data$data4['party-id'];
              url = _data$data4.url;
              if (partyId) {
                _context70.next = 14;
                break;
              }
              throw new TypeError('Invalid Number');
            case 14:
              isTempAuthLocallyGenerated = false; // temp auth
              if (!(!auth || !auth.token)) {
                _context70.next = 22;
                break;
              }
              _context70.next = 18;
              return createTempAuth(partyId);
            case 18:
              auth = _context70.sent;
              _auth2 = auth;
              api = _auth2.api;
              isTempAuthLocallyGenerated = true;
            case 22:
              // create stand alone user api for conference.
              // auth is required
              conference = createConference({
                api: api
              }); // hack join method
              join = conference.join;
              conference.join = function (additional) {
                return join(Object.spread({}, {
                  url: url
                }, options, additional));
              };
              if (isTempAuthLocallyGenerated) {
                conference.once('disconnected', auth.invalid);
              }
              return _context70.abrupt("return", conference);
            case 27:
            case "end":
              return _context70.stop();
          }
        }, _callee70);
      }));
      return _connect3.apply(this, arguments);
    }
    return {
      fetch: fetch,
      connect: connect
    };
  }
  {
    polyfill();
  }
  var log$t = browser('MN');
  var version = "1.0.4";
  // global setup
  function setup$2(config) {
    setupConfig(config);
    if (isMiniProgram()) {
      axios$1.defaults.adapter = mpAdapter;
    }
    browser.enable(CONFIG.get('debug', 'MN*,-MN:Api*,-MN:Information:Item,-MN:Worker'));
    log$t('setup() [version]: %s', version);
  }
  function connect(_x50) {
    return _connect4.apply(this, arguments);
  }
  function _connect4() {
    _connect4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee81(options) {
      var ua, conference;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee81$(_context81) {
        while (1) switch (_context81.prev = _context81.next) {
          case 0:
            ua = createUA();
            _context81.next = 3;
            return ua.connect(options);
          case 3:
            conference = _context81.sent;
            return _context81.abrupt("return", conference);
          case 5:
          case "end":
            return _context81.stop();
        }
      }, _callee81);
    }));
    return _connect4.apply(this, arguments);
  }
  exports.adapter = mpAdapter;
  exports.axios = axios$1;
  exports.bootstrap = bootstrap;
  exports.connect = connect;
  exports.createUA = createUA;
  exports.createUserApi = createUserApi;
  exports.debug = browser;
  exports.fetchControlUrl = fetchControlUrl;
  exports.setup = setup$2;
  exports.version = version;
  return exports;
}({});